import React, { Component } from "react";
import {
  View,
  Image,
  Text,
  SafeAreaView,
  TouchableOpacity,
  ActivityIndicator,
  StatusBar,
  Dimensions,
  Linking,
  Alert,
  BackHandler,
  ScrollView,
  Platform,
  ImageBackground,
} from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { SvgCss } from "react-native-svg";
import { WebView } from "react-native-webview"
import LocationPopup from "../shared/LocationPopup";
import BOGuide from "../shared/Guide/BOGuide";

import * as Font from "expo-font";
import {
  MaterialCommunityIcons,
  FontAwesome,
  Entypo,
} from "@expo/vector-icons";

//import { Notifications } from "expo";
//import * as Permissions from 'expo-permissions';
import firebase from "firebase";
import "firebase/firestore";
import Constants from "expo-constants";
import initiateGlobalFunctions from "../shared/globalFunctions";
//import CategorySelectorMarket from "./V1CategorySelector";
//import CategorySelectorArtisan from "./V1CategorySelectorArtisan";
//import CategorySelectorEducation from "./V1CategorySelectorEducation";
import Search from "./Find/V2Search";
import Post from "./Post/Post";
import * as Find from "./Find/findFunctions";
import Moment from "react-moment";
import { NavigationEvents } from "react-navigation";
import RecommendedOffer from "./Apps/shared/RecommendedOffer";
import CachedImage from "../shared/CachedImage";
import BlogPreview from "./Apps/shared/BlogPreview";
import NewsTicker from "./Apps/News/NewsTicker"

global.icons = {
  Electronics: {
    bgcolor: "#4DC5E2",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="87.911" height="75.88" viewBox="0 0 87.911 75.88"><defs><style>.a{fill:#2b84e9;}.b{fill:#363c44;}.c{fill:#292e33;}.d{fill:#555e6b;}.e{fill:#49bc6e;}.f{fill:#2676c6;}.g{fill:#434b56;}.h{fill:#ffe92f;}.i{fill:#2e343a;}.j{fill:#96abbc;}.k{fill:#ff7b05;}.l{fill:#707d8c;}</style></defs><g transform="translate(0 -10.265)"><g transform="translate(0 10.265)"><path class="a" d="M90.547,72.364H23.039a4.881,4.881,0,0,1-4.881-4.881V23.765a4.881,4.881,0,0,1,4.881-4.881H90.546a4.881,4.881,0,0,1,4.881,4.881V67.484A4.881,4.881,0,0,1,90.547,72.364Z" transform="translate(-7.516 -13.832)"/><rect class="b" width="14.794" height="12.806" transform="translate(41.88 58.101)"/><g transform="translate(41.88 58.101)"><rect class="c" width="14.794" height="3.424"/><rect class="c" width="14.794" height="2.418" transform="translate(0 9.955)"/></g><path class="d" d="M18.158,94.633a4.881,4.881,0,0,0,4.881,4.881H90.546a4.881,4.881,0,0,0,4.881-4.881V84.474H18.158Z" transform="translate(-7.516 -40.982)"/><circle class="e" cx="1.335" cy="1.335" r="1.335" transform="translate(79.826 49.469)"/><path class="f" d="M41.844,18.884H23.328a4.881,4.881,0,0,0-4.881,4.881V67.483a4.881,4.881,0,0,0,4.881,4.881H41.844V18.884Z" transform="translate(-7.636 -13.832)"/><g transform="translate(70.276 49.469)"><circle class="e" cx="1.335" cy="1.335" r="1.335" transform="translate(4.744)"/><circle class="e" cx="1.335" cy="1.335" r="1.335"/></g><path class="g" d="M18.447,84.474V94.633a4.881,4.881,0,0,0,4.881,4.881H41.844V84.474h-23.4Z" transform="translate(-7.636 -40.982)"/><path class="d" d="M26.759,86.144H2.252A2.252,2.252,0,0,1,0,83.892V12.517a2.252,2.252,0,0,1,2.252-2.252H26.759a2.252,2.252,0,0,1,2.252,2.252V83.892A2.252,2.252,0,0,1,26.759,86.144Z" transform="translate(0 -10.265)"/><path class="b" d="M87.632,135.918H61.04a.5.5,0,0,1-.5-.5v-2.13a2.775,2.775,0,0,1,2.775-2.775H85.356a2.775,2.775,0,0,1,2.775,2.775v2.13A.5.5,0,0,1,87.632,135.918Z" transform="translate(-25.059 -60.038)"/><circle class="h" cx="2.607" cy="2.607" r="2.607" transform="translate(46.67 47.9)"/><g transform="translate(0 37.94)"><path class="i" d="M8.556,98.449,5.232,81.832a1.632,1.632,0,0,0-.326-.7L0,75v34.2l8.184-9.36A1.632,1.632,0,0,0,8.556,98.449Z" transform="translate(0 -75)"/><path class="i" d="M34.88,98.449,38.2,81.832a1.632,1.632,0,0,1,.326-.7L43.435,75v34.2l-8.184-9.36A1.632,1.632,0,0,1,34.88,98.449Z" transform="translate(-14.424 -75)"/></g><g transform="translate(6.941 69.325)"><path class="j" d="M16.329,131.221H13.178a1.335,1.335,0,1,1,0-2.669h3.151a1.335,1.335,0,0,1,0,2.669Z" transform="translate(-11.844 -128.551)"/><path class="j" d="M30.45,131.221H27.3a1.335,1.335,0,1,1,0-2.669H30.45a1.335,1.335,0,0,1,0,2.669Z" transform="translate(-17.689 -128.551)"/></g><circle class="k" cx="3.515" cy="3.515" r="3.515" transform="translate(10.642 38.866)"/><path class="i" d="M7.757,10.264,10.678,13.8a2.893,2.893,0,0,0,2.229,1.049h9.5a2.892,2.892,0,0,0,2.191-1l3.082-3.576Z" transform="translate(-3.211 -10.264)"/><g transform="translate(4.546 9.326)"><path class="l" d="M26.691,30.791H8.741a.985.985,0,0,1-.985-.985V27.162a.985.985,0,0,1,.985-.985H26.691a.985.985,0,0,1,.985.985v2.644A.985.985,0,0,1,26.691,30.791Z" transform="translate(-7.757 -26.177)"/><path class="l" d="M26.691,47.218H8.741a.985.985,0,0,1-.985-.985V43.589a.985.985,0,0,1,.985-.985H26.691a.985.985,0,0,1,.985.985v2.644A.985.985,0,0,1,26.691,47.218Z" transform="translate(-7.757 -32.977)"/></g></g></g></svg>`,
  },
  Services: {
    bgcolor: "#4160E0",
    image: (`<svg xmlns="http://www.w3.org/2000/svg" width="90.6" height="77.761" viewBox="0 0 90.6 77.761"><defs><style>.a{fill:#d9d9d9;}.b{fill:#cdcdcd;}.c{fill:#b9b9b9;}.d{fill:#eaeae8;}.e{fill:#fec9a3;}.f{fill:#f7bb8f;}.g{fill:#4298d1;}.h{fill:#3981b7;}.i{fill:#905638;}.j{fill:#69b9e7;}</style></defs><g transform="translate(-7.759 -12.931)"><path class="a" d="M114.114,122.807a17.191,17.191,0,0,0,15.994-10.27H117.962l-5.41-2.934v-5.869l5.41-2.934h12.145a17.067,17.067,0,0,0-14.239-10.171,17.588,17.588,0,0,0-16.145,7.236H87.931v17.606H99.723a17.462,17.462,0,0,0,14.391,7.336Z" transform="translate(-31.748 -33.582)"/><path class="b" d="M98.252,113.793H90.517v5.869h7.735a14.626,14.626,0,0,1,0-5.869Z" transform="translate(-32.772 -43.641)"/><path class="b" d="M119.962,121.64a1.656,1.656,0,0,1-.445-.062,11.553,11.553,0,0,1,0-22.5,1.637,1.637,0,0,1,1.553.317,1.411,1.411,0,0,1,.453,1.431,1.516,1.516,0,0,1-1.116,1.063,8.667,8.667,0,0,0,0,16.879,1.467,1.467,0,0,1,1.1,1.617A1.534,1.534,0,0,1,119.962,121.64Z" transform="translate(-40.721 -37.242)"/><path class="c" d="M139.514,117.424v-5.869l-5.411-2.934-5.411,2.934v5.869l5.411,2.934Z" transform="translate(-47.889 -41.403)"/><path class="b" d="M128.692,113.147v1.694l9.26,5.021,1.562-.847v-1.695l-9.26-5.021Z" transform="translate(-47.889 -42.995)"/><path class="d" d="M83.348,116.927H72.414V91.675l1.562-1.158c5.176,0,9.372,3.941,9.372,8.8Z" transform="translate(-25.603 -33.57)"/><path class="e" d="M18.693,124.412v-13.2H7.759V130.28a3.034,3.034,0,0,0,3.124,2.934H53.059Z" transform="translate(0 -42.522)"/><path class="d" d="M18.693,102.115H7.759V99.181c0-4.862,4.2-8.8,9.372-8.8l1.562-.183Z" transform="translate(0 -33.43)"/><path class="f" d="M25.914,50.182H22.79a4.41,4.41,0,1,1,0-8.8h3.124Z" transform="translate(-4.097 -12.309)"/><path class="f" d="M67.241,50.182h3.124a4.41,4.41,0,1,0,0-8.8H67.241Z" transform="translate(-23.555 -12.309)"/><path class="g" d="M54.517,113.222V88.279l-9.372-2.934h-12.5l-9.372,2.934v24.942Z" transform="translate(-6.145 -31.332)"/><path class="h" d="M56.9,121.552h3.124v2.934H56.9Z" transform="translate(-19.458 -46.998)"/><path class="f" d="M21.228,133.364V131.9L18.1,133.364l3.124,8.8H55.593a3.268,3.268,0,0,0,.944-.151Z" transform="translate(-4.097 -51.474)"/><path class="e" d="M38.793,72.414V79.75l6.248,8.8,6.248-8.8V72.414Z" transform="translate(-12.29 -25.737)"/><path class="f" d="M38.793,75.232a13.122,13.122,0,0,0,12.5,0V72.414h-12.5Z" transform="translate(-12.29 -25.737)"/><path class="e" d="M40.945,58.563c-6.9,0-12.5-5.255-12.5-11.738v-13.2H53.441v13.2C53.441,53.308,47.847,58.563,40.945,58.563Z" transform="translate(-8.193 -8.952)"/><g transform="translate(24.941 31.967)"><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(0 1.505)"/><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(12.497 1.505)"/><path class="i" d="M48.652,53.859H45.528a1.594,1.594,0,0,1-1.268-.609,1.393,1.393,0,0,1-.213-1.322l1.562-4.4a1.529,1.529,0,0,1,1.168-1.008,1.623,1.623,0,0,1,1.5.472,1.4,1.4,0,0,1,.29,1.465l-.876,2.47h.957a1.47,1.47,0,1,1,0,2.934Z" transform="translate(-39.279 -46.485)"/><path class="i" d="M46.066,66.66a6.162,6.162,0,0,1-4.229-1.642,1.4,1.4,0,0,1,0-2.075,1.634,1.634,0,0,1,2.209,0,2.992,2.992,0,0,0,4.039,0,1.634,1.634,0,0,1,2.209,0,1.405,1.405,0,0,1,0,2.075,6.162,6.162,0,0,1-4.229,1.642Z" transform="translate(-38.255 -53.42)"/></g><path class="h" d="M48.114,121.4a1.517,1.517,0,0,1-1.562-1.467V102.329a1.565,1.565,0,0,1,3.124,0v17.606A1.517,1.517,0,0,1,48.114,121.4Z" transform="translate(-15.362 -38.046)"/><path class="h" d="M37.283,97.431l4.686-4.4-6.248-10.27-4.686,2.934Z" transform="translate(-9.217 -30.213)"/><path class="h" d="M53.824,97.431l-4.686-4.4,6.248-10.27,4.686,2.934Z" transform="translate(-16.386 -30.213)"/><path class="f" d="M28.448,33.621H53.441v4.4H28.448Z" transform="translate(-8.193 -8.952)"/><path class="j" d="M28.448,32.5l1.193,2.242a13.017,13.017,0,0,0,22.607,0L53.441,32.5l-1.562-1.467H30.01Z" transform="translate(-8.193 -7.833)"/><path class="e" d="M54.517,111.207v13.2H35.772l-6.248-2.934-6.248,2.934,3.124,8.8H60.766a3.034,3.034,0,0,0,3.124-2.934V111.207Z" transform="translate(-6.145 -42.522)"/><path class="h" d="M53.441,24.669H28.448V18.8A6.067,6.067,0,0,1,34.7,12.931h12.5A6.067,6.067,0,0,1,53.441,18.8Z" transform="translate(-8.193 0)"/></g></svg>`),
  },
  Fashion: {
    bgcolor: "#935FF0",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="80.092" height="80.301" viewBox="0 0 80.092 80.301"><defs><style>.a{fill:#806631;}.b{fill:#5e9446;}.c{fill:#9c9c9c;}.d{fill:#eaca65;}.e{fill:#fce0b9;}.f{fill:#999;}.g{fill:#d0382a;}.h{fill:#fff;}.i{fill:#fad3ac;}.j{fill:#fcccc0;}.k{fill:#f0d57f;}.l{fill:#b83125;}.m{fill:#707070;}</style></defs><path class="a" d="M32.952,42a13.585,13.585,0,0,1-13.809,0H15V69.221H37.094V42Z" transform="translate(1.571 11.08)"/><path class="b" d="M44.809,54.249A12.339,12.339,0,0,0,32.381,42H31V69.221H44.809V54.249Z" transform="translate(7.665 11.08)"/><path class="b" d="M5,54.249A12.339,12.339,0,0,1,17.428,42h1.381V67.86H5V54.249Z" transform="translate(-2.238 11.08)"/><path class="c" d="M49,57h5.524v6.805H49Z" transform="translate(14.521 16.496)"/><path class="d" d="M52.712,38.387,49.415,24.3c-.464-1.98-.732-4-1.008-6.009a17.992,17.992,0,0,0-35.576,0c-.278,2.014-.545,4.029-1.008,6.009l-3.3,14.085a5.445,5.445,0,1,0,0,10.888,6.856,6.856,0,0,0,6.9,6.805h8.285V46.267a14.938,14.938,0,0,1-8.285-13.324V26.124a17.8,17.8,0,0,0,10.511-12.1A19.31,19.31,0,0,0,44.427,27.5h1.381v5.444a14.938,14.938,0,0,1-8.285,13.324V56.08h8.285a6.856,6.856,0,0,0,6.9-6.805,5.445,5.445,0,1,0,0-10.888Z" transform="translate(-3 -3)"/><path class="e" d="M42.38,30.019V24.575H41A19.307,19.307,0,0,1,22.513,11.1,17.8,17.8,0,0,1,12,23.2v6.819a15.192,15.192,0,0,0,30.38,0Z" transform="translate(0.428 -0.076)"/><path class="f" d="M3,47V67.415H33.38V47Z" transform="translate(-3 12.885)"/><path class="g" d="M68.618,22.361,65.166,21,54.809,25.083,44.452,21,41,22.361l5.524,21.776A40.863,40.863,0,0,0,41,64.637V70H68.618v-5.36a40.863,40.863,0,0,0-5.524-20.5Z" transform="translate(11.474 3.499)"/><circle class="h" cx="4" cy="4" r="4" transform="translate(11 66)"/><path class="i" d="M53.857,27.61l10.357-4.083-7.595-2.994V14H51.095v6.533L43.5,23.527Z" transform="translate(12.427 0.971)"/><path class="e" d="M24.9,36.437A15.292,15.292,0,0,1,18,34.79V44.6a13.585,13.585,0,0,0,13.809,0V34.79A15.292,15.292,0,0,1,24.9,36.437Z" transform="translate(2.714 8.477)"/><ellipse class="j" cx="2" cy="0.5" rx="2" ry="0.5" transform="translate(35 34)"/><ellipse class="j" cx="2.5" cy="0.5" rx="2.5" ry="0.5" transform="translate(16 34)"/><path class="k" d="M8.524,41.109l3.3-14.085c.464-1.98.732-4,1.008-6.009a17.992,17.992,0,0,1,35.576,0c.278,2.014.545,4.029,1.008,6.009l3.3,14.085a5.5,5.5,0,0,1,5.329,4.083,5.34,5.34,0,0,0,.195-1.361,5.485,5.485,0,0,0-5.524-5.444L49.415,24.3c-.464-1.98-.732-4-1.008-6.009a17.992,17.992,0,0,0-35.576,0c-.278,2.014-.545,4.029-1.008,6.009l-3.3,14.085A5.485,5.485,0,0,0,3,43.831a5.34,5.34,0,0,0,.195,1.361A5.5,5.5,0,0,1,8.524,41.109Z" transform="translate(-3 -3)"/><path class="i" d="M18,34.79v1.345l10.574,9.842A13.512,13.512,0,0,0,31.809,44.6V34.79A15.3,15.3,0,0,1,18,34.79Z" transform="translate(2.714 8.477)"/><path class="i" d="M41,24.575A19.307,19.307,0,0,1,22.513,11.1,17.8,17.8,0,0,1,12,23.2v4.083a17.8,17.8,0,0,0,10.511-12.1A19.31,19.31,0,0,0,41,28.658H42.38V24.575Z" transform="translate(0.428 -0.076)"/><path class="l" d="M50.666,44.138,45.143,22.361l1.381-.544L44.452,21,41,22.361l5.524,21.776A40.863,40.863,0,0,0,41,64.637V70h4.143v-5.36A40.863,40.863,0,0,1,50.666,44.138Z" transform="translate(11.474 3.499)"/><path class="j" d="M24.143,35.083A4.113,4.113,0,0,0,28.285,31H20A4.113,4.113,0,0,0,24.143,35.083Z" transform="translate(3.475 7.109)"/><path class="h" d="M28.031,32.361A3.98,3.98,0,0,0,28.285,31H20a3.979,3.979,0,0,0,.254,1.361Z" transform="translate(3.475 7.109)"/><ellipse class="a" cx="1.5" cy="2" rx="1.5" ry="2" transform="translate(19 29)"/><ellipse class="a" cx="1.5" cy="2" rx="1.5" ry="2" transform="translate(33 29)"/><ellipse class="h" cx="0.5" cy="1" rx="0.5" ry="1" transform="translate(21 30)"/><ellipse class="h" cx="0.5" cy="1" rx="0.5" ry="1" transform="translate(35 30)"/><path class="m" d="M49,57h5.524v2.722H49Z" transform="translate(14.521 16.496)"/><path class="m" d="M12.545,66.475,3,67.415H33.38V47A23.3,23.3,0,0,1,12.545,66.475Z" transform="translate(-3 12.885)"/><path class="l" d="M51.381,24.144,50,23.6v8.711h2.762V23.6Z" transform="translate(14.902 4.437)"/></svg>`,
  },
  Food: {
    bgcolor: "#C9BA49",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="93.374" height="63.349" viewBox="0 0 93.374 63.349"><defs><style>.a{fill:#d5d6db;}.b{fill:#ebf0f3;}.c{fill:#e1e6e9;}.d{fill:#fff;}.e{fill:#44c4a1;}.f{fill:#31978c;}.g{fill:#3ea69b;}.h{fill:#dc8744;}</style></defs><g transform="translate(0 -24.117)"><path class="a" d="M82.3,121.093H19.875l-6.37-7.9H88.672Z" transform="translate(-5.098 -33.627)"/><path class="b" d="M60.719,28.916l-2.9.964a3.949,3.949,0,1,0-7.5,2.489l-2.9.964a7.007,7.007,0,1,1,13.3-4.417Z" transform="translate(-17.766 0)"/><path class="c" d="M86.373,57.9,26.16,77.9l-1.646-4.957a31.723,31.723,0,0,1,20.109-40.1h0a31.723,31.723,0,0,1,40.1,20.109Z" transform="translate(-8.641 -2.678)"/><g transform="translate(45.045 31.777)"><path class="d" d="M93.113,46.987a.764.764,0,0,1-.765-.169c-11.042-10.383-18.978-8.777-19.057-8.76a.764.764,0,1,1-.33-1.493c.354-.078,8.81-1.792,20.434,9.139a.764.764,0,0,1-.282,1.282Z" transform="translate(-72.362 -36.423)"/><circle class="d" cx="1.147" cy="1.147" r="1.147" transform="translate(21.785 10.906)"/></g><rect class="c" width="93.374" height="3.342" transform="translate(0 76.221)"/><path class="e" d="M110.217,85.112S95.35,83.776,95.684,96.972C95.684,96.972,109.883,99.978,110.217,85.112Z" transform="translate(-36.119 -23.012)"/><g transform="translate(61.34 63.485)"><path class="f" d="M99.041,96.976a.5.5,0,0,1-.32-.887l9.062-7.534a.5.5,0,1,1,.64.771l-9.062,7.534A.5.5,0,0,1,99.041,96.976Z" transform="translate(-98.54 -87.768)"/><path class="f" d="M112.345,91.9H107.9V87.861a.5.5,0,1,1,1,0V90.9h3.445a.5.5,0,0,1,0,1Z" transform="translate(-102.072 -87.36)"/><path class="f" d="M107.828,95.725h-4.447V91.684a.5.5,0,1,1,1,0v3.039h3.445a.5.5,0,0,1,0,1Z" transform="translate(-100.367 -88.803)"/></g><path class="g" d="M78.161,89.572s11.371-1.022,11.115,9.071C89.276,98.643,78.416,100.943,78.161,89.572Z" transform="translate(-29.506 -24.699)"/><g transform="translate(50.596 66.329)"><path class="f" d="M88.713,98.693a.5.5,0,0,1-.32-.115L81.46,92.815a.5.5,0,0,1,.64-.771l6.932,5.763a.5.5,0,0,1-.32.887Z" transform="translate(-81.279 -91.929)"/><path class="f" d="M85.459,96.026H81.939a.5.5,0,1,1,0-1h2.517V92.817a.5.5,0,1,1,1,0Z" transform="translate(-81.339 -92.075)"/></g><path class="h" d="M49.514,100.582H95.657a4.424,4.424,0,0,1,4.424,4.424H45.09A4.424,4.424,0,0,1,49.514,100.582Z" transform="translate(-17.022 -28.866)"/></g></svg>`,
  },
  News: {
    bgcolor: "#C9BA49",
    image: `<svg id="news_1_" data-name="news(1)" xmlns="http://www.w3.org/2000/svg" width="76.088" height="76.088" viewBox="0 0 76.088 76.088">
    <path id="Path_602" data-name="Path 602" d="M71.5,1.148V62S22.964,76.088,6.889,76.088A6.89,6.89,0,0,1,0,69.2V5.741A1.148,1.148,0,0,1,1.148,4.593H9.186V1.148A1.148,1.148,0,0,1,10.334,0H70.347A1.148,1.148,0,0,1,71.5,1.148Z" fill="#8ae7ff"/>
    <path id="Path_603" data-name="Path 603" d="M34.593,60v60.013a2.3,2.3,0,1,1-4.593,0V60Z" transform="translate(-25.407 -50.814)" fill="#47d4ff"/>
    <path id="Path_604" data-name="Path 604" d="M428.889,30,422,101.5h4.593a6.889,6.889,0,0,0,6.889-6.889V31.148A1.148,1.148,0,0,0,432.334,30Z" transform="translate(-357.394 -25.407)" fill="#bdf2ff"/>
    <path id="Path_605" data-name="Path 605" d="M51.889,30V94.606A6.89,6.89,0,0,1,45,101.5h57.717a6.89,6.89,0,0,0,6.889-6.889V30Z" transform="translate(-38.111 -25.407)" fill="#e5faff"/>
    <path id="Path_606" data-name="Path 606" d="M227.686,287v22.964h-4.593L218.5,298.482,223.093,287Z" transform="translate(-185.049 -243.062)" fill="#ff443b"/>
    <path id="Path_607" data-name="Path 607" d="M150,287h15.08v22.964H150Z" transform="translate(-127.036 -243.062)" fill="#ff6333"/>
    <path id="Path_608" data-name="Path 608" d="M386.186,131.186v4.593h-4.593L377,122Z" transform="translate(-319.283 -103.322)" fill="#5c2bc8"/>
    <path id="Path_610" data-name="Path 610" d="M386.186,90v14.085h-4.593L377,97.042,381.593,90Z" transform="translate(-319.283 -76.221)" fill="#725fee"/>
    <path id="Path_609" data-name="Path 609" d="M189.345,122v13.779H150v-4.593Z" transform="translate(-127.036 -103.322)" fill="#6241ea"/>
    <path id="Path_611" data-name="Path 611" d="M150,90h39.345v14.085H150Z" transform="translate(-127.036 -76.221)" fill="#8a7af1"/>
    <g id="Group_805" data-name="Group 805" transform="translate(21.816 35.901)">
      <path id="Path_612" data-name="Path 612" d="M321.821,281.8H302.148a1.148,1.148,0,0,1,0-2.3h19.673a1.148,1.148,0,1,1,0,2.3Z" transform="translate(-276.734 -272.611)" fill="#8ae7ff"/>
      <path id="Path_613" data-name="Path 613" d="M321.821,311.8H302.148a1.148,1.148,0,0,1,0-2.3h19.673a1.148,1.148,0,1,1,0,2.3Z" transform="translate(-276.734 -298.018)" fill="#8ae7ff"/>
      <path id="Path_614" data-name="Path 614" d="M187.586,236.8H143.648a1.148,1.148,0,1,1,0-2.3h43.938a1.148,1.148,0,0,1,0,2.3Z" transform="translate(-142.5 -234.5)" fill="#8ae7ff"/>
      <path id="Path_615" data-name="Path 615" d="M321.821,371.8H302.148a1.148,1.148,0,0,1,0-2.3h19.673a1.148,1.148,0,1,1,0,2.3Z" transform="translate(-276.734 -348.832)" fill="#8ae7ff"/>
      <path id="Path_616" data-name="Path 616" d="M321.821,341.8H302.148a1.148,1.148,0,0,1,0-2.3h19.673a1.148,1.148,0,1,1,0,2.3Z" transform="translate(-276.734 -323.425)" fill="#8ae7ff"/>
      <path id="Path_617" data-name="Path 617" d="M321.821,401.8H302.148a1.148,1.148,0,0,1,0-2.3h19.673a1.148,1.148,0,1,1,0,2.3Z" transform="translate(-276.734 -374.239)" fill="#8ae7ff"/>
      <path id="Path_618" data-name="Path 618" d="M321.821,431.8H302.148a1.148,1.148,0,0,1,0-2.3h19.673a1.148,1.148,0,1,1,0,2.3Z" transform="translate(-276.734 -399.646)" fill="#8ae7ff"/>
    </g>
    <g id="Group_831" data-name="Group 831" transform="translate(26.186 18.128)" style="mix-blend-mode: overlay;isolation: isolate">
      <g id="Group_826" data-name="Group 826" transform="translate(0 0)">
        <g id="Group_825" data-name="Group 825" transform="translate(0)">
          <path id="Path_631" data-name="Path 631" d="M57.014,133.17a.946.946,0,0,1-.946-.946v-8.906a.946.946,0,0,1,1.725-.538l4.5,6.519-.058-5.989a.946.946,0,0,1,.937-.956h.009a.946.946,0,0,1,.946.937l.083,8.622a1.112,1.112,0,0,1-.752,1.11,1.067,1.067,0,0,1-1.2-.448l-4.3-6.222v5.87A.946.946,0,0,1,57.014,133.17Z" transform="translate(-56.068 -122.355)" fill="#9dc6fb"/>
        </g>
      </g>
      <path id="Path_632" data-name="Path 632" d="M144.489,131.279h-2.813v-2.569h2.536a.946.946,0,0,0,0-1.893h-2.536V124.25h2.813a.946.946,0,0,0,0-1.893h-3.76a.946.946,0,0,0-.946.946v8.923a.946.946,0,0,0,.946.946h3.76a.946.946,0,0,0,0-1.893Z" transform="translate(-129.529 -122.357)" fill="#9dc6fb"/>
      <g id="Group_828" data-name="Group 828" transform="translate(31.349 0)">
        <g id="Group_827" data-name="Group 827">
          <path id="Path_633" data-name="Path 633" d="M316.06,133.169a5.2,5.2,0,0,1-3.811-1.633.946.946,0,1,1,1.4-1.271,3.278,3.278,0,0,0,2.408,1.012,1.674,1.674,0,0,0,1.725-1.154c.1-.555-.367-1.067-1.278-1.4-1.379-.509-2.6-1.053-2.654-1.076a.939.939,0,0,1-.131-.071,2.668,2.668,0,0,1-1.19-2.642,2.971,2.971,0,0,1,2.156-2.4,5.022,5.022,0,0,1,4.371.959.946.946,0,0,1-1.214,1.452,3.143,3.143,0,0,0-2.611-.6,1.059,1.059,0,0,0-.828.853.784.784,0,0,0,.3.751c.291.128,1.335.579,2.458.994,2.153.794,2.7,2.335,2.486,3.511A3.511,3.511,0,0,1,316.06,133.169Z" transform="translate(-312.004 -122.354)" fill="#9dc6fb"/>
        </g>
      </g>
      <path id="Path_634" data-name="Path 634" d="M214.576,122.389a.947.947,0,0,0-1.113.743l-1.164,5.85-1.836-5.961a.946.946,0,0,0-1.833.093l-1.816,5.868-1.16-5.866a.946.946,0,1,0-1.857.367l1.738,8.789a.943.943,0,0,0,.037.133,1.149,1.149,0,0,0,1.082.764h.008a1.149,1.149,0,0,0,1.079-.778l.008-.025,1.811-5.85,1.8,5.852c0,.013.008.026.013.038a1.149,1.149,0,0,0,1.081.763h.008a1.149,1.149,0,0,0,1.079-.778.933.933,0,0,0,.032-.12l1.745-8.77A.946.946,0,0,0,214.576,122.389Z" transform="translate(-185.686 -122.354)" fill="#9dc6fb"/>
    </g>
  </svg>`,
  },

  Beauty: {
    bgcolor: "#C43699",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="81.672" height="78.676" viewBox="0 0 81.672 78.676"><defs><style>.a{fill:#9b5729;}.b{fill:#7f441c;}.c{fill:#f66;}.d{fill:#fe3745;}.e{fill:#def9ff;}.f{fill:#f8d5ab;}.g{fill:#eac092;}.h{fill:#b57a4e;}.i{fill:#ffe2b8;}.j{fill:#ffc987;}.k{fill:#72563c;}.l{fill:#ffaf10;}.m{fill:#f39600;}.n{fill:#ffcb00;}.o{fill:#c7c8ca;}.p{fill:#a7a9ac;}.q{fill:#602f0e;}.r{fill:#8a8c8e;}.s{fill:#6d6e71;}.t{fill:#ff99a3;}.u{fill:#ff788c;}.v{fill:#ffaf68;}</style></defs><g transform="translate(0 -0.146)"><path class="a" d="M62.87,8.759A26.581,26.581,0,0,1,74.2,11.144a11.333,11.333,0,0,0-22.656,0A26.581,26.581,0,0,1,62.87,8.759Zm0,0" transform="translate(-23.478 0)"/><path class="b" d="M56.947,9.355A11.313,11.313,0,0,1,65.48.45a11.43,11.43,0,0,0-2.61-.3,11.3,11.3,0,0,0-11.328,11A24.209,24.209,0,0,1,56.947,9.355Zm0,0" transform="translate(-23.478)"/><path class="c" d="M106.164,114.28a12.115,12.115,0,0,0-2.544-.876l1.713,1.7Zm0,0" transform="translate(-47.201 -51.591)"/><path class="c" d="M71.706,122.056l-8.542-8.5-9.537,14.608a4.107,4.107,0,0,1-2.854,1.819H49.6a4.107,4.107,0,0,1-2.854-1.819l-10-15.314h-.914A12.116,12.116,0,0,0,23.7,124.924v4.38a.859.859,0,0,0,.86.859H75.815a.859.859,0,0,0,.86-.859v-4.38c0-.223-.007-.444-.019-.664A7.581,7.581,0,0,1,71.706,122.056Zm0,0" transform="translate(-10.796 -51.341)"/><path class="d" d="M37.069,113.519l-.433-.664h-.8A12.116,12.116,0,0,0,23.7,124.924v4.38a.86.86,0,0,0,.86.859h5.194a.86.86,0,0,1-.86-.859v-4.38A12.092,12.092,0,0,1,37.069,113.519Zm0,0" transform="translate(-10.796 -51.341)"/><path class="e" d="M73.276,112.855H69.538l-8.528,13.064L52.48,112.855H47.458l10.112,15.49a4.107,4.107,0,0,0,2.854,1.819h1.171a4.107,4.107,0,0,0,2.854-1.819l9.606-14.715Zm0,0" transform="translate(-21.618 -51.341)"/><path class="f" d="M70.023,107.769v-3.531a16.216,16.216,0,0,1-2.78.241H62.987a16.1,16.1,0,0,1-2.781-.243v3.532a1.165,1.165,0,0,1-1.166,1.16H56.47l8.644,13.242,8.645-13.242H71.19A1.165,1.165,0,0,1,70.023,107.769Zm0,0" transform="translate(-25.723 -47.415)"/><path class="g" d="M59.836,112.277a1.163,1.163,0,0,1-.8.315H56.47l8.645,13.242L66.9,123.1Zm0,0" transform="translate(-25.723 -51.078)"/><path class="h" d="M33.145,40.09h2.832V36.226a.853.853,0,0,1,.855-.849H51.245a7.951,7.951,0,0,0,6.677-3.7.857.857,0,0,1,1.449,0,7.954,7.954,0,0,0,6.677,3.7h5.288a.853.853,0,0,1,.854.849V40.09h2.833a3.28,3.28,0,0,1,.89.125V34.4c0-11.858-9.773-18.727-21.83-18.727s-21.83,6.87-21.83,18.727v5.817A3.261,3.261,0,0,1,33.145,40.09Zm0,0" transform="translate(-14.692 -7.072)"/><path class="a" d="M33.145,40.09h2.832V36.226a.853.853,0,0,1,.855-.849h.62V34.4c0-10.993,8.4-17.7,19.231-18.617q-1.279-.109-2.6-.11c-12.056,0-21.83,6.87-21.83,18.727v5.816A3.285,3.285,0,0,1,33.145,40.09Zm0,0" transform="translate(-14.692 -7.072)"/><path class="f" d="M105.6,66.879a7.237,7.237,0,0,1,5.195,3.1,3.294,3.294,0,0,0,1.024-2.385V63.557a3.359,3.359,0,0,0-3.387-3.332H105.6Zm0,0" transform="translate(-48.104 -27.367)"/><path class="i" d="M29.852,69.759a12.148,12.148,0,0,1,2.958-.373c.371,0,.739.019,1.1.055q-.022-.418-.023-.841V60.226H31.057a3.359,3.359,0,0,0-3.387,3.332V67.59a3.315,3.315,0,0,0,1.613,2.835A.753.753,0,0,1,29.852,69.759Zm0,0" transform="translate(-12.605 -27.367)"/><path class="i" d="M67.99,73.3a1.561,1.561,0,0,1,0-2.216,1.609,1.609,0,0,1,.324-.246l.146-.085-.093-.141a7.122,7.122,0,0,1-1.193-3.953A7.214,7.214,0,0,1,74.4,59.469a7.293,7.293,0,0,1,.932.062V49.153a1.011,1.011,0,0,0-1.014-1.009H69.03a7.793,7.793,0,0,1-6.542-3.62,1.017,1.017,0,0,0-1.719,0,7.793,7.793,0,0,1-6.542,3.62H39.813A1.012,1.012,0,0,0,38.8,49.153V61.232q0,.416.022.827a10,10,0,0,1,6.28,2.826,10.448,10.448,0,0,1,2.507,10.121.749.749,0,0,1-.213.36,16.16,16.16,0,0,0,7.543,1.858h4.256a16.147,16.147,0,0,0,9.59-3.139Zm0,0" transform="translate(-17.674 -19.999)"/><path class="j" d="M42.337,66.4a15.858,15.858,0,0,1-.1-1.738V52.578a1.011,1.011,0,0,1,1.014-1.008H39.813A1.011,1.011,0,0,0,38.8,52.578v12.08q0,.416.022.826A10.482,10.482,0,0,1,42.337,66.4Zm0,0" transform="translate(-17.674 -23.424)"/><path class="j" d="M54.8,99.549a.752.752,0,0,1-.213.36,16.16,16.16,0,0,0,7.543,1.858h3.442A16.156,16.156,0,0,1,55.1,97.929,12.125,12.125,0,0,1,54.8,99.549Zm0,0" transform="translate(-24.865 -44.542)"/><g transform="translate(24.759 34.058)"><path class="k" d="M71.587,74.425H69.58A2.128,2.128,0,0,1,67.449,72.3V69a1.2,1.2,0,0,1,2.393,0v3.028h1.745a1.2,1.2,0,0,1,0,2.393Zm0,0" transform="translate(-55.483 -64.88)"/><path class="k" d="M50.483,66.39a6.584,6.584,0,0,1-4.658-1.915,1.2,1.2,0,0,1,1.687-1.7,4.222,4.222,0,0,0,5.941,0,1.2,1.2,0,1,1,1.687,1.7A6.584,6.584,0,0,1,50.483,66.39Zm0,0" transform="translate(-45.472 -62.43)"/><path class="k" d="M85.829,66.39a6.581,6.581,0,0,1-4.657-1.915,1.2,1.2,0,0,1,1.687-1.7,4.222,4.222,0,0,0,5.941,0,1.2,1.2,0,0,1,1.687,1.7A6.587,6.587,0,0,1,85.829,66.39Zm0,0" transform="translate(-61.574 -62.43)"/><path class="k" d="M66.583,89.131a9.14,9.14,0,0,1-6.467-2.656,1.2,1.2,0,0,1,1.687-1.7,6.839,6.839,0,0,0,9.623-.035,1.2,1.2,0,1,1,1.687,1.7A9.238,9.238,0,0,1,66.583,89.131Zm0,0" transform="translate(-51.982 -72.436)"/></g><path class="l" d="M128.258,47.354a.479.479,0,0,1-.446-.3c-.965-2.429-1.7-3.162-4.125-4.127a.48.48,0,0,1,0-.892c2.428-.965,3.16-1.7,4.125-4.127a.479.479,0,0,1,.891,0c.965,2.429,1.7,3.162,4.125,4.127a.48.48,0,0,1,0,.892c-2.428.965-3.16,1.7-4.125,4.127A.479.479,0,0,1,128.258,47.354Zm0,0" transform="translate(-56.205 -17.062)"/><path class="m" d="M125.393,44.314a.379.379,0,0,1-.042-.021,11.419,11.419,0,0,1-1.663.787.48.48,0,0,0,0,.892c2.428.965,3.16,1.7,4.125,4.127a.479.479,0,0,0,.891,0,11.334,11.334,0,0,1,.8-1.689C128.547,46.006,127.81,45.275,125.393,44.314Zm0,0" transform="translate(-56.205 -20.11)"/><path class="n" d="M12.379,47.446a.478.478,0,0,1-.446-.3c-.965-2.429-1.7-3.162-4.126-4.127a.48.48,0,0,1,0-.892c2.428-.965,3.16-1.7,4.126-4.127a.479.479,0,0,1,.89,0c.965,2.429,1.7,3.162,4.125,4.127a.48.48,0,0,1,0,.892c-2.428.965-3.16,1.7-4.125,4.127A.478.478,0,0,1,12.379,47.446Zm0,0" transform="translate(-3.419 -17.105)"/><path class="l" d="M9.505,44.409l-.038-.019a11.525,11.525,0,0,1-1.659.784.48.48,0,0,0,0,.892c2.428.965,3.16,1.7,4.126,4.127a.479.479,0,0,0,.89,0,11.405,11.405,0,0,1,.8-1.681C12.661,46.1,11.925,45.371,9.505,44.409Zm0,0" transform="translate(-3.419 -20.154)"/><path class="l" d="M26.094,12.926a.388.388,0,0,1-.361-.245,4.762,4.762,0,0,0-3.345-3.347.389.389,0,0,1,0-.723,4.762,4.762,0,0,0,3.345-3.347.389.389,0,0,1,.722,0A4.763,4.763,0,0,0,29.8,8.611a.389.389,0,0,1,0,.723,4.763,4.763,0,0,0-3.345,3.347A.388.388,0,0,1,26.094,12.926Zm0,0" transform="translate(-10.087 -2.22)"/><path class="m" d="M27.384,13.077a4.685,4.685,0,0,0-3.153-3.268,6.9,6.9,0,0,1-1.843.984.389.389,0,0,0,0,.723,4.764,4.764,0,0,1,3.345,3.347.389.389,0,0,0,.722,0,7.189,7.189,0,0,1,.932-1.78Zm0,0" transform="translate(-10.087 -4.401)"/><path class="o" d="M13.768,100.665.453,115.316a1.532,1.532,0,0,0,0,2.174,1.552,1.552,0,0,0,2.186,0L17.37,104.247Zm0,0" transform="translate(0 -45.788)"/><path class="p" d="M15.152,102.041l-1.384-1.376L.453,115.316a1.532,1.532,0,0,0,0,2.174,1.552,1.552,0,0,0,2.186,0l.664-.6a1.529,1.529,0,0,1,.158-1.986Zm0,0" transform="translate(0 -45.788)"/><path class="a" d="M40.872,79.67a10.749,10.749,0,0,0-10.331-2.536.916.916,0,0,0-.692.826l-.582,8.824,4.45,4.426,8.873-.579a.916.916,0,0,0,.83-.687A10.605,10.605,0,0,0,40.872,79.67Zm0,0" transform="translate(-13.332 -34.898)"/><path class="b" d="M32.889,82.607l.318-4.815a1.009,1.009,0,0,1,.761-.91c.132-.033.264-.064.4-.093a12.127,12.127,0,0,0-3.822.346.914.914,0,0,0-.692.826l-.582,8.824.705.7Zm0,0" transform="translate(-13.332 -34.899)"/><path class="q" d="M39.689,89.293a1.2,1.2,0,0,0-1.639-.421l-5.066,2.995,3-5.027a1.2,1.2,0,0,0-2.054-1.228l-3.372,5.642,3.043,3.025,5.662-3.347A1.2,1.2,0,0,0,39.689,89.293Zm0,0" transform="translate(-13.922 -38.666)"/><path class="r" d="M29.768,102.034a.829.829,0,0,1-1.165,0l-5-4.975a.819.819,0,0,1,0-1.159l1.648-1.639a.829.829,0,0,1,1.165,0l5,4.975a.82.82,0,0,1,0,1.16Zm0,0" transform="translate(-10.641 -42.763)"/><path class="s" d="M25.591,98.1l1.844-1.834a.918.918,0,0,1,.737-.259l-1.759-1.75a.83.83,0,0,0-1.166,0L23.6,95.9a.818.818,0,0,0,0,1.159l1.724,1.715A.912.912,0,0,1,25.591,98.1Zm0,0" transform="translate(-10.641 -42.763)"/><path class="t" d="M92.712,83.386a1.568,1.568,0,0,1,1.115.46l2.805,2.79a7.45,7.45,0,0,0,2.506.042L95.058,82.62a1.562,1.562,0,0,1,0-2.216,1.583,1.583,0,0,1,2.231,0l5.015,4.987a7.446,7.446,0,0,0,1.287-1.168L100.752,81.4a1.561,1.561,0,0,1,0-2.216,1.583,1.583,0,0,1,2.231,0l2.155,2.144A7.387,7.387,0,1,0,91.93,83.593,1.571,1.571,0,0,1,92.712,83.386Zm0,0" transform="translate(-41.28 -32.765)"/><path class="u" d="M92.712,83.386a1.568,1.568,0,0,1,1.115.46l2.805,2.79a7.5,7.5,0,0,0,1.373.128,7.4,7.4,0,0,0,1.128-.089l-.384-.383a7.332,7.332,0,0,1,.929-14.025,7.388,7.388,0,0,0-9.058,7.153,7.287,7.287,0,0,0,1.309,4.174A1.571,1.571,0,0,1,92.712,83.386Zm0,0" transform="translate(-41.28 -32.765)"/><path class="j" d="M115.327,117.015a.9.9,0,0,1-.635-.261l-5.777-5.746a7.86,7.86,0,0,1-2.069.277,7.751,7.751,0,0,1-5.5-2.264L89.526,97.265a1.719,1.719,0,0,1,0-2.442,1.743,1.743,0,0,1,2.456,0l6.7,6.663,1-1L90.753,91.6a1.721,1.721,0,0,1,0-2.443,1.744,1.744,0,0,1,2.456,0l8.932,8.882,1-1L94.215,88.16a1.721,1.721,0,0,1,0-2.443,1.743,1.743,0,0,1,2.456,0L105.6,94.6l1.005-1-6.7-6.662a1.721,1.721,0,0,1,0-2.443,1.744,1.744,0,0,1,2.456,0l8.59,8.543V89.955a2.184,2.184,0,0,1,4.369,0v7.736a7.732,7.732,0,0,1,.861,6.089l5.772,5.741a.894.894,0,0,1,0,1.271l-6,5.963A.893.893,0,0,1,115.327,117.015Zm0,0" transform="translate(-40.549 -38.193)"/><path class="v" d="M109.9,118.1a7.886,7.886,0,0,1-2.069.276,7.75,7.75,0,0,1-5.5-2.264l-11.82-11.756a1.707,1.707,0,0,1-.5-1.085,1.727,1.727,0,0,0-.48.335,1.719,1.719,0,0,0,0,2.443l11.82,11.756a7.751,7.751,0,0,0,5.5,2.264,7.886,7.886,0,0,0,2.069-.276l5.777,5.745a.9.9,0,0,0,1.269,0l.7-.7Zm0,0" transform="translate(-40.549 -46.975)"/></g></svg>`,
  },
  Home: {
    bgcolor: "#4160E0",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="87.862" height="67.539" viewBox="0 0 87.862 67.539"><defs><style>.a{fill:#a35418;}.b{fill:#64cc56;}.c{fill:#50a645;}.d{fill:#ffd180;}.e{fill:#ffba63;}.f{fill:#ff7043;}.g{fill:#bf6724;}.h{fill:#fdeedf;}.i{fill:#ff5722;}.j{fill:#b2ebf2;}.k{fill:#80deea;}.l{fill:#8c4815;}</style></defs><path class="a" d="M41.207,363.934h5.3v12.353h-5.3Z" transform="translate(-34.136 -311.663)"/><ellipse class="b" cx="9.723" cy="9.713" rx="9.723" ry="9.713" transform="translate(0 35.848)"/><path class="c" d="M43.859,268.127a9.744,9.744,0,0,0-2.652.366,9.713,9.713,0,0,1,0,18.694,9.715,9.715,0,1,0,2.652-19.059Z" transform="translate(-34.136 -232.279)"/><path class="a" d="M439.887,363.934h5.3v12.353h-5.3Z" transform="translate(-364.4 -311.663)"/><ellipse class="b" cx="9.723" cy="9.713" rx="9.723" ry="9.713" transform="translate(68.416 35.848)"/><path class="c" d="M442.539,268.127a9.744,9.744,0,0,0-2.652.366,9.713,9.713,0,0,1,0,18.694,9.715,9.715,0,1,0,2.652-19.059Z" transform="translate(-364.4 -232.279)"/><path class="d" d="M154.506,99.862v38.7H101.47v-38.7L127.988,79.51Z" transform="translate(-84.057 -75.994)"/><path class="e" d="M379.622,174.494v42.77h5.3v-38.7Z" transform="translate(-314.477 -154.696)"/><path class="f" d="M128.436,82.886,98.03,59.548a2.652,2.652,0,0,0-3.229,0L64.394,82.886a2.652,2.652,0,0,0,3.229,4.208l28.792-22.1,28.792,22.1a2.652,2.652,0,0,0,3.229-4.208Z" transform="translate(-52.484 -59)"/><path class="g" d="M145.771,271.218h15.911v26.19H145.771Z" transform="translate(-120.756 -234.84)"/><path class="a" d="M207.581,271.218h5.3v26.19h-5.3Z" transform="translate(-171.959 -234.84)"/><path class="h" d="M155.468,263.72H139.557a1.287,1.287,0,0,0-1.287,1.286v26.189h2.574v-24.9h13.337v24.9h2.574V265.006A1.287,1.287,0,0,0,155.468,263.72Z" transform="translate(-114.542 -228.627)"/><path class="f" d="M283.657,338.326H265.978a.707.707,0,0,1-.707-.706v-3.885a.707.707,0,0,1,.707-.706h17.678a.707.707,0,0,1,.707.706v3.885A.707.707,0,0,1,283.657,338.326Z" transform="translate(-219.749 -286.055)"/><path class="i" d="M346.809,333.028h-5.3a.707.707,0,0,1,.707.706v3.885a.707.707,0,0,1-.707.706h5.3a.707.707,0,0,0,.707-.706v-3.885A.707.707,0,0,0,346.809,333.028Z" transform="translate(-282.901 -286.055)"/><path class="j" d="M275.573,271.218H291.13v10.6H275.573Z" transform="translate(-228.283 -234.84)"/><path class="k" d="M335.324,271.218h5.3v10.6h-5.3Z" transform="translate(-277.78 -234.84)"/><ellipse class="j" cx="6.187" cy="6.181" rx="6.187" ry="6.181" transform="translate(37.744 15.635)"/><path class="h" d="M219.918,142.711a7.466,7.466,0,1,0,7.474,7.466A7.479,7.479,0,0,0,219.918,142.711Zm4.75,6.262h-3.463v-3.52A4.916,4.916,0,0,1,224.669,148.973Zm-6.037-3.52v3.52h-3.463A4.916,4.916,0,0,1,218.631,145.454Zm-3.419,6.091h3.419V154.9A4.917,4.917,0,0,1,215.213,151.544Zm5.993,3.357v-3.357h3.419A4.917,4.917,0,0,1,221.206,154.9Z" transform="translate(-175.987 -128.361)"/><path class="h" d="M284.917,263.717H269.36A1.286,1.286,0,0,0,268.073,265v10.6a1.286,1.286,0,0,0,1.287,1.286h15.557A1.286,1.286,0,0,0,286.2,275.6V265A1.286,1.286,0,0,0,284.917,263.717Zm-14.27,2.571h5.2v8.024h-5.2Zm12.983,8.024h-5.2v-8.024h5.2Z" transform="translate(-222.07 -228.625)"/><path class="a" d="M85.032,425.652H2.83A2.829,2.829,0,0,1,0,422.825v0a2.829,2.829,0,0,1,2.83-2.827h82.2a2.829,2.829,0,0,1,2.83,2.827v0A2.829,2.829,0,0,1,85.032,425.652Z" transform="translate(0 -358.113)"/><path class="l" d="M469.915,419.995h-5.3a2.829,2.829,0,0,1,0,5.658h5.3a2.829,2.829,0,0,0,0-5.658Z" transform="translate(-384.882 -358.114)"/></svg>`,
  },
  Handyman: {
    bgcolor: "#F46E56",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="90.6" height="77.761" viewBox="0 0 90.6 77.761"><defs><style>.a{fill:#d9d9d9;}.b{fill:#cdcdcd;}.c{fill:#b9b9b9;}.d{fill:#eaeae8;}.e{fill:#fec9a3;}.f{fill:#f7bb8f;}.g{fill:#4298d1;}.h{fill:#3981b7;}.i{fill:#905638;}.j{fill:#69b9e7;}</style></defs><g transform="translate(-7.759 -12.931)"><path class="a" d="M114.114,122.807a17.191,17.191,0,0,0,15.994-10.27H117.962l-5.41-2.934v-5.869l5.41-2.934h12.145a17.067,17.067,0,0,0-14.239-10.171,17.588,17.588,0,0,0-16.145,7.236H87.931v17.606H99.723a17.462,17.462,0,0,0,14.391,7.336Z" transform="translate(-31.748 -33.582)"/><path class="b" d="M98.252,113.793H90.517v5.869h7.735a14.626,14.626,0,0,1,0-5.869Z" transform="translate(-32.772 -43.641)"/><path class="b" d="M119.962,121.64a1.656,1.656,0,0,1-.445-.062,11.553,11.553,0,0,1,0-22.5,1.637,1.637,0,0,1,1.553.317,1.411,1.411,0,0,1,.453,1.431,1.516,1.516,0,0,1-1.116,1.063,8.667,8.667,0,0,0,0,16.879,1.467,1.467,0,0,1,1.1,1.617A1.534,1.534,0,0,1,119.962,121.64Z" transform="translate(-40.721 -37.242)"/><path class="c" d="M139.514,117.424v-5.869l-5.411-2.934-5.411,2.934v5.869l5.411,2.934Z" transform="translate(-47.889 -41.403)"/><path class="b" d="M128.692,113.147v1.694l9.26,5.021,1.562-.847v-1.695l-9.26-5.021Z" transform="translate(-47.889 -42.995)"/><path class="d" d="M83.348,116.927H72.414V91.675l1.562-1.158c5.176,0,9.372,3.941,9.372,8.8Z" transform="translate(-25.603 -33.57)"/><path class="e" d="M18.693,124.412v-13.2H7.759V130.28a3.034,3.034,0,0,0,3.124,2.934H53.059Z" transform="translate(0 -42.522)"/><path class="d" d="M18.693,102.115H7.759V99.181c0-4.862,4.2-8.8,9.372-8.8l1.562-.183Z" transform="translate(0 -33.43)"/><path class="f" d="M25.914,50.182H22.79a4.41,4.41,0,1,1,0-8.8h3.124Z" transform="translate(-4.097 -12.309)"/><path class="f" d="M67.241,50.182h3.124a4.41,4.41,0,1,0,0-8.8H67.241Z" transform="translate(-23.555 -12.309)"/><path class="g" d="M54.517,113.222V88.279l-9.372-2.934h-12.5l-9.372,2.934v24.942Z" transform="translate(-6.145 -31.332)"/><path class="h" d="M56.9,121.552h3.124v2.934H56.9Z" transform="translate(-19.458 -46.998)"/><path class="f" d="M21.228,133.364V131.9L18.1,133.364l3.124,8.8H55.593a3.268,3.268,0,0,0,.944-.151Z" transform="translate(-4.097 -51.474)"/><path class="e" d="M38.793,72.414V79.75l6.248,8.8,6.248-8.8V72.414Z" transform="translate(-12.29 -25.737)"/><path class="f" d="M38.793,75.232a13.122,13.122,0,0,0,12.5,0V72.414h-12.5Z" transform="translate(-12.29 -25.737)"/><path class="e" d="M40.945,58.563c-6.9,0-12.5-5.255-12.5-11.738v-13.2H53.441v13.2C53.441,53.308,47.847,58.563,40.945,58.563Z" transform="translate(-8.193 -8.952)"/><g transform="translate(24.941 31.967)"><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(0 1.505)"/><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(12.497 1.505)"/><path class="i" d="M48.652,53.859H45.528a1.594,1.594,0,0,1-1.268-.609,1.393,1.393,0,0,1-.213-1.322l1.562-4.4a1.529,1.529,0,0,1,1.168-1.008,1.623,1.623,0,0,1,1.5.472,1.4,1.4,0,0,1,.29,1.465l-.876,2.47h.957a1.47,1.47,0,1,1,0,2.934Z" transform="translate(-39.279 -46.485)"/><path class="i" d="M46.066,66.66a6.162,6.162,0,0,1-4.229-1.642,1.4,1.4,0,0,1,0-2.075,1.634,1.634,0,0,1,2.209,0,2.992,2.992,0,0,0,4.039,0,1.634,1.634,0,0,1,2.209,0,1.405,1.405,0,0,1,0,2.075,6.162,6.162,0,0,1-4.229,1.642Z" transform="translate(-38.255 -53.42)"/></g><path class="h" d="M48.114,121.4a1.517,1.517,0,0,1-1.562-1.467V102.329a1.565,1.565,0,0,1,3.124,0v17.606A1.517,1.517,0,0,1,48.114,121.4Z" transform="translate(-15.362 -38.046)"/><path class="h" d="M37.283,97.431l4.686-4.4-6.248-10.27-4.686,2.934Z" transform="translate(-9.217 -30.213)"/><path class="h" d="M53.824,97.431l-4.686-4.4,6.248-10.27,4.686,2.934Z" transform="translate(-16.386 -30.213)"/><path class="f" d="M28.448,33.621H53.441v4.4H28.448Z" transform="translate(-8.193 -8.952)"/><path class="j" d="M28.448,32.5l1.193,2.242a13.017,13.017,0,0,0,22.607,0L53.441,32.5l-1.562-1.467H30.01Z" transform="translate(-8.193 -7.833)"/><path class="e" d="M54.517,111.207v13.2H35.772l-6.248-2.934-6.248,2.934,3.124,8.8H60.766a3.034,3.034,0,0,0,3.124-2.934V111.207Z" transform="translate(-6.145 -42.522)"/><path class="h" d="M53.441,24.669H28.448V18.8A6.067,6.067,0,0,1,34.7,12.931h12.5A6.067,6.067,0,0,1,53.441,18.8Z" transform="translate(-8.193 0)"/></g></svg>`,
  },

  Services: {
    bgcolor: "#4160E0",
    image: (`<svg xmlns="http://www.w3.org/2000/svg" width="90.6" height="77.761" viewBox="0 0 90.6 77.761"><defs><style>.a{fill:#d9d9d9;}.b{fill:#cdcdcd;}.c{fill:#b9b9b9;}.d{fill:#eaeae8;}.e{fill:#fec9a3;}.f{fill:#f7bb8f;}.g{fill:#4298d1;}.h{fill:#3981b7;}.i{fill:#905638;}.j{fill:#69b9e7;}</style></defs><g transform="translate(-7.759 -12.931)"><path class="a" d="M114.114,122.807a17.191,17.191,0,0,0,15.994-10.27H117.962l-5.41-2.934v-5.869l5.41-2.934h12.145a17.067,17.067,0,0,0-14.239-10.171,17.588,17.588,0,0,0-16.145,7.236H87.931v17.606H99.723a17.462,17.462,0,0,0,14.391,7.336Z" transform="translate(-31.748 -33.582)"/><path class="b" d="M98.252,113.793H90.517v5.869h7.735a14.626,14.626,0,0,1,0-5.869Z" transform="translate(-32.772 -43.641)"/><path class="b" d="M119.962,121.64a1.656,1.656,0,0,1-.445-.062,11.553,11.553,0,0,1,0-22.5,1.637,1.637,0,0,1,1.553.317,1.411,1.411,0,0,1,.453,1.431,1.516,1.516,0,0,1-1.116,1.063,8.667,8.667,0,0,0,0,16.879,1.467,1.467,0,0,1,1.1,1.617A1.534,1.534,0,0,1,119.962,121.64Z" transform="translate(-40.721 -37.242)"/><path class="c" d="M139.514,117.424v-5.869l-5.411-2.934-5.411,2.934v5.869l5.411,2.934Z" transform="translate(-47.889 -41.403)"/><path class="b" d="M128.692,113.147v1.694l9.26,5.021,1.562-.847v-1.695l-9.26-5.021Z" transform="translate(-47.889 -42.995)"/><path class="d" d="M83.348,116.927H72.414V91.675l1.562-1.158c5.176,0,9.372,3.941,9.372,8.8Z" transform="translate(-25.603 -33.57)"/><path class="e" d="M18.693,124.412v-13.2H7.759V130.28a3.034,3.034,0,0,0,3.124,2.934H53.059Z" transform="translate(0 -42.522)"/><path class="d" d="M18.693,102.115H7.759V99.181c0-4.862,4.2-8.8,9.372-8.8l1.562-.183Z" transform="translate(0 -33.43)"/><path class="f" d="M25.914,50.182H22.79a4.41,4.41,0,1,1,0-8.8h3.124Z" transform="translate(-4.097 -12.309)"/><path class="f" d="M67.241,50.182h3.124a4.41,4.41,0,1,0,0-8.8H67.241Z" transform="translate(-23.555 -12.309)"/><path class="g" d="M54.517,113.222V88.279l-9.372-2.934h-12.5l-9.372,2.934v24.942Z" transform="translate(-6.145 -31.332)"/><path class="h" d="M56.9,121.552h3.124v2.934H56.9Z" transform="translate(-19.458 -46.998)"/><path class="f" d="M21.228,133.364V131.9L18.1,133.364l3.124,8.8H55.593a3.268,3.268,0,0,0,.944-.151Z" transform="translate(-4.097 -51.474)"/><path class="e" d="M38.793,72.414V79.75l6.248,8.8,6.248-8.8V72.414Z" transform="translate(-12.29 -25.737)"/><path class="f" d="M38.793,75.232a13.122,13.122,0,0,0,12.5,0V72.414h-12.5Z" transform="translate(-12.29 -25.737)"/><path class="e" d="M40.945,58.563c-6.9,0-12.5-5.255-12.5-11.738v-13.2H53.441v13.2C53.441,53.308,47.847,58.563,40.945,58.563Z" transform="translate(-8.193 -8.952)"/><g transform="translate(24.941 31.967)"><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(0 1.505)"/><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(12.497 1.505)"/><path class="i" d="M48.652,53.859H45.528a1.594,1.594,0,0,1-1.268-.609,1.393,1.393,0,0,1-.213-1.322l1.562-4.4a1.529,1.529,0,0,1,1.168-1.008,1.623,1.623,0,0,1,1.5.472,1.4,1.4,0,0,1,.29,1.465l-.876,2.47h.957a1.47,1.47,0,1,1,0,2.934Z" transform="translate(-39.279 -46.485)"/><path class="i" d="M46.066,66.66a6.162,6.162,0,0,1-4.229-1.642,1.4,1.4,0,0,1,0-2.075,1.634,1.634,0,0,1,2.209,0,2.992,2.992,0,0,0,4.039,0,1.634,1.634,0,0,1,2.209,0,1.405,1.405,0,0,1,0,2.075,6.162,6.162,0,0,1-4.229,1.642Z" transform="translate(-38.255 -53.42)"/></g><path class="h" d="M48.114,121.4a1.517,1.517,0,0,1-1.562-1.467V102.329a1.565,1.565,0,0,1,3.124,0v17.606A1.517,1.517,0,0,1,48.114,121.4Z" transform="translate(-15.362 -38.046)"/><path class="h" d="M37.283,97.431l4.686-4.4-6.248-10.27-4.686,2.934Z" transform="translate(-9.217 -30.213)"/><path class="h" d="M53.824,97.431l-4.686-4.4,6.248-10.27,4.686,2.934Z" transform="translate(-16.386 -30.213)"/><path class="f" d="M28.448,33.621H53.441v4.4H28.448Z" transform="translate(-8.193 -8.952)"/><path class="j" d="M28.448,32.5l1.193,2.242a13.017,13.017,0,0,0,22.607,0L53.441,32.5l-1.562-1.467H30.01Z" transform="translate(-8.193 -7.833)"/><path class="e" d="M54.517,111.207v13.2H35.772l-6.248-2.934-6.248,2.934,3.124,8.8H60.766a3.034,3.034,0,0,0,3.124-2.934V111.207Z" transform="translate(-6.145 -42.522)"/><path class="h" d="M53.441,24.669H28.448V18.8A6.067,6.067,0,0,1,34.7,12.931h12.5A6.067,6.067,0,0,1,53.441,18.8Z" transform="translate(-8.193 0)"/></g></svg>`),
  },
  Health: {
    bgcolor: "#6DC17D",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="74.24" height="83.854" viewBox="0 0 74.24 83.854"><defs><style>.a{fill:#ffe7cf;}.b{fill:#f4d5ba;}.c{fill:#fff;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:15px;}.d{fill:#24d9de;}.e{fill:#d0d1d2;}.f{fill:#f9644b;}.g{fill:#e1effb;}.h{fill:#caddea;}.i{fill:#44798c;}.j{fill:#1785b8;}.k{fill:#2c5871;}.l{fill:#ffb125;}.m{fill:#ff901d;}</style></defs><path class="a" d="M186.611,253.9l8.926-8.312-3.544-.653a4.192,4.192,0,0,1-2.941-4.038v-7.708H172.478V240.9a4.192,4.192,0,0,1-2.941,4.038l-3.544.653,8.926,8.312A8.593,8.593,0,0,0,186.611,253.9Z" transform="translate(-143.645 -195.244)"/><path class="b" d="M282.038,233.189v11.688a4.192,4.192,0,0,0,2.941,4.038l3.054.867,4.5-4.194-3.544-.653a4.192,4.192,0,0,1-2.941-4.038v-7.708Z" transform="translate(-240.645 -195.243)"/><path class="c" d="M249.173,469.222Z" transform="translate(-213.174 -392.868)"/><path class="d" d="M77.29,300.56l-10.346,7.667L56.6,300.56a2.2,2.2,0,0,0-1.936-.338l-17.382,5.2a5.121,5.121,0,0,0-3.589,4.029l-3.83,22.229a2.511,2.511,0,0,0,2.49,2.926h69.186a2.511,2.511,0,0,0,2.49-2.926L100.2,309.451a5.121,5.121,0,0,0-3.589-4.029l-17.382-5.2A2.2,2.2,0,0,0,77.29,300.56Z" transform="translate(-29.824 -251.291)"/><g transform="translate(21.847 48.838)"><path class="e" d="M165.93,300.222l-2.99.895,6.6,9.156a1.916,1.916,0,0,0,2.3.641l6.377-2.686h0l-10.346-7.667A2.2,2.2,0,0,0,165.93,300.222Z" transform="translate(-162.94 -300.13)"/><path class="e" d="M262.377,310.914a1.916,1.916,0,0,0,2.3-.641l6.6-9.156-.016,0-2.974-.89a2.2,2.2,0,0,0-1.936.338L256,308.228h0Z" transform="translate(-240.727 -300.13)"/></g><g transform="translate(31.189 56.936)"><path class="f" d="M230.459,349.894l-5.015,2.112,2.932,3.379h4.166l2.932-3.379Z" transform="translate(-224.528 -349.894)"/><path class="f" d="M227.878,383.639h-4.166l-3.847,20.887h11.861Z" transform="translate(-219.864 -378.148)"/></g><path class="g" d="M66.944,331.2s-11.62-30.7-12.283-30.506l-17.382,5.2a5.121,5.121,0,0,0-3.589,4.029l-3.83,22.229a2.511,2.511,0,0,0,2.49,2.926h69.186a2.511,2.511,0,0,0,2.49-2.926L100.2,309.92a5.121,5.121,0,0,0-3.589-4.029l-17.382-5.2C78.564,300.493,66.944,331.2,66.944,331.2Z" transform="translate(-29.824 -251.761)"/><path class="h" d="M342.825,332.149,339,309.92a5.121,5.121,0,0,0-3.589-4.029l-17.382-5.2c-.18-.054-1.17,2.176-2.516,5.452l12.606,3.771a2.609,2.609,0,0,1,1.829,2.053l3.981,23.109h6.41A2.511,2.511,0,0,0,342.825,332.149Z" transform="translate(-268.623 -251.761)"/><g transform="translate(17.375 39.016)"><path class="i" d="M312.393,266.708a1.262,1.262,0,0,1-1.268-1.257V251.185a8.932,8.932,0,0,0-8.557-8.9,1.257,1.257,0,1,1,.119-2.511,11.451,11.451,0,0,1,10.973,11.414v14.266A1.262,1.262,0,0,1,312.393,266.708Z" transform="translate(-274.171 -239.769)"/><path class="i" d="M136.958,257.413a1.262,1.262,0,0,1-1.268-1.257v-4.965a11.458,11.458,0,0,1,10.941-11.413,1.257,1.257,0,1,1,.127,2.51,8.936,8.936,0,0,0-8.533,8.9v4.965A1.262,1.262,0,0,1,136.958,257.413Z" transform="translate(-135.69 -239.775)"/></g><ellipse class="j" cx="5.291" cy="5.246" rx="5.291" ry="5.246" transform="translate(50.292 60.278)"/><ellipse class="g" cx="2.331" cy="2.311" rx="2.331" ry="2.311" transform="translate(53.252 63.213)"/><path class="k" d="M109.93,358.046h-1.58a1.257,1.257,0,1,1,0-2.514h1.58a.692.692,0,0,0,.5-.219.68.68,0,0,0,.181-.515l-.924-11.751a3.735,3.735,0,0,0-3.836-3.458h-.238a3.736,3.736,0,0,0-3.816,3.456l-.923,11.75a.679.679,0,0,0,.18.515.691.691,0,0,0,.5.219h1.58a1.257,1.257,0,1,1,0,2.514h-1.58a3.244,3.244,0,0,1-2.365-1.025,3.186,3.186,0,0,1-.847-2.418l.923-11.75a6.255,6.255,0,0,1,6.326-5.774h.256a6.255,6.255,0,0,1,6.364,5.776l.923,11.75a3.187,3.187,0,0,1-.847,2.418A3.244,3.244,0,0,1,109.93,358.046Z" transform="translate(-87.096 -282.226)"/><g transform="translate(17.11 21.904)"><path class="b" d="M139.462,139.311v-4.7h-2.893a2.48,2.48,0,0,0-2.491,2.47v1.91a2.48,2.48,0,0,0,2.491,2.47h2.893Z" transform="translate(-134.078 -134.608)"/><path class="b" d="M348.009,134.608h-2.893v6.85h2.893a2.48,2.48,0,0,0,2.491-2.47v-1.91A2.48,2.48,0,0,0,348.009,134.608Z" transform="translate(-310.481 -134.608)"/></g><path class="a" d="M187.48,25.668c-2.5-2.13-6-1.992-10.635-2.043-4.633.051-8.14-.087-10.635,2.043A14.312,14.312,0,0,0,161.3,36.583v12.1c0,4.164,5.278,15.209,15.541,15.209s15.541-11.045,15.541-15.209v-12.1A14.311,14.311,0,0,0,187.48,25.668Z" transform="translate(-139.725 -19.781)"/><path class="b" d="M245.33,27.856a7.636,7.636,0,0,0-3.46-1.618c0,.006,0,.012,0,.018V50.875c0,3.555-3.847,12.122-11.358,14.554a13.506,13.506,0,0,0,4.183.655c10.263,0,15.541-11.045,15.541-15.209v-12.1A14.312,14.312,0,0,0,245.33,27.856Z" transform="translate(-197.575 -21.968)"/><path class="l" d="M173.359,0h-18.7a8.675,8.675,0,0,0-8.712,8.638v14.18a6.049,6.049,0,0,1,3.941,1.459.511.511,0,0,0,.867-.363v-11.6a3.835,3.835,0,0,1,3.851-3.818h3.5a4,4,0,0,1,2.518.89l.343.278a4.841,4.841,0,0,0,6.088,0l.343-.278a4,4,0,0,1,2.518-.89h3.5a3.835,3.835,0,0,1,3.851,3.818v11.6a.511.511,0,0,0,.867.363,6.049,6.049,0,0,1,3.941-1.459V8.638A8.675,8.675,0,0,0,173.359,0Z" transform="translate(-126.89)"/><path class="m" d="M270.359,0h-8.366A8.675,8.675,0,0,1,270.7,8.5a3.831,3.831,0,0,1,3.562,3.806v11.6a.511.511,0,0,0,.867.363,6.049,6.049,0,0,1,3.94-1.459V8.638A8.675,8.675,0,0,0,270.359,0Z" transform="translate(-223.89)"/></svg>`,
  },
  Professionals: {
    bgcolor: "#4DC5E2",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="79.738" height="72.087" viewBox="0 0 79.738 72.087"><defs><style>.a{fill:#636363;}.b{fill:#494949;}.c{fill:#c9d2e3;}.d{fill:#adbbd5;}.e{fill:#ffd664;}.f{fill:#f9c646;}</style></defs><path class="a" d="M87.585,205.564H27.3a6.378,6.378,0,0,1-6.483-6.268V157.141H94.068V199.3A6.378,6.378,0,0,1,87.585,205.564Zm0,0" transform="translate(-17.571 -133.477)"/><path class="b" d="M90.5,157.141H20.813v18.108a9.824,9.824,0,0,0,1.371.364l29.773,5.335H62.924L90.5,176.007V199.3a6.378,6.378,0,0,1-6.483,6.268h3.566a6.378,6.378,0,0,0,6.483-6.268V157.141Zm0,0" transform="translate(-17.571 -133.477)"/><path class="c" d="M233.072,294.422v6.895H222.7v-6.895Zm0,0" transform="translate(-188.017 -250.085)"/><path class="d" d="M222.7,294.422h10.372v3.134H222.7Zm0,0" transform="translate(-188.017 -250.085)"/><path class="a" d="M39.869,136.266h5.186L74.5,130.99a6.327,6.327,0,0,0,5.235-6.151V114.5a6.379,6.379,0,0,0-6.483-6.269H6.483A6.379,6.379,0,0,0,0,114.5v10.343a6.327,6.327,0,0,0,5.235,6.151l29.447,5.276Zm0,0" transform="translate(0 -91.929)"/><path class="b" d="M449.288,108.227H445.4a6.379,6.379,0,0,1,6.483,6.269v11.922a6.176,6.176,0,0,1-2.228,4.729l.883-.158a6.327,6.327,0,0,0,5.236-6.151V114.5A6.379,6.379,0,0,0,449.288,108.227Zm0,0" transform="translate(-376.033 -91.929)"/><path class="e" d="M228.369,348.054l3.565-1.078a1.573,1.573,0,0,0,1.138-1.5v-5.273H222.7v5.273a1.573,1.573,0,0,0,1.138,1.5l3.565,1.078A1.671,1.671,0,0,0,228.369,348.054Zm0,0" transform="translate(-188.017 -288.975)"/><path class="f" d="M272.648,340.207v7.209l1.456-.44a1.573,1.573,0,0,0,1.138-1.5v-5.273Zm0,0" transform="translate(-230.187 -288.975)"/><path class="e" d="M140.846,81.709h-9.724V78.575a1.6,1.6,0,0,1,1.621-1.567h6.483a1.6,1.6,0,0,1,1.621,1.567Zm0,0" transform="translate(-110.701 -65.411)"/><path class="f" d="M138.738,77.008v1.254a1.594,1.594,0,0,1-1.62,1.567h-6V81.71h9.724V78.575a1.6,1.6,0,0,0-1.621-1.568Zm0,0" transform="translate(-110.701 -65.411)"/><path class="e" d="M328.162,81.709h-9.724V78.575a1.6,1.6,0,0,1,1.621-1.567h6.483a1.6,1.6,0,0,1,1.621,1.567Zm0,0" transform="translate(-268.845 -65.411)"/><path class="f" d="M326.059,77.008v1.254a1.6,1.6,0,0,1-1.621,1.567h-6V81.71h9.724V78.575a1.6,1.6,0,0,0-1.621-1.568Zm0,0" transform="translate(-268.848 -65.411)"/><path class="c" d="M180.05,11.6h-5.186V8.776a3.832,3.832,0,0,0-3.89-3.761H154.767a3.831,3.831,0,0,0-3.89,3.761V11.6h-5.186V8.776A8.94,8.94,0,0,1,154.767,0h16.207a8.94,8.94,0,0,1,9.076,8.776Zm0,0" transform="translate(-123.002)"/><g transform="translate(25.607)"><path class="d" d="M164.422,37.062v2.821h2.269V37.062a3.832,3.832,0,0,1,3.89-3.761h-2.269A3.832,3.832,0,0,0,164.422,37.062Zm0,0" transform="translate(-164.422 -28.286)"/><path class="d" d="M295.733,0h-2.269a8.939,8.939,0,0,1,9.075,8.776V11.6h2.269V8.776A8.94,8.94,0,0,0,295.733,0Zm0,0" transform="translate(-273.368)"/></g></svg>`,
  },
  Cars: {
    bgcolor: "#42CBA6",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="94.677" height="37.544" viewBox="0 0 94.677 37.544"><defs><style>.a{fill:#dd381a;}.b{fill:#4394cc;}.c{fill:#3e89bd;}.d{fill:#f5ae45;}.e{fill:#c43117;}.f{fill:#3678a6;}.g{fill:#d03418;}.h{fill:#697b8c;}.i{fill:#c3c9d1;}</style></defs><g transform="translate(0 -0.422)"><path class="a" d="M83.25,33.56a53.621,53.621,0,0,0-6.387-3.407l-5.04,5.039h-50.6a36.871,36.871,0,0,0-18.3,4.86A5.8,5.8,0,0,0,0,45.087V54.78H86.515L91.8,52.658a4.57,4.57,0,0,0,2.873-4.244V35.191Zm0,0" transform="translate(0 -24.976)"/><path class="b" d="M188.333,5.177A53.712,53.712,0,0,0,166.262.422h-1.923a53.69,53.69,0,0,0-25.713,6.557l-5.935,3.237h50.6Zm0,0" transform="translate(-111.47)"/><path class="c" d="M265.379,15.692h29.382l5.04-5.039a53.909,53.909,0,0,0-11.64-3.712Zm0,0" transform="translate(-222.938 -5.477)"/><path class="d" d="M551.172,82.074h6.53v3.265h-6.53Zm0,0" transform="translate(-463.025 -68.594)"/><path class="e" d="M244.965,82.074h6.53v3.265h-6.53Zm0,0" transform="translate(-205.788 -68.594)"/><path class="f" d="M318.68.422c-.758,0-1.512.039-2.266.072v9.722h3.265V.422Zm0,0" transform="translate(-265.811)"/><path class="g" d="M0,143.316v6.53H86.515l5.289-2.122a4.57,4.57,0,0,0,2.873-4.244v-.164Zm0,0" transform="translate(0 -120.042)"/><path class="h" d="M40.415,112.7a9.794,9.794,0,1,0,9.794,9.794A9.794,9.794,0,0,0,40.415,112.7Zm0,0" transform="translate(-25.724 -94.318)"/><path class="i" d="M71.036,148.214a4.9,4.9,0,1,1-4.9-4.9A4.9,4.9,0,0,1,71.036,148.214Zm0,0" transform="translate(-51.448 -120.042)"/><path class="h" d="M428.278,112.7a9.794,9.794,0,1,0,9.794,9.794A9.794,9.794,0,0,0,428.278,112.7Zm0,0" transform="translate(-351.557 -94.318)"/><path class="i" d="M458.9,148.214a4.9,4.9,0,1,1-4.9-4.9A4.9,4.9,0,0,1,458.9,148.214Zm0,0" transform="translate(-377.278 -120.042)"/><path class="e" d="M316.414,61.66h3.265V81.249h-3.265Zm0,0" transform="translate(-265.811 -51.445)"/></g></svg>`,
  },
  Repair_Refill: {
    bgcolor: "#42CBA6",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="81.672" height="78.676" viewBox="0 0 81.672 78.676"><defs><style>.a{fill:#9b5729;}.b{fill:#7f441c;}.c{fill:#f66;}.d{fill:#fe3745;}.e{fill:#def9ff;}.f{fill:#f8d5ab;}.g{fill:#eac092;}.h{fill:#b57a4e;}.i{fill:#ffe2b8;}.j{fill:#ffc987;}.k{fill:#72563c;}.l{fill:#ffaf10;}.m{fill:#f39600;}.n{fill:#ffcb00;}.o{fill:#c7c8ca;}.p{fill:#a7a9ac;}.q{fill:#602f0e;}.r{fill:#8a8c8e;}.s{fill:#6d6e71;}.t{fill:#ff99a3;}.u{fill:#ff788c;}.v{fill:#ffaf68;}</style></defs><g transform="translate(0 -0.146)"><path class="a" d="M62.87,8.759A26.581,26.581,0,0,1,74.2,11.144a11.333,11.333,0,0,0-22.656,0A26.581,26.581,0,0,1,62.87,8.759Zm0,0" transform="translate(-23.478 0)"/><path class="b" d="M56.947,9.355A11.313,11.313,0,0,1,65.48.45a11.43,11.43,0,0,0-2.61-.3,11.3,11.3,0,0,0-11.328,11A24.209,24.209,0,0,1,56.947,9.355Zm0,0" transform="translate(-23.478)"/><path class="c" d="M106.164,114.28a12.115,12.115,0,0,0-2.544-.876l1.713,1.7Zm0,0" transform="translate(-47.201 -51.591)"/><path class="c" d="M71.706,122.056l-8.542-8.5-9.537,14.608a4.107,4.107,0,0,1-2.854,1.819H49.6a4.107,4.107,0,0,1-2.854-1.819l-10-15.314h-.914A12.116,12.116,0,0,0,23.7,124.924v4.38a.859.859,0,0,0,.86.859H75.815a.859.859,0,0,0,.86-.859v-4.38c0-.223-.007-.444-.019-.664A7.581,7.581,0,0,1,71.706,122.056Zm0,0" transform="translate(-10.796 -51.341)"/><path class="d" d="M37.069,113.519l-.433-.664h-.8A12.116,12.116,0,0,0,23.7,124.924v4.38a.86.86,0,0,0,.86.859h5.194a.86.86,0,0,1-.86-.859v-4.38A12.092,12.092,0,0,1,37.069,113.519Zm0,0" transform="translate(-10.796 -51.341)"/><path class="e" d="M73.276,112.855H69.538l-8.528,13.064L52.48,112.855H47.458l10.112,15.49a4.107,4.107,0,0,0,2.854,1.819h1.171a4.107,4.107,0,0,0,2.854-1.819l9.606-14.715Zm0,0" transform="translate(-21.618 -51.341)"/><path class="f" d="M70.023,107.769v-3.531a16.216,16.216,0,0,1-2.78.241H62.987a16.1,16.1,0,0,1-2.781-.243v3.532a1.165,1.165,0,0,1-1.166,1.16H56.47l8.644,13.242,8.645-13.242H71.19A1.165,1.165,0,0,1,70.023,107.769Zm0,0" transform="translate(-25.723 -47.415)"/><path class="g" d="M59.836,112.277a1.163,1.163,0,0,1-.8.315H56.47l8.645,13.242L66.9,123.1Zm0,0" transform="translate(-25.723 -51.078)"/><path class="h" d="M33.145,40.09h2.832V36.226a.853.853,0,0,1,.855-.849H51.245a7.951,7.951,0,0,0,6.677-3.7.857.857,0,0,1,1.449,0,7.954,7.954,0,0,0,6.677,3.7h5.288a.853.853,0,0,1,.854.849V40.09h2.833a3.28,3.28,0,0,1,.89.125V34.4c0-11.858-9.773-18.727-21.83-18.727s-21.83,6.87-21.83,18.727v5.817A3.261,3.261,0,0,1,33.145,40.09Zm0,0" transform="translate(-14.692 -7.072)"/><path class="a" d="M33.145,40.09h2.832V36.226a.853.853,0,0,1,.855-.849h.62V34.4c0-10.993,8.4-17.7,19.231-18.617q-1.279-.109-2.6-.11c-12.056,0-21.83,6.87-21.83,18.727v5.816A3.285,3.285,0,0,1,33.145,40.09Zm0,0" transform="translate(-14.692 -7.072)"/><path class="f" d="M105.6,66.879a7.237,7.237,0,0,1,5.195,3.1,3.294,3.294,0,0,0,1.024-2.385V63.557a3.359,3.359,0,0,0-3.387-3.332H105.6Zm0,0" transform="translate(-48.104 -27.367)"/><path class="i" d="M29.852,69.759a12.148,12.148,0,0,1,2.958-.373c.371,0,.739.019,1.1.055q-.022-.418-.023-.841V60.226H31.057a3.359,3.359,0,0,0-3.387,3.332V67.59a3.315,3.315,0,0,0,1.613,2.835A.753.753,0,0,1,29.852,69.759Zm0,0" transform="translate(-12.605 -27.367)"/><path class="i" d="M67.99,73.3a1.561,1.561,0,0,1,0-2.216,1.609,1.609,0,0,1,.324-.246l.146-.085-.093-.141a7.122,7.122,0,0,1-1.193-3.953A7.214,7.214,0,0,1,74.4,59.469a7.293,7.293,0,0,1,.932.062V49.153a1.011,1.011,0,0,0-1.014-1.009H69.03a7.793,7.793,0,0,1-6.542-3.62,1.017,1.017,0,0,0-1.719,0,7.793,7.793,0,0,1-6.542,3.62H39.813A1.012,1.012,0,0,0,38.8,49.153V61.232q0,.416.022.827a10,10,0,0,1,6.28,2.826,10.448,10.448,0,0,1,2.507,10.121.749.749,0,0,1-.213.36,16.16,16.16,0,0,0,7.543,1.858h4.256a16.147,16.147,0,0,0,9.59-3.139Zm0,0" transform="translate(-17.674 -19.999)"/><path class="j" d="M42.337,66.4a15.858,15.858,0,0,1-.1-1.738V52.578a1.011,1.011,0,0,1,1.014-1.008H39.813A1.011,1.011,0,0,0,38.8,52.578v12.08q0,.416.022.826A10.482,10.482,0,0,1,42.337,66.4Zm0,0" transform="translate(-17.674 -23.424)"/><path class="j" d="M54.8,99.549a.752.752,0,0,1-.213.36,16.16,16.16,0,0,0,7.543,1.858h3.442A16.156,16.156,0,0,1,55.1,97.929,12.125,12.125,0,0,1,54.8,99.549Zm0,0" transform="translate(-24.865 -44.542)"/><g transform="translate(24.759 34.058)"><path class="k" d="M71.587,74.425H69.58A2.128,2.128,0,0,1,67.449,72.3V69a1.2,1.2,0,0,1,2.393,0v3.028h1.745a1.2,1.2,0,0,1,0,2.393Zm0,0" transform="translate(-55.483 -64.88)"/><path class="k" d="M50.483,66.39a6.584,6.584,0,0,1-4.658-1.915,1.2,1.2,0,0,1,1.687-1.7,4.222,4.222,0,0,0,5.941,0,1.2,1.2,0,1,1,1.687,1.7A6.584,6.584,0,0,1,50.483,66.39Zm0,0" transform="translate(-45.472 -62.43)"/><path class="k" d="M85.829,66.39a6.581,6.581,0,0,1-4.657-1.915,1.2,1.2,0,0,1,1.687-1.7,4.222,4.222,0,0,0,5.941,0,1.2,1.2,0,0,1,1.687,1.7A6.587,6.587,0,0,1,85.829,66.39Zm0,0" transform="translate(-61.574 -62.43)"/><path class="k" d="M66.583,89.131a9.14,9.14,0,0,1-6.467-2.656,1.2,1.2,0,0,1,1.687-1.7,6.839,6.839,0,0,0,9.623-.035,1.2,1.2,0,1,1,1.687,1.7A9.238,9.238,0,0,1,66.583,89.131Zm0,0" transform="translate(-51.982 -72.436)"/></g><path class="l" d="M128.258,47.354a.479.479,0,0,1-.446-.3c-.965-2.429-1.7-3.162-4.125-4.127a.48.48,0,0,1,0-.892c2.428-.965,3.16-1.7,4.125-4.127a.479.479,0,0,1,.891,0c.965,2.429,1.7,3.162,4.125,4.127a.48.48,0,0,1,0,.892c-2.428.965-3.16,1.7-4.125,4.127A.479.479,0,0,1,128.258,47.354Zm0,0" transform="translate(-56.205 -17.062)"/><path class="m" d="M125.393,44.314a.379.379,0,0,1-.042-.021,11.419,11.419,0,0,1-1.663.787.48.48,0,0,0,0,.892c2.428.965,3.16,1.7,4.125,4.127a.479.479,0,0,0,.891,0,11.334,11.334,0,0,1,.8-1.689C128.547,46.006,127.81,45.275,125.393,44.314Zm0,0" transform="translate(-56.205 -20.11)"/><path class="n" d="M12.379,47.446a.478.478,0,0,1-.446-.3c-.965-2.429-1.7-3.162-4.126-4.127a.48.48,0,0,1,0-.892c2.428-.965,3.16-1.7,4.126-4.127a.479.479,0,0,1,.89,0c.965,2.429,1.7,3.162,4.125,4.127a.48.48,0,0,1,0,.892c-2.428.965-3.16,1.7-4.125,4.127A.478.478,0,0,1,12.379,47.446Zm0,0" transform="translate(-3.419 -17.105)"/><path class="l" d="M9.505,44.409l-.038-.019a11.525,11.525,0,0,1-1.659.784.48.48,0,0,0,0,.892c2.428.965,3.16,1.7,4.126,4.127a.479.479,0,0,0,.89,0,11.405,11.405,0,0,1,.8-1.681C12.661,46.1,11.925,45.371,9.505,44.409Zm0,0" transform="translate(-3.419 -20.154)"/><path class="l" d="M26.094,12.926a.388.388,0,0,1-.361-.245,4.762,4.762,0,0,0-3.345-3.347.389.389,0,0,1,0-.723,4.762,4.762,0,0,0,3.345-3.347.389.389,0,0,1,.722,0A4.763,4.763,0,0,0,29.8,8.611a.389.389,0,0,1,0,.723,4.763,4.763,0,0,0-3.345,3.347A.388.388,0,0,1,26.094,12.926Zm0,0" transform="translate(-10.087 -2.22)"/><path class="m" d="M27.384,13.077a4.685,4.685,0,0,0-3.153-3.268,6.9,6.9,0,0,1-1.843.984.389.389,0,0,0,0,.723,4.764,4.764,0,0,1,3.345,3.347.389.389,0,0,0,.722,0,7.189,7.189,0,0,1,.932-1.78Zm0,0" transform="translate(-10.087 -4.401)"/><path class="o" d="M13.768,100.665.453,115.316a1.532,1.532,0,0,0,0,2.174,1.552,1.552,0,0,0,2.186,0L17.37,104.247Zm0,0" transform="translate(0 -45.788)"/><path class="p" d="M15.152,102.041l-1.384-1.376L.453,115.316a1.532,1.532,0,0,0,0,2.174,1.552,1.552,0,0,0,2.186,0l.664-.6a1.529,1.529,0,0,1,.158-1.986Zm0,0" transform="translate(0 -45.788)"/><path class="a" d="M40.872,79.67a10.749,10.749,0,0,0-10.331-2.536.916.916,0,0,0-.692.826l-.582,8.824,4.45,4.426,8.873-.579a.916.916,0,0,0,.83-.687A10.605,10.605,0,0,0,40.872,79.67Zm0,0" transform="translate(-13.332 -34.898)"/><path class="b" d="M32.889,82.607l.318-4.815a1.009,1.009,0,0,1,.761-.91c.132-.033.264-.064.4-.093a12.127,12.127,0,0,0-3.822.346.914.914,0,0,0-.692.826l-.582,8.824.705.7Zm0,0" transform="translate(-13.332 -34.899)"/><path class="q" d="M39.689,89.293a1.2,1.2,0,0,0-1.639-.421l-5.066,2.995,3-5.027a1.2,1.2,0,0,0-2.054-1.228l-3.372,5.642,3.043,3.025,5.662-3.347A1.2,1.2,0,0,0,39.689,89.293Zm0,0" transform="translate(-13.922 -38.666)"/><path class="r" d="M29.768,102.034a.829.829,0,0,1-1.165,0l-5-4.975a.819.819,0,0,1,0-1.159l1.648-1.639a.829.829,0,0,1,1.165,0l5,4.975a.82.82,0,0,1,0,1.16Zm0,0" transform="translate(-10.641 -42.763)"/><path class="s" d="M25.591,98.1l1.844-1.834a.918.918,0,0,1,.737-.259l-1.759-1.75a.83.83,0,0,0-1.166,0L23.6,95.9a.818.818,0,0,0,0,1.159l1.724,1.715A.912.912,0,0,1,25.591,98.1Zm0,0" transform="translate(-10.641 -42.763)"/><path class="t" d="M92.712,83.386a1.568,1.568,0,0,1,1.115.46l2.805,2.79a7.45,7.45,0,0,0,2.506.042L95.058,82.62a1.562,1.562,0,0,1,0-2.216,1.583,1.583,0,0,1,2.231,0l5.015,4.987a7.446,7.446,0,0,0,1.287-1.168L100.752,81.4a1.561,1.561,0,0,1,0-2.216,1.583,1.583,0,0,1,2.231,0l2.155,2.144A7.387,7.387,0,1,0,91.93,83.593,1.571,1.571,0,0,1,92.712,83.386Zm0,0" transform="translate(-41.28 -32.765)"/><path class="u" d="M92.712,83.386a1.568,1.568,0,0,1,1.115.46l2.805,2.79a7.5,7.5,0,0,0,1.373.128,7.4,7.4,0,0,0,1.128-.089l-.384-.383a7.332,7.332,0,0,1,.929-14.025,7.388,7.388,0,0,0-9.058,7.153,7.287,7.287,0,0,0,1.309,4.174A1.571,1.571,0,0,1,92.712,83.386Zm0,0" transform="translate(-41.28 -32.765)"/><path class="j" d="M115.327,117.015a.9.9,0,0,1-.635-.261l-5.777-5.746a7.86,7.86,0,0,1-2.069.277,7.751,7.751,0,0,1-5.5-2.264L89.526,97.265a1.719,1.719,0,0,1,0-2.442,1.743,1.743,0,0,1,2.456,0l6.7,6.663,1-1L90.753,91.6a1.721,1.721,0,0,1,0-2.443,1.744,1.744,0,0,1,2.456,0l8.932,8.882,1-1L94.215,88.16a1.721,1.721,0,0,1,0-2.443,1.743,1.743,0,0,1,2.456,0L105.6,94.6l1.005-1-6.7-6.662a1.721,1.721,0,0,1,0-2.443,1.744,1.744,0,0,1,2.456,0l8.59,8.543V89.955a2.184,2.184,0,0,1,4.369,0v7.736a7.732,7.732,0,0,1,.861,6.089l5.772,5.741a.894.894,0,0,1,0,1.271l-6,5.963A.893.893,0,0,1,115.327,117.015Zm0,0" transform="translate(-40.549 -38.193)"/><path class="v" d="M109.9,118.1a7.886,7.886,0,0,1-2.069.276,7.75,7.75,0,0,1-5.5-2.264l-11.82-11.756a1.707,1.707,0,0,1-.5-1.085,1.727,1.727,0,0,0-.48.335,1.719,1.719,0,0,0,0,2.443l11.82,11.756a7.751,7.751,0,0,0,5.5,2.264,7.886,7.886,0,0,0,2.069-.276l5.777,5.745a.9.9,0,0,0,1.269,0l.7-.7Zm0,0" transform="translate(-40.549 -46.975)"/></g></svg>`,
  },
  Travel: {
    bgcolor: "#C43699",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="77" height="73.824" viewBox="0 0 77 73.824"><defs><style>.a{fill:#23a8fe;}.b{fill:#0193fa;}.c{fill:#43cb8e;}.d{fill:#00ba66;}.e{fill:#fee55a;}.f{fill:#ffd301;}.g{fill:#b1dbfc;}.h{fill:#8bcaff;}.i{fill:#ff656f;}.j{fill:#ff4756;}.k{fill:#dfebfa;}</style></defs><path class="a" d="M90.426,40.271a3.55,3.55,0,0,0-1.217-3.386,3.466,3.466,0,0,0-2.165-.747,3.353,3.353,0,0,0-1.379.29c-.153.069-.3.15-.444.228a4.011,4.011,0,0,1-.662.311c-1.042.34-2.044-.219-3.1-.812a11.282,11.282,0,0,0-1.462-.728,9.493,9.493,0,0,0-2.812-.459,12.617,12.617,0,0,1-2.083-.243,3.8,3.8,0,0,1-2.4-1.746,1.834,1.834,0,0,1-.139-1.533,3.655,3.655,0,0,1,.568-.914,4.575,4.575,0,0,0,.553-.85,4.528,4.528,0,0,0,.232-2.182,6.787,6.787,0,0,1,.02-1.443,6.673,6.673,0,0,1,.892-2.118,5.626,5.626,0,0,0,.951-2.643,5.659,5.659,0,0,0-.242-1.463c-.058-.226-.118-.459-.162-.688a5.41,5.41,0,0,1,.26-2.891l.085-.132a36.392,36.392,0,0,0-10.9-2.685c-.366,1.051-1.405,2.157-1.83,3.174-.2.485-.254,1.022-.432,1.516a1.491,1.491,0,0,1-1.062,1.054,1.821,1.821,0,0,0-.473.07c-.4.174-.366.753-.552,1.154a1.316,1.316,0,0,1-1.13.68,3.853,3.853,0,0,1-1.353-.242,2.72,2.72,0,0,1-1.523-.868c-.188-.269-.273-.6-.44-.879a4.368,4.368,0,0,0-1.284-1.153,8.62,8.62,0,0,1-2.451-3.419,36.292,36.292,0,0,0-6.34,2.334l.085.128A1.81,1.81,0,0,0,46.7,18.23L49.382,20.4a1.5,1.5,0,0,1,.56,1.174v3.076a1.811,1.811,0,0,0,1.8,1.816H53a1.5,1.5,0,0,1,1.492,1.5v1.456a1.514,1.514,0,0,1-.6,1.208l-7.366,5.5a1.493,1.493,0,0,1-.888.3H41.078a1.811,1.811,0,0,0-1.8,1.816v3.028a1.812,1.812,0,0,0,.528,1.284L43,45.771a1.783,1.783,0,0,0,1.274.532h4.494a1.5,1.5,0,0,1,1.492,1.5V49.15a1.811,1.811,0,0,0,1.8,1.816h3.137a1.5,1.5,0,0,1,1.492,1.5,1.811,1.811,0,0,0,1.8,1.816h4.078a1.5,1.5,0,0,1,1.492,1.5v4.346a1.5,1.5,0,0,1-.554,1.169l-6.149,5.011a1.814,1.814,0,0,0-.669,1.412v2.124a1.515,1.515,0,0,1-.473,1.1L53.9,73.129a1.829,1.829,0,0,0-.571,1.326v4.734a1.5,1.5,0,0,1-1.492,1.5H49.391a1.5,1.5,0,0,1-1.492-1.5v-3.02a1.836,1.836,0,0,0-.179-.788l-1.713-3.586a1.522,1.522,0,0,1-.148-.652V64.309a1.826,1.826,0,0,0-.749-1.474l-6.473-4.7a1.511,1.511,0,0,1-.62-1.22V52.19a1.517,1.517,0,0,1,.188-.731l.342-.619a1.833,1.833,0,0,0-.306-2.173l-5.684-5.682a1.52,1.52,0,0,1-.441-1.068V38.3a1.828,1.828,0,0,0-.584-1.338l-2.8-2.589-.124-.1a37.145,37.145,0,0,0,7.146,42.035,36.413,36.413,0,0,0,51.786,0,37.167,37.167,0,0,0,2.681-3.016h-.2A18.445,18.445,0,0,1,87.3,70.95a13.1,13.1,0,0,1-3.346-7c-.065-.455-.108-.923-.149-1.376a15.5,15.5,0,0,0-.343-2.39A15.766,15.766,0,0,0,82.206,57.1a11.366,11.366,0,0,1-1.388-3.946A5.733,5.733,0,0,1,83.207,48a11.391,11.391,0,0,1,3.229-1.363,12.678,12.678,0,0,0,3.091-1.253,1.476,1.476,0,0,0,.625-.642,1.6,1.6,0,0,0-.145-1.22,3.733,3.733,0,0,1-.166-.483,3.184,3.184,0,0,1,.286-1.788,7.306,7.306,0,0,0,.3-.984Z" transform="translate(-21.267 -13.295)"/><path class="b" d="M49.39,197.31a1.5,1.5,0,0,1-1.492-1.5v-.225a37.023,37.023,0,0,1-13.3-33.934L32.558,159.6a1.52,1.52,0,0,1-.441-1.068v-3.618a1.828,1.828,0,0,0-.584-1.338l-2.8-2.589-.124-.1a37.145,37.145,0,0,0,7.146,42.035,36.378,36.378,0,0,0,30.5,10.518,36.284,36.284,0,0,1-16.048-6.132Z" transform="translate(-21.267 -129.912)"/><path class="b" d="M170.422,20.621a36.291,36.291,0,0,0-6.341,2.331l.085.128a1.81,1.81,0,0,0,.668,1.246l2.628,2.12a36.328,36.328,0,0,1,4.779-2.967A9.876,9.876,0,0,1,170.422,20.621Z" transform="translate(-139.405 -19.391)"/><path class="c" d="M82.412,72.636H78.334a1.654,1.654,0,0,1-1.647-1.66,1.654,1.654,0,0,0-1.647-1.66H71.9a1.653,1.653,0,0,1-1.647-1.66V66.311a1.654,1.654,0,0,0-1.647-1.66H64.116a1.64,1.64,0,0,1-1.164-.486L59.76,60.948a1.667,1.667,0,0,1-.482-1.174V56.747a1.654,1.654,0,0,1,1.647-1.66h4.554a1.638,1.638,0,0,0,.98-.326l7.366-5.5a1.665,1.665,0,0,0,.667-1.334V46.47a1.654,1.654,0,0,0-1.647-1.66H71.59a1.653,1.653,0,0,1-1.647-1.66V40.075a1.665,1.665,0,0,0-.618-1.3L66.64,36.613a1.665,1.665,0,0,1-.618-1.3v-.07A36.908,36.908,0,0,0,48.391,52.915l2.883,2.667a1.666,1.666,0,0,1,.534,1.223v3.618A1.667,1.667,0,0,0,52.3,61.6l5.684,5.682a1.67,1.67,0,0,1,.279,1.986l-.342.619a1.67,1.67,0,0,0-.208.807v4.727a1.664,1.664,0,0,0,.685,1.347l6.473,4.7a1.664,1.664,0,0,1,.685,1.347v6.834a1.669,1.669,0,0,0,.163.72l1.713,3.586a1.67,1.67,0,0,1,.163.72v3.02a1.654,1.654,0,0,0,1.647,1.66h2.451a1.653,1.653,0,0,0,1.647-1.66V92.96a1.666,1.666,0,0,1,.522-1.212l2.309-2.178a1.666,1.666,0,0,0,.522-1.212V86.234a1.665,1.665,0,0,1,.611-1.291l6.149-5.011a1.665,1.665,0,0,0,.611-1.291V74.3A1.654,1.654,0,0,0,82.412,72.636Z" transform="translate(-41.114 -31.8)"/><path class="d" d="M66.02,35.327v-.068A36.9,36.9,0,0,0,48.389,52.925l2.883,2.667a1.666,1.666,0,0,1,.533,1.223v3.618a1.667,1.667,0,0,0,.487,1.179l2.129,2.128A36.942,36.942,0,0,1,69.3,38.77l-2.662-2.146A1.665,1.665,0,0,1,66.02,35.327Z" transform="translate(-41.112 -31.81)"/><path class="c" d="M365.286,64.829a36.947,36.947,0,0,0-10.725-26.1,36.485,36.485,0,0,0-11.995-8.058,5.624,5.624,0,0,0-.325,3.126,10.917,10.917,0,0,1,.4,2.119c-.017,1.712-1.567,3.048-1.841,4.738-.193,1.192.263,2.489-.24,3.585-.293.639-.88,1.115-1.125,1.775-.577,1.554,1.043,3.112,2.647,3.486s3.334.112,4.875.7c1.575.6,3.067,2.064,4.668,1.542a11.542,11.542,0,0,0,1.122-.544,3.324,3.324,0,0,1,3.384.436,3.387,3.387,0,0,1,1.162,3.233c-.194.959-.811,1.888-.582,2.84.13.544.531,1.09.318,1.606a1.329,1.329,0,0,1-.565.569c-1.941,1.222-4.444,1.309-6.327,2.62a5.929,5.929,0,0,0-2.455,5.3c.231,2.513,2.035,4.6,2.65,7.046a36.555,36.555,0,0,1,.488,3.75,13.244,13.244,0,0,0,3.387,7.089,19.035,19.035,0,0,0,2.867,2.447,36.982,36.982,0,0,0,8.207-23.3Z" transform="translate(-288.286 -27.917)"/><path class="d" d="M351.627,51.738a11.545,11.545,0,0,0,1.122-.544,3.324,3.324,0,0,1,3.384.436,3.387,3.387,0,0,1,1.162,3.233c-.194.959-.811,1.888-.582,2.84.13.544.531,1.09.318,1.606-.006.015-.014.029-.021.043,1.7-.779,3.668-1.018,5.262-2.021a1.33,1.33,0,0,0,.565-.569c.213-.516-.188-1.063-.318-1.606-.228-.952.389-1.88.582-2.84,0-.016,0-.033.008-.049q-.608-1.7-1.386-3.342a3.331,3.331,0,0,0-3.168-.278,11.535,11.535,0,0,1-1.122.544c-1.6.522-3.093-.945-4.668-1.542-1.541-.584-3.271-.322-4.875-.7s-3.224-1.932-2.647-3.486c.245-.66.832-1.136,1.125-1.775.5-1.1.047-2.393.24-3.585.254-1.565,1.6-2.828,1.812-4.366a36.252,36.252,0,0,0-5.852-3.071,5.623,5.623,0,0,0-.325,3.126,10.909,10.909,0,0,1,.4,2.12c-.017,1.712-1.567,3.048-1.84,4.738-.193,1.192.263,2.489-.24,3.585-.293.639-.88,1.115-1.125,1.775-.577,1.554,1.043,3.112,2.647,3.486s3.334.112,4.875.7c1.575.6,3.067,2.064,4.668,1.542Z" transform="translate(-288.287 -27.918)"/><path class="d" d="M407.153,249.863a13.244,13.244,0,0,1-3.387-7.089,36.554,36.554,0,0,0-.488-3.75c-.615-2.446-2.419-4.533-2.65-7.046a5.956,5.956,0,0,1,1.829-4.786c-1.713.713-3.65.971-5.179,2.035a5.929,5.929,0,0,0-2.455,5.3c.231,2.513,2.035,4.6,2.65,7.046a36.539,36.539,0,0,1,.488,3.75,13.244,13.244,0,0,0,3.387,7.089,19.026,19.026,0,0,0,2.867,2.447,36.758,36.758,0,0,0,3.228-4.692C407.345,250.065,407.248,249.965,407.153,249.863Z" transform="translate(-335.426 -194.647)"/><path class="c" d="M216.16,17.5c.179-.495.229-1.031.432-1.516.433-1.035,1.5-2.162,1.851-3.23.011-.032.018-.065.027-.1q-1.6-.141-3.213-.144v0a36.518,36.518,0,0,0-9.426,1.238,8.77,8.77,0,0,0,2.512,3.559,4.366,4.366,0,0,1,1.284,1.153c.167.282.253.61.44.879a2.721,2.721,0,0,0,1.523.868,3.853,3.853,0,0,0,1.353.242,1.316,1.316,0,0,0,1.131-.68c.185-.4.149-.98.552-1.154a1.821,1.821,0,0,1,.473-.07A1.491,1.491,0,0,0,216.16,17.5Z" transform="translate(-174.876 -12.51)"/><path class="d" d="M218.47,12.653c-1.086-.1-2.163-.144-3.213-.144v0a36.712,36.712,0,0,0-9.426,1.238,10.228,10.228,0,0,0,1.781,2.895,36.3,36.3,0,0,1,10.721-3.611A2.354,2.354,0,0,0,218.47,12.653Z" transform="translate(-174.876 -12.509)"/><path class="e" d="M39.737,263.024l-2.2-2.221a1.8,1.8,0,0,1-.484-.9,227.849,227.849,0,0,1-20.142,17.717c-5.4,4.119-8.665,5.955-10.523,6.773a.388.388,0,0,1-.508-.514A38.073,38.073,0,0,1,9,278.354c-.044-.074-.087-.149-.131-.224-.726-1.295-2.522-5.168-2.522-5.168a56.4,56.4,0,0,0-4.994,8.221c-.7,1.507-2.569,5.509-.164,7.933A4.048,4.048,0,0,0,4.21,290.3c2.992,0,7.461-2.3,14.02-7.12a221.325,221.325,0,0,0,22.591-19.639A1.777,1.777,0,0,1,39.737,263.024Z" transform="translate(-0.001 -222.4)"/><path class="f" d="M70.382,260.8a1.8,1.8,0,0,1-.484-.9,227.85,227.85,0,0,1-20.142,17.717c-2.791,2.129-5.011,3.648-6.762,4.732h0a32.26,32.26,0,0,1-3.761,2.042.386.386,0,0,1-.54-.369s-.573,2.591,3.368.76c1.858-.818,5.124-2.654,10.523-6.773A222.229,222.229,0,0,0,71.275,261.7Z" transform="translate(-32.85 -222.4)"/><path class="f" d="M4.018,362.588c-2.405-2.424-.538-6.426.164-7.933a47.669,47.669,0,0,1,3.432-5.937c-.653-1.355-1.265-2.674-1.265-2.674a56.4,56.4,0,0,0-4.994,8.221c-.7,1.507-2.569,5.509-.164,7.933a4.048,4.048,0,0,0,3.018,1.186,6.661,6.661,0,0,0,.82-.054A3.906,3.906,0,0,1,4.018,362.588Z" transform="translate(0 -295.482)"/><path class="g" d="M341.428,208.518l-5.694-12.723-5.97,5.765,8.329,9.806a.832.832,0,0,0,1.227.048l1.936-1.952a.849.849,0,0,0,.171-.944Z" transform="translate(-280.171 -168.01)"/><path class="h" d="M340.679,227.509l-8.376-9.861-2.539,2.452,8.329,9.806a.832.832,0,0,0,1.227.048L341.256,228a.84.84,0,0,0,.142-.192A.855.855,0,0,1,340.679,227.509Z" transform="translate(-280.171 -186.55)"/><path class="g" d="M245.339,128.052l-12.622-5.74a.832.832,0,0,0-.936.172l-1.936,1.952a.848.848,0,0,0,.048,1.237l9.728,8.4Z" transform="translate(-195.07 -105.604)"/><path class="h" d="M231.976,125.287a.869.869,0,0,1-.291-.781l-1.84,1.855a.848.848,0,0,0,.048,1.237l9.728,8.4,2.146-2.258Z" transform="translate(-195.069 -107.528)"/><path class="i" d="M281.711,261.634l-1.348-6.972-4.081,3.941a1.775,1.775,0,0,1-.813.448l2.348,4.583a.833.833,0,0,0,1.184.33l2.329-1.452a.846.846,0,0,0,.381-.879Z" transform="translate(-234.041 -217.953)"/><path class="i" d="M218.63,218.463l3.91-4.114-6.917-1.358a.834.834,0,0,0-.872.384l-1.441,2.347a.847.847,0,0,0,.328,1.193l4.547,2.367A1.8,1.8,0,0,1,218.63,218.463Z" transform="translate(-181.124 -182.585)"/><path class="j" d="M279.345,259.328a1.254,1.254,0,0,1,.274-1.48l.007-.007,1.138-1.1-.4-2.081-4.081,3.941a1.775,1.775,0,0,1-.813.448l2.348,4.583a.833.833,0,0,0,1.184.33l2.061-1.286Z" transform="translate(-234.04 -217.952)"/><path class="j" d="M216.985,216.156a.847.847,0,0,1-.328-1.193l.969-1.578-2-.393a.834.834,0,0,0-.872.384l-1.441,2.347a.847.847,0,0,0,.328,1.193l4.547,2.367a1.8,1.8,0,0,1,.445-.82l.922-.97Z" transform="translate(-181.125 -182.586)"/><path class="k" d="M271.384,112.372a2.1,2.1,0,0,0-1.586-1.6,6.013,6.013,0,0,0-5.686,1.73l-18.261,19.213a1.823,1.823,0,0,0,.027,2.536l2.213,2.23a1.788,1.788,0,0,0,2.516.027L269.667,118.1A6.123,6.123,0,0,0,271.384,112.372Z" transform="translate(-208.453 -95.752)"/><path class="g" d="M248.356,136.643a1.823,1.823,0,0,1-.027-2.536l18.261-19.213a6.017,6.017,0,0,1,4.9-1.853,6.172,6.172,0,0,0-.108-.666,2.1,2.1,0,0,0-1.586-1.6,6.014,6.014,0,0,0-5.686,1.73L245.85,131.719a1.823,1.823,0,0,0,.027,2.536l2.212,2.23a1.8,1.8,0,0,0,.425.318Z" transform="translate(-208.452 -95.754)"/></svg>`,
  },
  Commercial: {
    bgcolor: "#935FF0",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="85.218" height="86.486" viewBox="0 0 85.218 86.486"><defs><style>.a{fill:#dfe2ea;}.b{fill:#53515e;}.c{fill:#474756;}.d{fill:#ffe1b3;}.e{fill:#f0c891;}.f{fill:#b28362;}.g{fill:#c7cad3;}.h{fill:#fad7a5;}.i{fill:#b48765;}.j{fill:#966d50;}.k{fill:#846047;}.l{fill:#ff9ea4;}.m{fill:#ff7b97;}.n{fill:#e9ebf2;}.o{fill:#fff;}</style></defs><g transform="translate(-3.754 0)"><path class="a" d="M194.1,125.886l-3.3-.866a19.186,19.186,0,0,0-.344-3.791l3.087-1.449a1.134,1.134,0,0,0,.584-1.413l-1.107-3.047a1.134,1.134,0,0,0-1.355-.709l-3.3.872a19.435,19.435,0,0,0-2.05-2.988l2-2.767a1.134,1.134,0,0,0-.174-1.519l-2.445-2.129a1.134,1.134,0,0,0-1.529.036l-2.462,2.359a19.181,19.181,0,0,0-4.051-1.912l.259-3.4a1.134,1.134,0,0,0-.943-1.2l-3.2-.537a1.134,1.134,0,0,0-1.284.83l-.866,3.3a19.2,19.2,0,0,0-3.791.344l-1.022-2.177-.427-.909a1.134,1.134,0,0,0-1.413-.584l-3.047,1.107a1.134,1.134,0,0,0-.709,1.355l.872,3.3a19.448,19.448,0,0,0-2.988,2.05l-2.767-2a1.134,1.134,0,0,0-1.519.174l-2.129,2.445a1.134,1.134,0,0,0,.036,1.529l2.359,2.462a19.18,19.18,0,0,0-1.912,4.052l-3.4-.259a1.134,1.134,0,0,0-1.2.943l-.537,3.2a1.134,1.134,0,0,0,.83,1.284l3.3.866a19.186,19.186,0,0,0,.344,3.791l-3.087,1.449a1.134,1.134,0,0,0-.584,1.413l1.107,3.047a1.134,1.134,0,0,0,1.355.709l3.3-.873a19.438,19.438,0,0,0,2.051,2.988l-2,2.767a1.134,1.134,0,0,0,.174,1.519l2.445,2.129a1.134,1.134,0,0,0,1.529-.036l2.462-2.359a19.18,19.18,0,0,0,4.052,1.912l-.259,3.4a1.134,1.134,0,0,0,.943,1.2l3.2.537a1.134,1.134,0,0,0,1.284-.83l.866-3.3a19.185,19.185,0,0,0,3.791-.344l1.449,3.087a1.133,1.133,0,0,0,1.414.584l3.047-1.107a1.134,1.134,0,0,0,.709-1.355l-.872-3.3a19.448,19.448,0,0,0,2.988-2.05l2.767,2a1.134,1.134,0,0,0,1.519-.174l2.129-2.445a1.134,1.134,0,0,0-.036-1.529l-2.359-2.462a19.18,19.18,0,0,0,1.912-4.052l3.4.259a1.134,1.134,0,0,0,1.2-.943l.537-3.2A1.134,1.134,0,0,0,194.1,125.886Zm-8.97,1.282a13.7,13.7,0,0,1-17.6,10.8l-3.252-1.508a13.695,13.695,0,1,1,20.85-9.292Z" transform="translate(-119.886 -84.276)"/><path class="b" d="M263.739,39.848a11.193,11.193,0,0,0,2.892-10.841.683.683,0,0,0-1.143-.31l-5.34,5.34a1.74,1.74,0,0,1-2.461,0l-3.978-3.978a1.74,1.74,0,0,1,0-2.461l5.34-5.34a.683.683,0,0,0-.31-1.143,11.2,11.2,0,0,0-13.413,14.733L220,59.009a6.185,6.185,0,0,0-.2,8.937h0a6.185,6.185,0,0,0,8.966-.231l22.9-25.385A11.2,11.2,0,0,0,263.739,39.848Z" transform="translate(-178.046 -17.227)"/><g transform="translate(39.943 3.503)"><path class="c" d="M420.631,20.809l-2.3,2.3a1.74,1.74,0,0,0,0,2.461l1.745,1.745,5.051-5.052a.683.683,0,0,0-.307-1.142A11.27,11.27,0,0,0,420.631,20.809Z" transform="translate(-384.064 -20.738)"/><path class="c" d="M265.494,66.918h0a11.2,11.2,0,0,1-15.284,9.14L235.319,92.567a11.357,11.357,0,0,1-10.668,3.528l-.992-.2a6.648,6.648,0,0,1-1.612-.533l-2.042,1.867c-1.625,1.486-1.885,4.2-1.992,4.079a6.167,6.167,0,0,0,1.792,4.858h0a6.185,6.185,0,0,0,8.966-.231l5.923-6.567h0l16.973-18.817a11.2,11.2,0,0,0,14.97-13.324A.684.684,0,0,0,265.494,66.918Zm-43.478,36.506.023.024-.043,0Z" transform="translate(-217.994 -58.951)"/></g><path class="d" d="M79.206,208.629l-5.984-1.172c-2.687-.526-4.588-2.532-4.588-4.841V196.94H55.241v5.677c0,2.31-1.9,4.315-4.588,4.841l-5.984,1.172c-4.905.96-8.374,4.621-8.374,8.837V223.9H87.579v-6.431C87.58,213.25,84.111,209.59,79.206,208.629Z" transform="translate(-27.044 -163.674)"/><path class="e" d="M154.912,204.552h0a12.076,12.076,0,0,0,6.928-2.172v-5.44H148.448v5.677c0,.023,0,.047,0,.07A12.076,12.076,0,0,0,154.912,204.552Z" transform="translate(-120.251 -163.674)"/><path class="d" d="M127.03,56.692h0A12.134,12.134,0,0,1,114.9,44.558v-9.92A12.134,12.134,0,0,1,127.03,22.5h0a12.134,12.134,0,0,1,12.134,12.134v9.92A12.134,12.134,0,0,1,127.03,56.692Z" transform="translate(-92.368 -18.704)"/><path class="f" d="M166.45,173.445a5.269,5.269,0,0,1-3.75-1.554,1.267,1.267,0,0,1,1.792-1.792,2.77,2.77,0,0,0,3.918,0,1.267,1.267,0,0,1,1.792,1.792A5.269,5.269,0,0,1,166.45,173.445Z" transform="translate(-131.788 -141.059)"/><path class="g" d="M237.934,115.152a12.263,12.263,0,0,0,.073-1.323V109.4q-.64.079-1.27.2l-1.022-2.177-.427-.909a1.134,1.134,0,0,0-1.414-.584l-.679.247v5.609a12.074,12.074,0,0,1-2.277,7.072A13.732,13.732,0,0,1,237.934,115.152Z" transform="translate(-188.793 -87.975)"/><path class="h" d="M154.286,23.728a12.118,12.118,0,0,1,5.085,9.877v9.92a12.134,12.134,0,0,1-12.134,12.134h0A12.2,12.2,0,0,1,145,55.452a12.079,12.079,0,0,0,7.048,2.256h0a12.134,12.134,0,0,0,12.134-12.134v-9.92A12.137,12.137,0,0,0,154.286,23.728Z" transform="translate(-117.388 -19.72)"/><path class="i" d="M101.35,45.778A14.269,14.269,0,0,0,99.266,54.9a14.639,14.639,0,0,0,3.427-1.315,16.348,16.348,0,0,0,3.5-2.595h0Z" transform="translate(-79.307 -38.046)"/><path class="j" d="M140.1,14.6a21.856,21.856,0,0,0-5.54-10.172A14.837,14.837,0,0,0,125.23,0a15.25,15.25,0,0,0-9.783,3.586,16.25,16.25,0,0,0-3.422,4.142c4.219,6.037,10.549,9.876,17.627,9.876,1.743,0,5.385-.532,7.125-1.674" transform="translate(-89.982 0)"/><path class="k" d="M181.988,4.427A14.836,14.836,0,0,0,172.653,0a13.562,13.562,0,0,0-3.566.434,15.779,15.779,0,0,1,6.668,3.989A21.856,21.856,0,0,1,181.3,14.6l-3.327,1.336a12.082,12.082,0,0,1-4.212,1.387,19.389,19.389,0,0,0,3.32.286c1.743,0,5.385-.532,7.125-1.674l3.327-1.336A21.857,21.857,0,0,0,181.988,4.427Z" transform="translate(-137.405 0)"/><g transform="translate(28.504 19.324)"><circle class="b" cx="1.345" cy="1.345" r="1.345"/><circle class="b" cx="1.345" cy="1.345" r="1.345" transform="translate(9.145)"/></g><path class="l" d="M87.58,264.146c0-4.215-3.47-7.874-8.374-8.834l-5.984-1.172a6.432,6.432,0,0,1-2.461-1.03,13.419,13.419,0,0,1-17.646,0,6.432,6.432,0,0,1-2.461,1.03l-5.984,1.172c-4.905.96-8.374,4.621-8.374,8.837v6.431h0v11.715a10.969,10.969,0,0,0,3.085,7.626l5.441,5.625h35.1l4.915-6.024a12.2,12.2,0,0,0,2.746-7.71V264.148A.01.01,0,0,0,87.58,264.146Z" transform="translate(-27.045 -210.355)"/><path class="g" d="M294.547,299.287l0,5.609a19.157,19.157,0,0,0,2.36-.3l1.449,3.087a1.133,1.133,0,0,0,1.414.584l3.047-1.107a1.134,1.134,0,0,0,.709-1.355l-.872-3.3q.831-.463,1.611-1.006V298a7.758,7.758,0,0,0-.691-3.185A13.712,13.712,0,0,1,294.547,299.287Z" transform="translate(-241.673 -245.015)"/><g transform="translate(9.251 47.311)"><path class="m" d="M39.493,280.368a8.4,8.4,0,0,0-3.2,6.433v6.431h0v11.715a10.969,10.969,0,0,0,3.085,7.626l5.441,5.625h1.193V287.29C46.015,283.887,42.812,281.046,39.493,280.368Z" transform="translate(-36.296 -280.32)"/><path class="m" d="M292.084,304.228V286.563a8.415,8.415,0,0,0-3.254-6.479c-3.38.58-6.465,3.479-6.465,6.97l.01,30.908h2.047l4.915-6.024A12.2,12.2,0,0,0,292.084,304.228Z" transform="translate(-240.799 -280.084)"/></g><path class="n" d="M113.006,367.489H80.57a2.341,2.341,0,0,1-2.341-2.341v-22.6a2.876,2.876,0,0,1,2.876-2.876h31.365a2.876,2.876,0,0,1,2.876,2.876v22.6A2.341,2.341,0,0,1,113.006,367.489Z" transform="translate(-61.895 -282.3)"/><path class="a" d="M112.471,339.677h-3.009v3.28a19.5,19.5,0,0,1-19.5,19.5H78.229v2.692a2.341,2.341,0,0,0,2.341,2.341h32.436a2.341,2.341,0,0,0,2.341-2.341v-22.6A2.876,2.876,0,0,0,112.471,339.677Z" transform="translate(-61.895 -282.3)"/><circle class="o" cx="3.151" cy="3.151" r="3.151" transform="translate(31.742 68.132)"/><path class="j" d="M64.128,499.246H5.05a1.3,1.3,0,0,1,0-2.592H64.128a1.3,1.3,0,0,1,0,2.592Z" transform="translate(0 -412.76)"/></g></svg>`,
  },
  Art: {
    bgcolor: "#F46E56",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="85.605" height="80.947" viewBox="0 0 85.605 80.947"><defs><style>.a{fill:#ffd592;}.b{fill:#d644a4;}.c,.o{opacity:0.1;}.d{fill:#ff8828;}.e{fill:#22e0c3;}.f{fill:#4351b5;}.g{fill:#543b93;}.h{fill:#fff;}.i{fill:#ef3e3b;}.j{fill:#38ccaa;}.k{fill:#b59472;}.l{fill:#967659;}.m{fill:#e5e5e5;}.n{fill:#d1d3d4;}</style></defs><g transform="translate(0 -13.928)"><path class="a" d="M65.159,107.827a38.029,38.029,0,1,1-2.083-55.8,6.6,6.6,0,0,1,.359,9.684l-6.316,6.3a4.763,4.763,0,1,0,6.747,6.726l1.075-1.072A6.63,6.63,0,0,1,76.235,77.8,38.028,38.028,0,0,1,65.159,107.827Z" transform="translate(0 -24.1)"/><path class="b" d="M262.032,95.507a6.108,6.108,0,1,1-8.632.513A6.082,6.082,0,0,1,262.032,95.507Z" transform="translate(-209.745 -66.659)"/><path class="c" d="M256.693,104.628a6.1,6.1,0,0,1,2.68-10.5A6.1,6.1,0,1,0,259.35,106,6.08,6.08,0,0,1,256.693,104.628Z" transform="translate(-209.743 -66.661)"/><path class="d" d="M140.533,92.648a6.1,6.1,0,1,1-5.748,6.448A6.1,6.1,0,0,1,140.533,92.648Z" transform="translate(-112.241 -65.55)"/><path class="c" d="M137.41,99.1a6.108,6.108,0,0,1,4.8-6.317,6.1,6.1,0,1,0-.011,11.909A6.093,6.093,0,0,1,137.41,99.1Z" transform="translate(-112.242 -65.55)"/><path class="e" d="M52.5,176.288a6.1,6.1,0,1,1,.5,8.606A6.128,6.128,0,0,1,52.5,176.288Z" transform="translate(-42.435 -133.507)"/><path class="c" d="M55.84,184.9A6.1,6.1,0,0,1,58.5,174.407a6.1,6.1,0,1,0-.021,11.859A6.086,6.086,0,0,1,55.84,184.9Z" transform="translate(-42.434 -133.51)"/><path class="f" d="M49.493,297.424a6.115,6.115,0,1,1,6.461,5.723A6.111,6.111,0,0,1,49.493,297.424Z" transform="translate(-41.209 -230.717)"/><path class="c" d="M52.227,297.424a6.108,6.108,0,0,1,4.745-6.3A6.1,6.1,0,1,0,56.956,303,6.093,6.093,0,0,1,52.227,297.424Z" transform="translate(-41.21 -230.718)"/><path class="g" d="M133.277,385.1a6.108,6.108,0,1,1,8.633-.514A6.084,6.084,0,0,1,133.277,385.1Z" transform="translate(-109.286 -300.241)"/><path class="h" d="M254.774,387.96a6.1,6.1,0,1,1,5.747-6.448A6.1,6.1,0,0,1,254.774,387.96Z" transform="translate(-206.787 -301.35)"/><path class="i" d="M342.81,304.322a6.1,6.1,0,1,1-.5-8.606A6.128,6.128,0,0,1,342.81,304.322Z" transform="translate(-276.597 -233.394)"/><path class="c" d="M136.1,385.1a6.1,6.1,0,0,1,2.664-10.492,6.1,6.1,0,1,0-.022,11.864A6.077,6.077,0,0,1,136.1,385.1Z" transform="translate(-109.286 -300.242)"/><path class="c" d="M251.133,382.238a6.109,6.109,0,0,1,4.7-6.295,6.1,6.1,0,1,0-.019,11.863A6.094,6.094,0,0,1,251.133,382.238Z" transform="translate(-206.787 -301.35)"/><path class="c" d="M337,304.838a6.1,6.1,0,0,1,2.664-10.492,6.1,6.1,0,1,0-.022,11.864A6.09,6.09,0,0,1,337,304.838Z" transform="translate(-276.595 -233.396)"/><rect class="e" width="8.985" height="4.302" transform="translate(68.89 27.601) rotate(-45)"/><g transform="translate(53.887 13.928)"><path class="j" d="M449.1,24.953l7.158-7.158a2.371,2.371,0,0,0,.268-3.31,2.371,2.371,0,0,0-3.311.268l-7.158,7.157Z" transform="translate(-425.369 -13.928)"/><path class="j" d="M322.3,103.227l.289.289c-.082.09-.164.179-.246.27l5.328,5.328c.09-.082.179-.165.27-.246l.155.155q6.95-7.668,13.2-15.951l-3.043-3.042Q329.973,96.267,322.3,103.227Z" transform="translate(-322.3 -77.305)"/></g><path class="k" d="M185.069,250.584a.293.293,0,0,1,.069.293c-.666,2.147-2.37,4.1-5.209,5.958a59.8,59.8,0,0,1-8.084,4.138,52.419,52.419,0,0,0-5.589,2.758.289.289,0,0,1-.4-.4,52.447,52.447,0,0,0,2.758-5.589,59.786,59.786,0,0,1,4.138-8.084c1.862-2.839,3.811-4.543,5.958-5.209a.291.291,0,0,1,.293.069Z" transform="translate(-138.087 -191.967)"/><path class="c" d="M170.686,257.74a59.758,59.758,0,0,1,4.138-8.084,13.313,13.313,0,0,1,4.654-4.661l-.476-.476a.291.291,0,0,0-.293-.069c-2.147.665-4.1,2.37-5.958,5.209a59.792,59.792,0,0,0-4.138,8.084,52.421,52.421,0,0,1-2.758,5.589.289.289,0,0,0,.4.4c.618-.381,1.33-.759,2.1-1.14C169.121,261.217,169.885,259.522,170.686,257.74Z" transform="translate(-138.086 -191.968)"/><g transform="translate(37.519 53.328)"><path class="l" d="M252.331,264.99l-2.1,2.1a1.368,1.368,0,0,0,1.934,1.934l2.1-2.1Z" transform="translate(-245.58 -262.414)"/><path class="l" d="M228.574,249.582l-3.775,3.774a1.368,1.368,0,1,0,1.934,1.934l3.775-3.775Z" transform="translate(-224.398 -249.582)"/></g><path class="m" d="M250.659,202.487q5.038-4.742,9.78-9.784l-6.042-6.042q-5.037,4.742-9.785,9.78Z" transform="translate(-203.715 -143.853)"/><path class="n" d="M248.2,181.071l6.077,6.076q6.286-5.963,12.109-12.389l-5.8-5.8Q254.164,174.78,248.2,181.071Z" transform="translate(-206.699 -129.112)"/><g transform="translate(44.258 41.812)"><path class="m" d="M270.883,217.355q1.328-1.3,2.632-2.629l-6.177-6.177q-1.325,1.306-2.629,2.632Z" transform="translate(-264.709 -203.893)"/><path class="m" d="M299.459,189.378q1.289-1.343,2.554-2.707l-5.97-5.97q-1.363,1.267-2.706,2.554Z" transform="translate(-288.551 -180.702)"/></g><path class="c" d="M244.615,115.966l1.373,1.373A229.209,229.209,0,0,1,274.927,91.4l-1.373-1.372A229.17,229.17,0,0,0,244.615,115.966Z" transform="translate(-203.716 -63.377)"/><path class="m" d="M249.937,239.239a1.328,1.328,0,0,1-1.879,0l-6.379-6.379a1.329,1.329,0,0,1,1.879-1.879l6.379,6.379A1.328,1.328,0,0,1,249.937,239.239Z" transform="translate(-200.947 -180.439)"/><path class="c" d="M241.678,230.982a1.329,1.329,0,0,0,0,1.879l1.491,1.49a1.329,1.329,0,1,1,1.879-1.879l-1.49-1.49A1.329,1.329,0,0,0,241.678,230.982Z" transform="translate(-200.947 -180.44)"/><g class="o" transform="translate(0 18.767)"><path d="M16.032,107.861A38.08,38.08,0,0,1,40.663,42.947q-1.9-.119-3.82-.054a38.054,38.054,0,1,0,3.723,76A38.036,38.036,0,0,1,16.032,107.861Z" transform="translate(-0.002 -42.87)"/></g></g></svg>
`,
  },
  QuickJobs: {
    bgcolor: "#935FF0",
    image: `<svg xmlns="http://www.w3.org/2000/svg" width="91.54" height="78.321" viewBox="0 0 91.54 98.321"><defs><style>.a{fill:#7148db;}.b{fill:#486be0;}.c{fill:#548aff;}.d{fill:#f5c99d;}.e{fill:#4b6275;}.f{fill:#4976f2;}.g{fill:#62798c;}.h{fill:#7e57df;}.i{fill:#9977ed;}.j{fill:#b1712c;}</style></defs><g transform="translate(-40 -24)"><path class="a" d="M129.977,192.522h-3.39V181.787l-2.252-2.252-10.368,2.074-.665-3.325,11.258-2.252a1.7,1.7,0,0,1,1.531.464l3.39,3.39a1.7,1.7,0,0,1,.5,1.2Z" transform="translate(-57.769 -119.791)"/><path class="b" d="M199.3,86.52V100.4H183.257l-5.478,4.694-6.389,5.478-3.39-3.39,11.866-15.257Z" transform="translate(-100.877 -49.272)"/><path class="c" d="M282.856,94.163v5.086l-8.476,1.816-15.257,3.27-3.068-1.954-8.8,7.039L232,104.334l8.628-18.982a9.823,9.823,0,0,1,5.8-7.3l8.728-3.74.576,1.585.752,2.068,2.638,2.638a11.578,11.578,0,0,1,3.39,8.186v5.376Z" transform="translate(-151.316 -39.649)"/><path class="d" d="M177.779,157.088l-6.389,5.478-3.39-3.39,5.191-6.675Z" transform="translate(-100.877 -101.271)"/><path class="d" d="M440.476,168v5.086L432,174.9V168Z" transform="translate(-308.936 -113.487)"/><path class="e" d="M246.966,252.163l15.476,13.265-3.39,27.123h5.086l10.171-30.513L259.051,240Z" transform="translate(-163.11 -170.23)"/><path class="f" d="M350.781,94.682v5.376L344,94.972V81.79l.752,2.068L347.39,86.5A11.578,11.578,0,0,1,350.781,94.682Z" transform="translate(-239.583 -45.544)"/><path class="g" d="M99.6,216,87.733,244.818,64,251.6l1.7,5.086,30.513-3.39,18.647-32.208Z" transform="translate(-18.914 -151.316)"/><path class="h" d="M62.037,203.6,40,183.257,53.561,168,75.6,188.342Z" transform="translate(0 -113.487)"/><path class="i" d="M104,168v11.866l10.171,10.171,11.866-1.7Z" transform="translate(-50.439 -113.487)"/><path class="d" d="M338.171,56v5.086a5.086,5.086,0,0,1-10.171,0V56Z" transform="translate(-226.973 -25.219)"/><path class="j" d="M328,30.781h10.171V27.9a3.9,3.9,0,0,0-6.069-3.248L328,27.39Z" transform="translate(-226.973)"/><path class="f" d="M232,145.4l8.628-18.982a9.826,9.826,0,0,0-.152,1.724h0a9.82,9.82,0,0,0,4.548,8.285l11.031,7.019-8.8,7.038Z" transform="translate(-151.316 -80.716)"/></g></svg>`,
  },
};
global.shopIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112"><defs><style>.a{fill:#006df0;}.b{fill:#005ece;}.c{fill:#7ed63e;}.d{fill:#ff9811;}.e{fill:#ed1c24;}.f{fill:#5eac24;}.g{fill:#4e901e;}.h{fill:#ff5023;}.i{fill:#e54820;}.j{fill:#f1f2f2;}.k{fill:#58595b;}</style></defs><g transform="translate(-3 -3)"><path class="a" d="M8,22h92.676V97.3H8Z" transform="translate(4.654 17.684)"/><path class="b" d="M92.953,22V39.377a50.2,50.2,0,0,1-50.2,50.2H8V97.3h92.676V22Z" transform="translate(4.654 17.684)"/><path class="c" d="M104.4,7H11.723L4,24.377H112.122Z" transform="translate(0.931 3.723)"/><path class="d" d="M28,22v7.723a7.723,7.723,0,1,0,15.446,0V22Z" transform="translate(23.269 17.684)"/><path class="e" d="M20,22v7.723a7.723,7.723,0,1,0,15.446,0V22Z" transform="translate(15.823 17.684)"/><path class="d" d="M12,22v7.723a7.723,7.723,0,1,0,15.446,0V22Z" transform="translate(8.377 17.684)"/><path class="e" d="M19.446,29.723V22H4v7.723a7.723,7.723,0,1,0,15.446,0Z" transform="translate(0.931 17.684)"/><path class="e" d="M36,22v7.723a7.723,7.723,0,1,0,15.446,0V22Z" transform="translate(30.715 17.684)"/><path class="d" d="M44,22v7.723a7.723,7.723,0,0,0,15.446,0V22Z" transform="translate(38.161 17.684)"/><path class="e" d="M52,29.723a7.723,7.723,0,1,0,15.446,0V22H52Z" transform="translate(45.607 17.684)"/><path class="e" d="M77.784,18.446V3H16V18.446Z" transform="translate(12.1 0)"/><circle class="c" cx="19.5" cy="19.5" r="19.5" transform="translate(76 76)"/><path class="f" d="M51.931,41A19.317,19.317,0,0,0,50,41.1,19.308,19.308,0,0,1,50,79.52,19.307,19.307,0,1,0,51.931,41Z" transform="translate(43.745 35.368)"/><path class="d" d="M45.307,37H29.861A3.862,3.862,0,0,0,26,40.861V83.338H49.169V40.861A3.862,3.862,0,0,0,45.307,37Z" transform="translate(21.407 31.645)"/><path class="g" d="M34.892,27.584h77.23V16H4V27.584H34.892Z" transform="translate(0.931 12.1)"/><ellipse class="h" cx="18.5" cy="19.5" rx="18.5" ry="19.5" transform="translate(3 76)"/><path class="i" d="M13.931,41c-.653,0-1.3.035-1.931.1a19.307,19.307,0,0,1,0,38.422c.635.062,1.278.1,1.931.1a19.307,19.307,0,1,0,0-38.615Z" transform="translate(8.377 35.368)"/><g transform="translate(85.218 84.092)"><ellipse class="j" cx="3" cy="3.5" rx="3" ry="3.5" transform="translate(-0.218 4.908)"/><ellipse class="j" cx="3" cy="4" rx="3" ry="4" transform="translate(14.782 11.908)"/><path class="j" d="M61.51,45.276a1.931,1.931,0,0,0-2.649.66L47.276,65.244a1.931,1.931,0,1,0,3.31,1.989L62.17,47.925a1.931,1.931,0,0,0-.66-2.649Z" transform="translate(-44.265 -45)"/></g><path class="k" d="M36.861,48H34.931a1.931,1.931,0,0,0,0,3.862h1.931a1.931,1.931,0,1,0,0-3.862Z" transform="translate(27.922 41.884)"/><path class="j" d="M18.605,69.127l.025-1.958h.023a5.792,5.792,0,0,0,0-11.584H14.792a1.931,1.931,0,0,1,0-3.862h3.861a1.931,1.931,0,0,1,1.931,1.931,1.931,1.931,0,0,0,3.861,0,5.792,5.792,0,0,0-5.792-5.792V45.931a1.931,1.931,0,1,0-3.861,0v1.931a5.792,5.792,0,0,0,0,11.585h3.861a1.931,1.931,0,1,1,0,3.862H14.792a1.931,1.931,0,0,1-1.931-1.931,1.931,1.931,0,0,0-3.861,0,5.792,5.792,0,0,0,5.769,5.792l-.025,1.906a1.931,1.931,0,0,0,1.9,1.956h.027a1.931,1.931,0,0,0,1.931-1.9Z" transform="translate(5.584 38.161)"/></g></svg>`;
const innovation = require("../images/homePageIcons/innovationKitchen3.png");
// global.fashionIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="80.092" height="80.301" viewBox="0 0 80.092 80.301"><defs><style>.a{fill:#806631;}.b{fill:#5e9446;}.c{fill:#9c9c9c;}.d{fill:#eaca65;}.e{fill:#fce0b9;}.f{fill:#999;}.g{fill:#d0382a;}.h{fill:#fff;}.i{fill:#fad3ac;}.j{fill:#fcccc0;}.k{fill:#f0d57f;}.l{fill:#b83125;}.m{fill:#707070;}</style></defs><path class="a" d="M32.952,42a13.585,13.585,0,0,1-13.809,0H15V69.221H37.094V42Z" transform="translate(1.571 11.08)"/><path class="b" d="M44.809,54.249A12.339,12.339,0,0,0,32.381,42H31V69.221H44.809V54.249Z" transform="translate(7.665 11.08)"/><path class="b" d="M5,54.249A12.339,12.339,0,0,1,17.428,42h1.381V67.86H5V54.249Z" transform="translate(-2.238 11.08)"/><path class="c" d="M49,57h5.524v6.805H49Z" transform="translate(14.521 16.496)"/><path class="d" d="M52.712,38.387,49.415,24.3c-.464-1.98-.732-4-1.008-6.009a17.992,17.992,0,0,0-35.576,0c-.278,2.014-.545,4.029-1.008,6.009l-3.3,14.085a5.445,5.445,0,1,0,0,10.888,6.856,6.856,0,0,0,6.9,6.805h8.285V46.267a14.938,14.938,0,0,1-8.285-13.324V26.124a17.8,17.8,0,0,0,10.511-12.1A19.31,19.31,0,0,0,44.427,27.5h1.381v5.444a14.938,14.938,0,0,1-8.285,13.324V56.08h8.285a6.856,6.856,0,0,0,6.9-6.805,5.445,5.445,0,1,0,0-10.888Z" transform="translate(-3 -3)"/><path class="e" d="M42.38,30.019V24.575H41A19.307,19.307,0,0,1,22.513,11.1,17.8,17.8,0,0,1,12,23.2v6.819a15.192,15.192,0,0,0,30.38,0Z" transform="translate(0.428 -0.076)"/><path class="f" d="M3,47V67.415H33.38V47Z" transform="translate(-3 12.885)"/><path class="g" d="M68.618,22.361,65.166,21,54.809,25.083,44.452,21,41,22.361l5.524,21.776A40.863,40.863,0,0,0,41,64.637V70H68.618v-5.36a40.863,40.863,0,0,0-5.524-20.5Z" transform="translate(11.474 3.499)"/><circle class="h" cx="4" cy="4" r="4" transform="translate(11 66)"/><path class="i" d="M53.857,27.61l10.357-4.083-7.595-2.994V14H51.095v6.533L43.5,23.527Z" transform="translate(12.427 0.971)"/><path class="e" d="M24.9,36.437A15.292,15.292,0,0,1,18,34.79V44.6a13.585,13.585,0,0,0,13.809,0V34.79A15.292,15.292,0,0,1,24.9,36.437Z" transform="translate(2.714 8.477)"/><ellipse class="j" cx="2" cy="0.5" rx="2" ry="0.5" transform="translate(35 34)"/><ellipse class="j" cx="2.5" cy="0.5" rx="2.5" ry="0.5" transform="translate(16 34)"/><path class="k" d="M8.524,41.109l3.3-14.085c.464-1.98.732-4,1.008-6.009a17.992,17.992,0,0,1,35.576,0c.278,2.014.545,4.029,1.008,6.009l3.3,14.085a5.5,5.5,0,0,1,5.329,4.083,5.34,5.34,0,0,0,.195-1.361,5.485,5.485,0,0,0-5.524-5.444L49.415,24.3c-.464-1.98-.732-4-1.008-6.009a17.992,17.992,0,0,0-35.576,0c-.278,2.014-.545,4.029-1.008,6.009l-3.3,14.085A5.485,5.485,0,0,0,3,43.831a5.34,5.34,0,0,0,.195,1.361A5.5,5.5,0,0,1,8.524,41.109Z" transform="translate(-3 -3)"/><path class="i" d="M18,34.79v1.345l10.574,9.842A13.512,13.512,0,0,0,31.809,44.6V34.79A15.3,15.3,0,0,1,18,34.79Z" transform="translate(2.714 8.477)"/><path class="i" d="M41,24.575A19.307,19.307,0,0,1,22.513,11.1,17.8,17.8,0,0,1,12,23.2v4.083a17.8,17.8,0,0,0,10.511-12.1A19.31,19.31,0,0,0,41,28.658H42.38V24.575Z" transform="translate(0.428 -0.076)"/><path class="l" d="M50.666,44.138,45.143,22.361l1.381-.544L44.452,21,41,22.361l5.524,21.776A40.863,40.863,0,0,0,41,64.637V70h4.143v-5.36A40.863,40.863,0,0,1,50.666,44.138Z" transform="translate(11.474 3.499)"/><path class="j" d="M24.143,35.083A4.113,4.113,0,0,0,28.285,31H20A4.113,4.113,0,0,0,24.143,35.083Z" transform="translate(3.475 7.109)"/><path class="h" d="M28.031,32.361A3.98,3.98,0,0,0,28.285,31H20a3.979,3.979,0,0,0,.254,1.361Z" transform="translate(3.475 7.109)"/><ellipse class="a" cx="1.5" cy="2" rx="1.5" ry="2" transform="translate(19 29)"/><ellipse class="a" cx="1.5" cy="2" rx="1.5" ry="2" transform="translate(33 29)"/><ellipse class="h" cx="0.5" cy="1" rx="0.5" ry="1" transform="translate(21 30)"/><ellipse class="h" cx="0.5" cy="1" rx="0.5" ry="1" transform="translate(35 30)"/><path class="m" d="M49,57h5.524v2.722H49Z" transform="translate(14.521 16.496)"/><path class="m" d="M12.545,66.475,3,67.415H33.38V47A23.3,23.3,0,0,1,12.545,66.475Z" transform="translate(-3 12.885)"/><path class="l" d="M51.381,24.144,50,23.6v8.711h2.762V23.6Z" transform="translate(14.902 4.437)"/></svg>`;
// global.foodIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="93.374" height="63.349" viewBox="0 0 93.374 63.349"><defs><style>.a{fill:#d5d6db;}.b{fill:#ebf0f3;}.c{fill:#e1e6e9;}.d{fill:#fff;}.e{fill:#44c4a1;}.f{fill:#31978c;}.g{fill:#3ea69b;}.h{fill:#dc8744;}</style></defs><g transform="translate(0 -24.117)"><path class="a" d="M82.3,121.093H19.875l-6.37-7.9H88.672Z" transform="translate(-5.098 -33.627)"/><path class="b" d="M60.719,28.916l-2.9.964a3.949,3.949,0,1,0-7.5,2.489l-2.9.964a7.007,7.007,0,1,1,13.3-4.417Z" transform="translate(-17.766 0)"/><path class="c" d="M86.373,57.9,26.16,77.9l-1.646-4.957a31.723,31.723,0,0,1,20.109-40.1h0a31.723,31.723,0,0,1,40.1,20.109Z" transform="translate(-8.641 -2.678)"/><g transform="translate(45.045 31.777)"><path class="d" d="M93.113,46.987a.764.764,0,0,1-.765-.169c-11.042-10.383-18.978-8.777-19.057-8.76a.764.764,0,1,1-.33-1.493c.354-.078,8.81-1.792,20.434,9.139a.764.764,0,0,1-.282,1.282Z" transform="translate(-72.362 -36.423)"/><circle class="d" cx="1.147" cy="1.147" r="1.147" transform="translate(21.785 10.906)"/></g><rect class="c" width="93.374" height="3.342" transform="translate(0 76.221)"/><path class="e" d="M110.217,85.112S95.35,83.776,95.684,96.972C95.684,96.972,109.883,99.978,110.217,85.112Z" transform="translate(-36.119 -23.012)"/><g transform="translate(61.34 63.485)"><path class="f" d="M99.041,96.976a.5.5,0,0,1-.32-.887l9.062-7.534a.5.5,0,1,1,.64.771l-9.062,7.534A.5.5,0,0,1,99.041,96.976Z" transform="translate(-98.54 -87.768)"/><path class="f" d="M112.345,91.9H107.9V87.861a.5.5,0,1,1,1,0V90.9h3.445a.5.5,0,0,1,0,1Z" transform="translate(-102.072 -87.36)"/><path class="f" d="M107.828,95.725h-4.447V91.684a.5.5,0,1,1,1,0v3.039h3.445a.5.5,0,0,1,0,1Z" transform="translate(-100.367 -88.803)"/></g><path class="g" d="M78.161,89.572s11.371-1.022,11.115,9.071C89.276,98.643,78.416,100.943,78.161,89.572Z" transform="translate(-29.506 -24.699)"/><g transform="translate(50.596 66.329)"><path class="f" d="M88.713,98.693a.5.5,0,0,1-.32-.115L81.46,92.815a.5.5,0,0,1,.64-.771l6.932,5.763a.5.5,0,0,1-.32.887Z" transform="translate(-81.279 -91.929)"/><path class="f" d="M85.459,96.026H81.939a.5.5,0,1,1,0-1h2.517V92.817a.5.5,0,1,1,1,0Z" transform="translate(-81.339 -92.075)"/></g><path class="h" d="M49.514,100.582H95.657a4.424,4.424,0,0,1,4.424,4.424H45.09A4.424,4.424,0,0,1,49.514,100.582Z" transform="translate(-17.022 -28.866)"/></g></svg>`;
// global.electronicsIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="87.911" height="75.88" viewBox="0 0 87.911 75.88"><defs><style>.a{fill:#2b84e9;}.b{fill:#363c44;}.c{fill:#292e33;}.d{fill:#555e6b;}.e{fill:#49bc6e;}.f{fill:#2676c6;}.g{fill:#434b56;}.h{fill:#ffe92f;}.i{fill:#2e343a;}.j{fill:#96abbc;}.k{fill:#ff7b05;}.l{fill:#707d8c;}</style></defs><g transform="translate(0 -10.265)"><g transform="translate(0 10.265)"><path class="a" d="M90.547,72.364H23.039a4.881,4.881,0,0,1-4.881-4.881V23.765a4.881,4.881,0,0,1,4.881-4.881H90.546a4.881,4.881,0,0,1,4.881,4.881V67.484A4.881,4.881,0,0,1,90.547,72.364Z" transform="translate(-7.516 -13.832)"/><rect class="b" width="14.794" height="12.806" transform="translate(41.88 58.101)"/><g transform="translate(41.88 58.101)"><rect class="c" width="14.794" height="3.424"/><rect class="c" width="14.794" height="2.418" transform="translate(0 9.955)"/></g><path class="d" d="M18.158,94.633a4.881,4.881,0,0,0,4.881,4.881H90.546a4.881,4.881,0,0,0,4.881-4.881V84.474H18.158Z" transform="translate(-7.516 -40.982)"/><circle class="e" cx="1.335" cy="1.335" r="1.335" transform="translate(79.826 49.469)"/><path class="f" d="M41.844,18.884H23.328a4.881,4.881,0,0,0-4.881,4.881V67.483a4.881,4.881,0,0,0,4.881,4.881H41.844V18.884Z" transform="translate(-7.636 -13.832)"/><g transform="translate(70.276 49.469)"><circle class="e" cx="1.335" cy="1.335" r="1.335" transform="translate(4.744)"/><circle class="e" cx="1.335" cy="1.335" r="1.335"/></g><path class="g" d="M18.447,84.474V94.633a4.881,4.881,0,0,0,4.881,4.881H41.844V84.474h-23.4Z" transform="translate(-7.636 -40.982)"/><path class="d" d="M26.759,86.144H2.252A2.252,2.252,0,0,1,0,83.892V12.517a2.252,2.252,0,0,1,2.252-2.252H26.759a2.252,2.252,0,0,1,2.252,2.252V83.892A2.252,2.252,0,0,1,26.759,86.144Z" transform="translate(0 -10.265)"/><path class="b" d="M87.632,135.918H61.04a.5.5,0,0,1-.5-.5v-2.13a2.775,2.775,0,0,1,2.775-2.775H85.356a2.775,2.775,0,0,1,2.775,2.775v2.13A.5.5,0,0,1,87.632,135.918Z" transform="translate(-25.059 -60.038)"/><circle class="h" cx="2.607" cy="2.607" r="2.607" transform="translate(46.67 47.9)"/><g transform="translate(0 37.94)"><path class="i" d="M8.556,98.449,5.232,81.832a1.632,1.632,0,0,0-.326-.7L0,75v34.2l8.184-9.36A1.632,1.632,0,0,0,8.556,98.449Z" transform="translate(0 -75)"/><path class="i" d="M34.88,98.449,38.2,81.832a1.632,1.632,0,0,1,.326-.7L43.435,75v34.2l-8.184-9.36A1.632,1.632,0,0,1,34.88,98.449Z" transform="translate(-14.424 -75)"/></g><g transform="translate(6.941 69.325)"><path class="j" d="M16.329,131.221H13.178a1.335,1.335,0,1,1,0-2.669h3.151a1.335,1.335,0,0,1,0,2.669Z" transform="translate(-11.844 -128.551)"/><path class="j" d="M30.45,131.221H27.3a1.335,1.335,0,1,1,0-2.669H30.45a1.335,1.335,0,0,1,0,2.669Z" transform="translate(-17.689 -128.551)"/></g><circle class="k" cx="3.515" cy="3.515" r="3.515" transform="translate(10.642 38.866)"/><path class="i" d="M7.757,10.264,10.678,13.8a2.893,2.893,0,0,0,2.229,1.049h9.5a2.892,2.892,0,0,0,2.191-1l3.082-3.576Z" transform="translate(-3.211 -10.264)"/><g transform="translate(4.546 9.326)"><path class="l" d="M26.691,30.791H8.741a.985.985,0,0,1-.985-.985V27.162a.985.985,0,0,1,.985-.985H26.691a.985.985,0,0,1,.985.985v2.644A.985.985,0,0,1,26.691,30.791Z" transform="translate(-7.757 -26.177)"/><path class="l" d="M26.691,47.218H8.741a.985.985,0,0,1-.985-.985V43.589a.985.985,0,0,1,.985-.985H26.691a.985.985,0,0,1,.985.985v2.644A.985.985,0,0,1,26.691,47.218Z" transform="translate(-7.757 -32.977)"/></g></g></g></svg>`;
// global.servicesIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="90.6" height="77.761" viewBox="0 0 90.6 77.761"><defs><style>.a{fill:#d9d9d9;}.b{fill:#cdcdcd;}.c{fill:#b9b9b9;}.d{fill:#eaeae8;}.e{fill:#fec9a3;}.f{fill:#f7bb8f;}.g{fill:#4298d1;}.h{fill:#3981b7;}.i{fill:#905638;}.j{fill:#69b9e7;}</style></defs><g transform="translate(-7.759 -12.931)"><path class="a" d="M114.114,122.807a17.191,17.191,0,0,0,15.994-10.27H117.962l-5.41-2.934v-5.869l5.41-2.934h12.145a17.067,17.067,0,0,0-14.239-10.171,17.588,17.588,0,0,0-16.145,7.236H87.931v17.606H99.723a17.462,17.462,0,0,0,14.391,7.336Z" transform="translate(-31.748 -33.582)"/><path class="b" d="M98.252,113.793H90.517v5.869h7.735a14.626,14.626,0,0,1,0-5.869Z" transform="translate(-32.772 -43.641)"/><path class="b" d="M119.962,121.64a1.656,1.656,0,0,1-.445-.062,11.553,11.553,0,0,1,0-22.5,1.637,1.637,0,0,1,1.553.317,1.411,1.411,0,0,1,.453,1.431,1.516,1.516,0,0,1-1.116,1.063,8.667,8.667,0,0,0,0,16.879,1.467,1.467,0,0,1,1.1,1.617A1.534,1.534,0,0,1,119.962,121.64Z" transform="translate(-40.721 -37.242)"/><path class="c" d="M139.514,117.424v-5.869l-5.411-2.934-5.411,2.934v5.869l5.411,2.934Z" transform="translate(-47.889 -41.403)"/><path class="b" d="M128.692,113.147v1.694l9.26,5.021,1.562-.847v-1.695l-9.26-5.021Z" transform="translate(-47.889 -42.995)"/><path class="d" d="M83.348,116.927H72.414V91.675l1.562-1.158c5.176,0,9.372,3.941,9.372,8.8Z" transform="translate(-25.603 -33.57)"/><path class="e" d="M18.693,124.412v-13.2H7.759V130.28a3.034,3.034,0,0,0,3.124,2.934H53.059Z" transform="translate(0 -42.522)"/><path class="d" d="M18.693,102.115H7.759V99.181c0-4.862,4.2-8.8,9.372-8.8l1.562-.183Z" transform="translate(0 -33.43)"/><path class="f" d="M25.914,50.182H22.79a4.41,4.41,0,1,1,0-8.8h3.124Z" transform="translate(-4.097 -12.309)"/><path class="f" d="M67.241,50.182h3.124a4.41,4.41,0,1,0,0-8.8H67.241Z" transform="translate(-23.555 -12.309)"/><path class="g" d="M54.517,113.222V88.279l-9.372-2.934h-12.5l-9.372,2.934v24.942Z" transform="translate(-6.145 -31.332)"/><path class="h" d="M56.9,121.552h3.124v2.934H56.9Z" transform="translate(-19.458 -46.998)"/><path class="f" d="M21.228,133.364V131.9L18.1,133.364l3.124,8.8H55.593a3.268,3.268,0,0,0,.944-.151Z" transform="translate(-4.097 -51.474)"/><path class="e" d="M38.793,72.414V79.75l6.248,8.8,6.248-8.8V72.414Z" transform="translate(-12.29 -25.737)"/><path class="f" d="M38.793,75.232a13.122,13.122,0,0,0,12.5,0V72.414h-12.5Z" transform="translate(-12.29 -25.737)"/><path class="e" d="M40.945,58.563c-6.9,0-12.5-5.255-12.5-11.738v-13.2H53.441v13.2C53.441,53.308,47.847,58.563,40.945,58.563Z" transform="translate(-8.193 -8.952)"/><g transform="translate(24.941 31.967)"><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(0 1.505)"/><ellipse class="i" cx="1.562" cy="1.467" rx="1.562" ry="1.467" transform="translate(12.497 1.505)"/><path class="i" d="M48.652,53.859H45.528a1.594,1.594,0,0,1-1.268-.609,1.393,1.393,0,0,1-.213-1.322l1.562-4.4a1.529,1.529,0,0,1,1.168-1.008,1.623,1.623,0,0,1,1.5.472,1.4,1.4,0,0,1,.29,1.465l-.876,2.47h.957a1.47,1.47,0,1,1,0,2.934Z" transform="translate(-39.279 -46.485)"/><path class="i" d="M46.066,66.66a6.162,6.162,0,0,1-4.229-1.642,1.4,1.4,0,0,1,0-2.075,1.634,1.634,0,0,1,2.209,0,2.992,2.992,0,0,0,4.039,0,1.634,1.634,0,0,1,2.209,0,1.405,1.405,0,0,1,0,2.075,6.162,6.162,0,0,1-4.229,1.642Z" transform="translate(-38.255 -53.42)"/></g><path class="h" d="M48.114,121.4a1.517,1.517,0,0,1-1.562-1.467V102.329a1.565,1.565,0,0,1,3.124,0v17.606A1.517,1.517,0,0,1,48.114,121.4Z" transform="translate(-15.362 -38.046)"/><path class="h" d="M37.283,97.431l4.686-4.4-6.248-10.27-4.686,2.934Z" transform="translate(-9.217 -30.213)"/><path class="h" d="M53.824,97.431l-4.686-4.4,6.248-10.27,4.686,2.934Z" transform="translate(-16.386 -30.213)"/><path class="f" d="M28.448,33.621H53.441v4.4H28.448Z" transform="translate(-8.193 -8.952)"/><path class="j" d="M28.448,32.5l1.193,2.242a13.017,13.017,0,0,0,22.607,0L53.441,32.5l-1.562-1.467H30.01Z" transform="translate(-8.193 -7.833)"/><path class="e" d="M54.517,111.207v13.2H35.772l-6.248-2.934-6.248,2.934,3.124,8.8H60.766a3.034,3.034,0,0,0,3.124-2.934V111.207Z" transform="translate(-6.145 -42.522)"/><path class="h" d="M53.441,24.669H28.448V18.8A6.067,6.067,0,0,1,34.7,12.931h12.5A6.067,6.067,0,0,1,53.441,18.8Z" transform="translate(-8.193 0)"/></g></svg>`;
// global.beautyIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="81.672" height="78.676" viewBox="0 0 81.672 78.676"><defs><style>.a{fill:#9b5729;}.b{fill:#7f441c;}.c{fill:#f66;}.d{fill:#fe3745;}.e{fill:#def9ff;}.f{fill:#f8d5ab;}.g{fill:#eac092;}.h{fill:#b57a4e;}.i{fill:#ffe2b8;}.j{fill:#ffc987;}.k{fill:#72563c;}.l{fill:#ffaf10;}.m{fill:#f39600;}.n{fill:#ffcb00;}.o{fill:#c7c8ca;}.p{fill:#a7a9ac;}.q{fill:#602f0e;}.r{fill:#8a8c8e;}.s{fill:#6d6e71;}.t{fill:#ff99a3;}.u{fill:#ff788c;}.v{fill:#ffaf68;}</style></defs><g transform="translate(0 -0.146)"><path class="a" d="M62.87,8.759A26.581,26.581,0,0,1,74.2,11.144a11.333,11.333,0,0,0-22.656,0A26.581,26.581,0,0,1,62.87,8.759Zm0,0" transform="translate(-23.478 0)"/><path class="b" d="M56.947,9.355A11.313,11.313,0,0,1,65.48.45a11.43,11.43,0,0,0-2.61-.3,11.3,11.3,0,0,0-11.328,11A24.209,24.209,0,0,1,56.947,9.355Zm0,0" transform="translate(-23.478)"/><path class="c" d="M106.164,114.28a12.115,12.115,0,0,0-2.544-.876l1.713,1.7Zm0,0" transform="translate(-47.201 -51.591)"/><path class="c" d="M71.706,122.056l-8.542-8.5-9.537,14.608a4.107,4.107,0,0,1-2.854,1.819H49.6a4.107,4.107,0,0,1-2.854-1.819l-10-15.314h-.914A12.116,12.116,0,0,0,23.7,124.924v4.38a.859.859,0,0,0,.86.859H75.815a.859.859,0,0,0,.86-.859v-4.38c0-.223-.007-.444-.019-.664A7.581,7.581,0,0,1,71.706,122.056Zm0,0" transform="translate(-10.796 -51.341)"/><path class="d" d="M37.069,113.519l-.433-.664h-.8A12.116,12.116,0,0,0,23.7,124.924v4.38a.86.86,0,0,0,.86.859h5.194a.86.86,0,0,1-.86-.859v-4.38A12.092,12.092,0,0,1,37.069,113.519Zm0,0" transform="translate(-10.796 -51.341)"/><path class="e" d="M73.276,112.855H69.538l-8.528,13.064L52.48,112.855H47.458l10.112,15.49a4.107,4.107,0,0,0,2.854,1.819h1.171a4.107,4.107,0,0,0,2.854-1.819l9.606-14.715Zm0,0" transform="translate(-21.618 -51.341)"/><path class="f" d="M70.023,107.769v-3.531a16.216,16.216,0,0,1-2.78.241H62.987a16.1,16.1,0,0,1-2.781-.243v3.532a1.165,1.165,0,0,1-1.166,1.16H56.47l8.644,13.242,8.645-13.242H71.19A1.165,1.165,0,0,1,70.023,107.769Zm0,0" transform="translate(-25.723 -47.415)"/><path class="g" d="M59.836,112.277a1.163,1.163,0,0,1-.8.315H56.47l8.645,13.242L66.9,123.1Zm0,0" transform="translate(-25.723 -51.078)"/><path class="h" d="M33.145,40.09h2.832V36.226a.853.853,0,0,1,.855-.849H51.245a7.951,7.951,0,0,0,6.677-3.7.857.857,0,0,1,1.449,0,7.954,7.954,0,0,0,6.677,3.7h5.288a.853.853,0,0,1,.854.849V40.09h2.833a3.28,3.28,0,0,1,.89.125V34.4c0-11.858-9.773-18.727-21.83-18.727s-21.83,6.87-21.83,18.727v5.817A3.261,3.261,0,0,1,33.145,40.09Zm0,0" transform="translate(-14.692 -7.072)"/><path class="a" d="M33.145,40.09h2.832V36.226a.853.853,0,0,1,.855-.849h.62V34.4c0-10.993,8.4-17.7,19.231-18.617q-1.279-.109-2.6-.11c-12.056,0-21.83,6.87-21.83,18.727v5.816A3.285,3.285,0,0,1,33.145,40.09Zm0,0" transform="translate(-14.692 -7.072)"/><path class="f" d="M105.6,66.879a7.237,7.237,0,0,1,5.195,3.1,3.294,3.294,0,0,0,1.024-2.385V63.557a3.359,3.359,0,0,0-3.387-3.332H105.6Zm0,0" transform="translate(-48.104 -27.367)"/><path class="i" d="M29.852,69.759a12.148,12.148,0,0,1,2.958-.373c.371,0,.739.019,1.1.055q-.022-.418-.023-.841V60.226H31.057a3.359,3.359,0,0,0-3.387,3.332V67.59a3.315,3.315,0,0,0,1.613,2.835A.753.753,0,0,1,29.852,69.759Zm0,0" transform="translate(-12.605 -27.367)"/><path class="i" d="M67.99,73.3a1.561,1.561,0,0,1,0-2.216,1.609,1.609,0,0,1,.324-.246l.146-.085-.093-.141a7.122,7.122,0,0,1-1.193-3.953A7.214,7.214,0,0,1,74.4,59.469a7.293,7.293,0,0,1,.932.062V49.153a1.011,1.011,0,0,0-1.014-1.009H69.03a7.793,7.793,0,0,1-6.542-3.62,1.017,1.017,0,0,0-1.719,0,7.793,7.793,0,0,1-6.542,3.62H39.813A1.012,1.012,0,0,0,38.8,49.153V61.232q0,.416.022.827a10,10,0,0,1,6.28,2.826,10.448,10.448,0,0,1,2.507,10.121.749.749,0,0,1-.213.36,16.16,16.16,0,0,0,7.543,1.858h4.256a16.147,16.147,0,0,0,9.59-3.139Zm0,0" transform="translate(-17.674 -19.999)"/><path class="j" d="M42.337,66.4a15.858,15.858,0,0,1-.1-1.738V52.578a1.011,1.011,0,0,1,1.014-1.008H39.813A1.011,1.011,0,0,0,38.8,52.578v12.08q0,.416.022.826A10.482,10.482,0,0,1,42.337,66.4Zm0,0" transform="translate(-17.674 -23.424)"/><path class="j" d="M54.8,99.549a.752.752,0,0,1-.213.36,16.16,16.16,0,0,0,7.543,1.858h3.442A16.156,16.156,0,0,1,55.1,97.929,12.125,12.125,0,0,1,54.8,99.549Zm0,0" transform="translate(-24.865 -44.542)"/><g transform="translate(24.759 34.058)"><path class="k" d="M71.587,74.425H69.58A2.128,2.128,0,0,1,67.449,72.3V69a1.2,1.2,0,0,1,2.393,0v3.028h1.745a1.2,1.2,0,0,1,0,2.393Zm0,0" transform="translate(-55.483 -64.88)"/><path class="k" d="M50.483,66.39a6.584,6.584,0,0,1-4.658-1.915,1.2,1.2,0,0,1,1.687-1.7,4.222,4.222,0,0,0,5.941,0,1.2,1.2,0,1,1,1.687,1.7A6.584,6.584,0,0,1,50.483,66.39Zm0,0" transform="translate(-45.472 -62.43)"/><path class="k" d="M85.829,66.39a6.581,6.581,0,0,1-4.657-1.915,1.2,1.2,0,0,1,1.687-1.7,4.222,4.222,0,0,0,5.941,0,1.2,1.2,0,0,1,1.687,1.7A6.587,6.587,0,0,1,85.829,66.39Zm0,0" transform="translate(-61.574 -62.43)"/><path class="k" d="M66.583,89.131a9.14,9.14,0,0,1-6.467-2.656,1.2,1.2,0,0,1,1.687-1.7,6.839,6.839,0,0,0,9.623-.035,1.2,1.2,0,1,1,1.687,1.7A9.238,9.238,0,0,1,66.583,89.131Zm0,0" transform="translate(-51.982 -72.436)"/></g><path class="l" d="M128.258,47.354a.479.479,0,0,1-.446-.3c-.965-2.429-1.7-3.162-4.125-4.127a.48.48,0,0,1,0-.892c2.428-.965,3.16-1.7,4.125-4.127a.479.479,0,0,1,.891,0c.965,2.429,1.7,3.162,4.125,4.127a.48.48,0,0,1,0,.892c-2.428.965-3.16,1.7-4.125,4.127A.479.479,0,0,1,128.258,47.354Zm0,0" transform="translate(-56.205 -17.062)"/><path class="m" d="M125.393,44.314a.379.379,0,0,1-.042-.021,11.419,11.419,0,0,1-1.663.787.48.48,0,0,0,0,.892c2.428.965,3.16,1.7,4.125,4.127a.479.479,0,0,0,.891,0,11.334,11.334,0,0,1,.8-1.689C128.547,46.006,127.81,45.275,125.393,44.314Zm0,0" transform="translate(-56.205 -20.11)"/><path class="n" d="M12.379,47.446a.478.478,0,0,1-.446-.3c-.965-2.429-1.7-3.162-4.126-4.127a.48.48,0,0,1,0-.892c2.428-.965,3.16-1.7,4.126-4.127a.479.479,0,0,1,.89,0c.965,2.429,1.7,3.162,4.125,4.127a.48.48,0,0,1,0,.892c-2.428.965-3.16,1.7-4.125,4.127A.478.478,0,0,1,12.379,47.446Zm0,0" transform="translate(-3.419 -17.105)"/><path class="l" d="M9.505,44.409l-.038-.019a11.525,11.525,0,0,1-1.659.784.48.48,0,0,0,0,.892c2.428.965,3.16,1.7,4.126,4.127a.479.479,0,0,0,.89,0,11.405,11.405,0,0,1,.8-1.681C12.661,46.1,11.925,45.371,9.505,44.409Zm0,0" transform="translate(-3.419 -20.154)"/><path class="l" d="M26.094,12.926a.388.388,0,0,1-.361-.245,4.762,4.762,0,0,0-3.345-3.347.389.389,0,0,1,0-.723,4.762,4.762,0,0,0,3.345-3.347.389.389,0,0,1,.722,0A4.763,4.763,0,0,0,29.8,8.611a.389.389,0,0,1,0,.723,4.763,4.763,0,0,0-3.345,3.347A.388.388,0,0,1,26.094,12.926Zm0,0" transform="translate(-10.087 -2.22)"/><path class="m" d="M27.384,13.077a4.685,4.685,0,0,0-3.153-3.268,6.9,6.9,0,0,1-1.843.984.389.389,0,0,0,0,.723,4.764,4.764,0,0,1,3.345,3.347.389.389,0,0,0,.722,0,7.189,7.189,0,0,1,.932-1.78Zm0,0" transform="translate(-10.087 -4.401)"/><path class="o" d="M13.768,100.665.453,115.316a1.532,1.532,0,0,0,0,2.174,1.552,1.552,0,0,0,2.186,0L17.37,104.247Zm0,0" transform="translate(0 -45.788)"/><path class="p" d="M15.152,102.041l-1.384-1.376L.453,115.316a1.532,1.532,0,0,0,0,2.174,1.552,1.552,0,0,0,2.186,0l.664-.6a1.529,1.529,0,0,1,.158-1.986Zm0,0" transform="translate(0 -45.788)"/><path class="a" d="M40.872,79.67a10.749,10.749,0,0,0-10.331-2.536.916.916,0,0,0-.692.826l-.582,8.824,4.45,4.426,8.873-.579a.916.916,0,0,0,.83-.687A10.605,10.605,0,0,0,40.872,79.67Zm0,0" transform="translate(-13.332 -34.898)"/><path class="b" d="M32.889,82.607l.318-4.815a1.009,1.009,0,0,1,.761-.91c.132-.033.264-.064.4-.093a12.127,12.127,0,0,0-3.822.346.914.914,0,0,0-.692.826l-.582,8.824.705.7Zm0,0" transform="translate(-13.332 -34.899)"/><path class="q" d="M39.689,89.293a1.2,1.2,0,0,0-1.639-.421l-5.066,2.995,3-5.027a1.2,1.2,0,0,0-2.054-1.228l-3.372,5.642,3.043,3.025,5.662-3.347A1.2,1.2,0,0,0,39.689,89.293Zm0,0" transform="translate(-13.922 -38.666)"/><path class="r" d="M29.768,102.034a.829.829,0,0,1-1.165,0l-5-4.975a.819.819,0,0,1,0-1.159l1.648-1.639a.829.829,0,0,1,1.165,0l5,4.975a.82.82,0,0,1,0,1.16Zm0,0" transform="translate(-10.641 -42.763)"/><path class="s" d="M25.591,98.1l1.844-1.834a.918.918,0,0,1,.737-.259l-1.759-1.75a.83.83,0,0,0-1.166,0L23.6,95.9a.818.818,0,0,0,0,1.159l1.724,1.715A.912.912,0,0,1,25.591,98.1Zm0,0" transform="translate(-10.641 -42.763)"/><path class="t" d="M92.712,83.386a1.568,1.568,0,0,1,1.115.46l2.805,2.79a7.45,7.45,0,0,0,2.506.042L95.058,82.62a1.562,1.562,0,0,1,0-2.216,1.583,1.583,0,0,1,2.231,0l5.015,4.987a7.446,7.446,0,0,0,1.287-1.168L100.752,81.4a1.561,1.561,0,0,1,0-2.216,1.583,1.583,0,0,1,2.231,0l2.155,2.144A7.387,7.387,0,1,0,91.93,83.593,1.571,1.571,0,0,1,92.712,83.386Zm0,0" transform="translate(-41.28 -32.765)"/><path class="u" d="M92.712,83.386a1.568,1.568,0,0,1,1.115.46l2.805,2.79a7.5,7.5,0,0,0,1.373.128,7.4,7.4,0,0,0,1.128-.089l-.384-.383a7.332,7.332,0,0,1,.929-14.025,7.388,7.388,0,0,0-9.058,7.153,7.287,7.287,0,0,0,1.309,4.174A1.571,1.571,0,0,1,92.712,83.386Zm0,0" transform="translate(-41.28 -32.765)"/><path class="j" d="M115.327,117.015a.9.9,0,0,1-.635-.261l-5.777-5.746a7.86,7.86,0,0,1-2.069.277,7.751,7.751,0,0,1-5.5-2.264L89.526,97.265a1.719,1.719,0,0,1,0-2.442,1.743,1.743,0,0,1,2.456,0l6.7,6.663,1-1L90.753,91.6a1.721,1.721,0,0,1,0-2.443,1.744,1.744,0,0,1,2.456,0l8.932,8.882,1-1L94.215,88.16a1.721,1.721,0,0,1,0-2.443,1.743,1.743,0,0,1,2.456,0L105.6,94.6l1.005-1-6.7-6.662a1.721,1.721,0,0,1,0-2.443,1.744,1.744,0,0,1,2.456,0l8.59,8.543V89.955a2.184,2.184,0,0,1,4.369,0v7.736a7.732,7.732,0,0,1,.861,6.089l5.772,5.741a.894.894,0,0,1,0,1.271l-6,5.963A.893.893,0,0,1,115.327,117.015Zm0,0" transform="translate(-40.549 -38.193)"/><path class="v" d="M109.9,118.1a7.886,7.886,0,0,1-2.069.276,7.75,7.75,0,0,1-5.5-2.264l-11.82-11.756a1.707,1.707,0,0,1-.5-1.085,1.727,1.727,0,0,0-.48.335,1.719,1.719,0,0,0,0,2.443l11.82,11.756a7.751,7.751,0,0,0,5.5,2.264,7.886,7.886,0,0,0,2.069-.276l5.777,5.745a.9.9,0,0,0,1.269,0l.7-.7Zm0,0" transform="translate(-40.549 -46.975)"/></g></svg>`
// global.healthIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="74.24" height="83.854" viewBox="0 0 74.24 83.854"><defs><style>.a{fill:#ffe7cf;}.b{fill:#f4d5ba;}.c{fill:#fff;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:15px;}.d{fill:#24d9de;}.e{fill:#d0d1d2;}.f{fill:#f9644b;}.g{fill:#e1effb;}.h{fill:#caddea;}.i{fill:#44798c;}.j{fill:#1785b8;}.k{fill:#2c5871;}.l{fill:#ffb125;}.m{fill:#ff901d;}</style></defs><path class="a" d="M186.611,253.9l8.926-8.312-3.544-.653a4.192,4.192,0,0,1-2.941-4.038v-7.708H172.478V240.9a4.192,4.192,0,0,1-2.941,4.038l-3.544.653,8.926,8.312A8.593,8.593,0,0,0,186.611,253.9Z" transform="translate(-143.645 -195.244)"/><path class="b" d="M282.038,233.189v11.688a4.192,4.192,0,0,0,2.941,4.038l3.054.867,4.5-4.194-3.544-.653a4.192,4.192,0,0,1-2.941-4.038v-7.708Z" transform="translate(-240.645 -195.243)"/><path class="c" d="M249.173,469.222Z" transform="translate(-213.174 -392.868)"/><path class="d" d="M77.29,300.56l-10.346,7.667L56.6,300.56a2.2,2.2,0,0,0-1.936-.338l-17.382,5.2a5.121,5.121,0,0,0-3.589,4.029l-3.83,22.229a2.511,2.511,0,0,0,2.49,2.926h69.186a2.511,2.511,0,0,0,2.49-2.926L100.2,309.451a5.121,5.121,0,0,0-3.589-4.029l-17.382-5.2A2.2,2.2,0,0,0,77.29,300.56Z" transform="translate(-29.824 -251.291)"/><g transform="translate(21.847 48.838)"><path class="e" d="M165.93,300.222l-2.99.895,6.6,9.156a1.916,1.916,0,0,0,2.3.641l6.377-2.686h0l-10.346-7.667A2.2,2.2,0,0,0,165.93,300.222Z" transform="translate(-162.94 -300.13)"/><path class="e" d="M262.377,310.914a1.916,1.916,0,0,0,2.3-.641l6.6-9.156-.016,0-2.974-.89a2.2,2.2,0,0,0-1.936.338L256,308.228h0Z" transform="translate(-240.727 -300.13)"/></g><g transform="translate(31.189 56.936)"><path class="f" d="M230.459,349.894l-5.015,2.112,2.932,3.379h4.166l2.932-3.379Z" transform="translate(-224.528 -349.894)"/><path class="f" d="M227.878,383.639h-4.166l-3.847,20.887h11.861Z" transform="translate(-219.864 -378.148)"/></g><path class="g" d="M66.944,331.2s-11.62-30.7-12.283-30.506l-17.382,5.2a5.121,5.121,0,0,0-3.589,4.029l-3.83,22.229a2.511,2.511,0,0,0,2.49,2.926h69.186a2.511,2.511,0,0,0,2.49-2.926L100.2,309.92a5.121,5.121,0,0,0-3.589-4.029l-17.382-5.2C78.564,300.493,66.944,331.2,66.944,331.2Z" transform="translate(-29.824 -251.761)"/><path class="h" d="M342.825,332.149,339,309.92a5.121,5.121,0,0,0-3.589-4.029l-17.382-5.2c-.18-.054-1.17,2.176-2.516,5.452l12.606,3.771a2.609,2.609,0,0,1,1.829,2.053l3.981,23.109h6.41A2.511,2.511,0,0,0,342.825,332.149Z" transform="translate(-268.623 -251.761)"/><g transform="translate(17.375 39.016)"><path class="i" d="M312.393,266.708a1.262,1.262,0,0,1-1.268-1.257V251.185a8.932,8.932,0,0,0-8.557-8.9,1.257,1.257,0,1,1,.119-2.511,11.451,11.451,0,0,1,10.973,11.414v14.266A1.262,1.262,0,0,1,312.393,266.708Z" transform="translate(-274.171 -239.769)"/><path class="i" d="M136.958,257.413a1.262,1.262,0,0,1-1.268-1.257v-4.965a11.458,11.458,0,0,1,10.941-11.413,1.257,1.257,0,1,1,.127,2.51,8.936,8.936,0,0,0-8.533,8.9v4.965A1.262,1.262,0,0,1,136.958,257.413Z" transform="translate(-135.69 -239.775)"/></g><ellipse class="j" cx="5.291" cy="5.246" rx="5.291" ry="5.246" transform="translate(50.292 60.278)"/><ellipse class="g" cx="2.331" cy="2.311" rx="2.331" ry="2.311" transform="translate(53.252 63.213)"/><path class="k" d="M109.93,358.046h-1.58a1.257,1.257,0,1,1,0-2.514h1.58a.692.692,0,0,0,.5-.219.68.68,0,0,0,.181-.515l-.924-11.751a3.735,3.735,0,0,0-3.836-3.458h-.238a3.736,3.736,0,0,0-3.816,3.456l-.923,11.75a.679.679,0,0,0,.18.515.691.691,0,0,0,.5.219h1.58a1.257,1.257,0,1,1,0,2.514h-1.58a3.244,3.244,0,0,1-2.365-1.025,3.186,3.186,0,0,1-.847-2.418l.923-11.75a6.255,6.255,0,0,1,6.326-5.774h.256a6.255,6.255,0,0,1,6.364,5.776l.923,11.75a3.187,3.187,0,0,1-.847,2.418A3.244,3.244,0,0,1,109.93,358.046Z" transform="translate(-87.096 -282.226)"/><g transform="translate(17.11 21.904)"><path class="b" d="M139.462,139.311v-4.7h-2.893a2.48,2.48,0,0,0-2.491,2.47v1.91a2.48,2.48,0,0,0,2.491,2.47h2.893Z" transform="translate(-134.078 -134.608)"/><path class="b" d="M348.009,134.608h-2.893v6.85h2.893a2.48,2.48,0,0,0,2.491-2.47v-1.91A2.48,2.48,0,0,0,348.009,134.608Z" transform="translate(-310.481 -134.608)"/></g><path class="a" d="M187.48,25.668c-2.5-2.13-6-1.992-10.635-2.043-4.633.051-8.14-.087-10.635,2.043A14.312,14.312,0,0,0,161.3,36.583v12.1c0,4.164,5.278,15.209,15.541,15.209s15.541-11.045,15.541-15.209v-12.1A14.311,14.311,0,0,0,187.48,25.668Z" transform="translate(-139.725 -19.781)"/><path class="b" d="M245.33,27.856a7.636,7.636,0,0,0-3.46-1.618c0,.006,0,.012,0,.018V50.875c0,3.555-3.847,12.122-11.358,14.554a13.506,13.506,0,0,0,4.183.655c10.263,0,15.541-11.045,15.541-15.209v-12.1A14.312,14.312,0,0,0,245.33,27.856Z" transform="translate(-197.575 -21.968)"/><path class="l" d="M173.359,0h-18.7a8.675,8.675,0,0,0-8.712,8.638v14.18a6.049,6.049,0,0,1,3.941,1.459.511.511,0,0,0,.867-.363v-11.6a3.835,3.835,0,0,1,3.851-3.818h3.5a4,4,0,0,1,2.518.89l.343.278a4.841,4.841,0,0,0,6.088,0l.343-.278a4,4,0,0,1,2.518-.89h3.5a3.835,3.835,0,0,1,3.851,3.818v11.6a.511.511,0,0,0,.867.363,6.049,6.049,0,0,1,3.941-1.459V8.638A8.675,8.675,0,0,0,173.359,0Z" transform="translate(-126.89)"/><path class="m" d="M270.359,0h-8.366A8.675,8.675,0,0,1,270.7,8.5a3.831,3.831,0,0,1,3.562,3.806v11.6a.511.511,0,0,0,.867.363,6.049,6.049,0,0,1,3.94-1.459V8.638A8.675,8.675,0,0,0,270.359,0Z" transform="translate(-223.89)"/></svg>`;

export default class HomeMainScreen extends Component {
  static navigationOptions = {
    headerShown: false,
  };

  _didFocusSubscription;
  _willBlurSubscription;

  state = {
    recommendedPostIDs: [],
    LastViewedPostIDs: [],
    newAndTrendingOffers: [],
    activityIndicatorNewAndTrending: true,
    showDetail: false,
    detailPostResult: null,
    showSearchResults: false,

    assetsLoaded: false,
    lastLocationLoaded: false,
    currentLocationLoaded: false,
    globalsSet: false,
    listOfApps: [
      "Fashion",
      "Food",
      "Health",

      "Jobs",
      "Electronics",
      "Beauty",
      "Services",

      "News",
    ],
    versionMessage: null, // can be {text:..., type:...} or null
    listOfProviders: [],
    numberOfProvidersShowing: 6,
    showIndicator: true,
    discountLabel: "Flash Sales!!",
    discountData: [],
  };

  constructor() {
    super();

    this.unsubscribeFirestoreProfile = () => {
      return;
    };
    this.unsubscribeFirestoreToken = () => {
      return;
    };
    const firestore = firebase.firestore();

    initiateGlobalFunctions(this);

    global.setGlobals();
  }

  appDetails = {
    Fashion: {
      icon: global.icons.Fashion.image,
      image: null,
      route: "homeFashion",
      title: "Fashion",
      backgroundColor: "#935FF0",
    },
    Food: {
      icon: global.icons.Food.image,
      image: null,
      route: "homeFood",
      title: "Food",
      backgroundColor: "#C9BA49",
    },
    Electronics: {
      icon: global.icons.Electronics.image,
      image: null,
      route: "homeElectronics",
      title: "Electronics",
      backgroundColor: "#4DC5E2",
    },

    Services: {
      icon: global.icons.Services.image,
      image: null,
      route: "homeServices",
      title: "Services",
      backgroundColor: "#4160E0",
    },
    Beauty: {
      icon: global.icons.Beauty.image,
      image: null,
      route: "homeBeauty",
      title: "Beauty",
      backgroundColor: "#C43699",
    },
    Health: {
      icon: global.icons.Health.image,
      image: null,
      route: "homeHealth",
      title: "Health",
      backgroundColor: "#A81411",
    },
    Jobs: {
      icon: global.icons.QuickJobs.image,
      image: null,
      route: "homeJobs",
      title: "Jobs",
      backgroundColor: "#14A811",
    },
    InnovationKitchen: {
      icon: null,
      image: innovation,
      route: "homeInnovationKitchen",
      title: null,
      backgroundColor: "#A81411",
    },

    News: {
      icon: global.icons.News.image,
      image: null,
      route: "homeNews",
      title: "News",
      backgroundColor: "#1F6D84",
    },
  };

  async componentDidMount() {
    try {
      this.loadLocalIndex();
      this.loadFonts();
      global.reportOnboarding?.(40)

      const loa = await AsyncStorage.getItem("listOfApps");
      if (loa) {
        let listOfApps = JSON.parse(loa);
        if (Array.isArray(listOfApps)) this.setState({ listOfApps });
      }
      const pros = await AsyncStorage.getItem("homeListOfProviders");
      if (pros) {
        let listOfProviders = JSON.parse(pros);
        if (Array.isArray(listOfProviders))
          this.setState({ listOfProviders, showIndicator: false });
      }
      const dl = await AsyncStorage.getItem("homeDiscountLabel");
      if (dl) {
        let discountLabel = JSON.parse(dl);
        if (discountLabel) {
          global.salesString = discountLabel;
          this.setState({ discountLabel });
        }
      }
      const lodo = await AsyncStorage.getItem("ListOfdiscountedOffers");
      if (lodo) {
        let discountData = JSON.parse(lodo);
        if (discountData) this.setState({ discountData });
      }
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 4000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 60000);
        });
      if (!global.myUID || !global.myProfileID) return;

      const vDoc = await firebase
        .firestore()
        .collection("ServerClientReadOnly")
        .doc("appsVisible")
        .get();
      const v = vDoc.data();
      let apps = null;
      if (Platform.OS == "ios") apps = v.appsI;
      else apps = v.apps;
      if (v && apps && Array.isArray(apps)) {
        this.setState({ listOfApps: apps });
        //  this.setState({ listOfApps: ["InnovationKitchen",...apps] });  use this to temporarily show the IK app
        this.setLabels(v);

        await AsyncStorage.setItem("listOfApps", JSON.stringify(apps));
      }

      this.loadHome();
      this.loadNotifications();
      this.loadNewAndTrending();

      this.backHandler = BackHandler.addEventListener(
        "hardwareBackPress",
        this.handleBackPress
      );

      if (
        this.state.LastViewedPostIDs?.length == 0 &&
        global.lastViewedPostIDs?.length > 0
      ) {
        const LastViewedPostIDs = global.duplicate(global.lastViewedPostIDs);
        if (LastViewedPostIDs.length > 15) LastViewedPostIDs.length = 15;
        this.setState({ LastViewedPostIDs });
      }
      const recommendedPostIDs = await global.getRecommendationsAsync(12, {});
      if (Array.isArray(recommendedPostIDs) && recommendedPostIDs.length > 0)
        this.setState({ recommendedPostIDs });
    } catch (err) {
      global.warn?.(err, "HomeMount");
    }
  }

  componentWillUnmount() {
    this.unsubscribeFirestoreProfile();
    this.backHandler?.remove();
    console.log("Unmounting home");
  }

  loadNewAndTrending = async () => {
    try {
      if (!global.location)
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });

      if (!global.location)
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      const re = await Find.findPostOffersAsync({
        orderBy: "RECENT",
        location: global.location || {
          coords: { latitude: 6.6, longitude: 3.3 },
        },
        amount: 10,
      });
      // console.log("NEW_AND_TRENDING", re);
      if (re == -1)
        return this.setState({ activityIndicatorNewAndTrending: false });
      if (re.length == 0)
        return this.setState({ activityIndicatorNewAndTrending: false });
      if (re.length > 0)
        return this.setState({
          newAndTrendingOffers: re,
          activityIndicatorNewAndTrending: false,
        });
      // an error occurred. Set activityIndicatorNewAndTrending to false ...
      //No offers found. Set activityIndicatorNewAndTrending to false ...
    } catch (err) {
      global.warn?.(err, "loadNewAndTrending");
    }
  };

  loadHome = async () => {
    try {
      if (!global.location) {
        console.log("No global location. Loading location now.")
        await global.setLocationFast?.(960);
      }
      await global.fetchIdToken()
      const r3 = await fetch(global.cloudFunctionURL + "findHome", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ isWeb:true,
          isWeb: true,
          localCurrency: global.myLocalCurrency || "NGN",
          coords: global.location?.coords || { latitude: 6.6, longitude: 3.3 },
          type: "All",
          myUID: global.myUID,
          idToken: global.idToken,
        }),
      });
      const r4 = await r3.json();
      console.log("findHome response: " + r4.msg)
      if (
        r4.msg == "SUCCESS" &&
        Array.isArray(r4.providers) &&
        Array.isArray(r4.discountedOffers)
      ) {
        this.setState({
          listOfProviders: r4.providers,
          discountData: r4.discountedOffers,
          showIndicator: false,
        });
        AsyncStorage.setItem(
          "homeListOfProviders",
          JSON.stringify(r4.providers)
        );
        AsyncStorage.setItem(
          "ListOfdiscountedOffers",
          JSON.stringify(r4.discountedOffers)
        );
      }
    } catch (err) {
      global.warn?.(err, "loadHome");
    }
  };

  loadNotifications = async () => {
    await global.timeout(3000); // wait so that the updates can load before "New version available" shows
    try {
      let appVersion = "999.9.9";
      if (Constants.manifest && Constants.manifest.version) {
        appVersion = Constants.manifest.version;
      }
      const r = await fetch(global.cloudFunctionURL + "checkNotifications", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ isWeb:true,
          isWeb: true,
          deviceInfo: {
            deviceName: Constants.deviceName || "-",
            expoVersion: Constants.expoVersion || "-",
            deviceYearClass: Constants.deviceYearClass || "-",
            platform: Constants.platform || "-",
            appVersion,
          },
          myUID: global.myUID,
          idToken: global.idToken,
        }),
      });
      const r2 = await r.json();
      if (r2.msg == "SUCCESS") {
        this.setState({ versionMessage: r2.result });
      }
    } catch (err) {
      global.warn?.(err, "loadNotifications");
    }
  };

  setLabels = async (v) => {
    try {
      if (!global.myLocalCurrency)
        await new Promise((resolve) => {
          setTimeout(resolve, 200);
        });
      if (!global.myLocalCurrency)
        await new Promise((resolve) => {
          setTimeout(resolve, 200);
        });
      if (!global.myLocalCurrency)
        await new Promise((resolve) => {
          setTimeout(resolve, 300);
        });
      if (!global.myLocalCurrency)
        await new Promise((resolve) => {
          setTimeout(resolve, 400);
        });
      if (!global.myLocalCurrency)
        await new Promise((resolve) => {
          setTimeout(resolve, 600);
        });
      if (!global.myLocalCurrency)
        await new Promise((resolve) => {
          setTimeout(resolve, 2500);
        });
      let discountLabel;
      if (global.myLocalCurrency == "GHS" && v.labelDiscountGH)
        discountLabel = v.labelDiscountGH;
      else if (v.labelDiscount) discountLabel = v.labelDiscount;
      if (discountLabel) {
        this.setState({ discountLabel });
        global.salesString = discountLabel;
        await AsyncStorage.setItem(
          "homeDiscountLabel",
          JSON.stringify(discountLabel)
        );
      }

    } catch (err) {
      global.warn?.(err, "setLabels");
    }
  };

  loadFonts = async () => {
    try {
      await Font.loadAsync({
        "ProximaNovaA-Bold": require("../../assets/font/ProximaNovaA-Bold.ttf"),
        "ProximaNovaA-Regular": require("../../assets/font/ProximaNovaA-Regular.ttf"),
      });

      this.setState({ assetsLoaded: true });
    } catch (e) {
      global.warn?.(e, "fonts 657434");
    }
  };

  // function to occasionally update locally search results
  loadLocalIndex = async () => {
    await new Promise((resolve) => {
      setTimeout(resolve, 3000);
    });
    try {
      let localResultsString = null;
      const localResultsDateString = await AsyncStorage.getItem(
        "localResultsDateString"
      );
      const dat = new Date();
      if (localResultsDateString) {
        let localResultsDate = JSON.parse(localResultsDateString);
        localResultsDate = Date.parse(localResultsDate);
        // console.log("****************** received async date", localResultsDate);
        // console.log("****************** async date", dat - localResultsDate);
        if (dat - localResultsDate < 1814400000) {
          // console.log(
          //   "****************** async date not too old",
          //   dat - localResultsDate
          // );
          localResultsString = await AsyncStorage.getItem("localResultsString");
        }
      }
      if (localResultsString) {
        // console.log("****************** found localResultsString");
        global.localResultsList = JSON.parse(localResultsString);
      } else {
        if (!global.myUID || !global.idToken)
          await new Promise((resolve) => {
            setTimeout(resolve, 3000);
          });
        if (!global.myUID || !global.idToken)
          await new Promise((resolve) => {
            setTimeout(resolve, 3000);
          });
        if (!global.myUID || !global.idToken)
          await new Promise((resolve) => {
            setTimeout(resolve, 3000);
          });
        if (!global.myUID || !global.idToken)
          await new Promise((resolve) => {
            setTimeout(resolve, 9000);
          });
        if (!global.myUID || !global.idToken)
          await new Promise((resolve) => {
            setTimeout(resolve, 9000);
          });
        if (!global.myUID || !global.idToken) return;
        // console.log("****************** loading fresh localIndex");
        const r = await fetch(global.cloudFunctionURL + "getLocalIndex", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ isWeb:true,
            isWeb: true,
            myProfileID: global.myProfileID || null,
            myUID: global.myUID,
            idToken: global.idToken,
          }),
        });
        const r2 = await r.json();

        if (r2.msg == "SUCCESS") {
          // console.log("****************** loading fresh localIndex SUCCESS");
          global.localResultsList = r2.results;
          console.log(
            "ASYNC localResultsList has not existed, now creating. Successful function invocation."
          );
          await AsyncStorage.setItem(
            "localResultsString",
            JSON.stringify(r2.results)
          );
          await AsyncStorage.setItem(
            "localResultsDateString",
            JSON.stringify(dat)
          );
          // console.log("****************** asyncSaved fresh localIndex");
        }
      }
    } catch (error) {
      global.warn?.(error, "loadLocalIndex");
    }
  };

  handleBackPress = () => {
    //const a = this.props.navigation.dangerouslyGetParent()
    //console.log("NAVNAV", this.props.navigation)

    if (this.props.navigation.isFocused()) {
      if (this.state.showSearchResults)
        this.setState({ showSearchResults: false });
      else if (this.state.category2)
        this.setState({ category1: null, category2: null });
      else {
        Alert.alert(
          "Close app?",
          "",
          [
            {
              text: "No",
              onPress: () => console.log("Cancel Pressed"),
              style: "cancel",
            },
            {
              text: "Yes",
              onPress: () => {
                console.log("Yes Pressed");
                BackHandler.exitApp();
              },
            },
          ],
          { cancelable: true }
        );
      }
      return true;
    }
  };

  renderVersionMessage = () => {
    const message = this.state.versionMessage;
    return (
      <TouchableOpacity
        activeOpacity={
          message.type == "restartApp" ||
            message.type == "callRoute" ||
            message.type == "callURL"
            ? 0.2
            : 1
        }
        onPress={() => {
          //global.reportStats("pressed_Home_NewAndTrending");
          if (message.type == "restartApp")
            return (this.will.crash.app = reload.reset.intended);
          if (message.type == "callRoute")
            return this.props.navigation.navigate(message.route);
          if (message.type == "callURL")
            return Linking.openURL(message.url || "");
          if (message.type == "store")
            return alert(
              Platform.OS == "ios"
                ? "Update Wakanda through App Store"
                : "Update Wakanda Market on Google Play"
            );
        }}
        style={{
          borderColor: "#A8CF45",
          borderWidth: 1,
          height: 110,
          alignSelf: "stretch",
          margin: 15,
          alignItems: "center",
          justifyContent: "center",
          padding: 8,
          flexDirection: "row",
          overflow: "hidden",
        }}
      >
        <Image
          style={{
            width: 62.5,
            height: 50,
            margin: 10,
            //opacity: 0.75,

            //tintColor: "#fff"
          }}
          source={require("../images/logos/home_logo.png")}
        />
        <View style={{ flex: 1 }}>
          <Text style={{ color: "#FFF", fontSize: 12 }} numberOfLines={6}>
            {message.text}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  renderSearch = () => {
    return (
      <Search
        showResults={this.state.showSearchResults}
        //setCategories={(category1, category2) => { this.setState({ category1, category2 }) }}
        setShowResults={(showSearchResults) => {
          this.setState({ showSearchResults });
        }}
        // setAction={(action) => {
        //   this.setState({ action })
        //   if (action == "FIND") this.findProvider({ valNearYou: 0.5, valAffordable: 0.5, valQuality: 0.5, valProfessional: 0.5, requirements: "", coords: this.state.location.coords });
        // }}
        // refreshAction={() => {
        //   if (this.state.action == "BROWSE") this.browsePosts();
        //   if (this.state.action == "FIND") this.findProvider({ valNearYou: 0.5, valAffordable: 0.5, valQuality: 0.5, valProfessional: 0.5, requirements: "", coords: this.state.location.coords });
        // }}
        navigation={this.props.navigation}
      />
    );
  };

  renderMain = () => {
    // console.log("list of current app", this.state.listOfApps);
    if (this.state.assetsLoaded) {
      const providers = this.state.listOfProviders;

      return (
        <View>
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "F5F5F5",
              marginTop: 16,
              marginHorizontal: 18,
            }}
          >


            {/* <View
              style={{
                backgroundColor: "#17202A",
                height: 400,
                // width: SCREEN_HEIGHT - 480,
                width: "100%",
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
                margin: 22,
                alignSelf: "center",
                shadowColor: "#000",
                shadowOpacity: 0.05,
              }}
            >
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  // justifyContent: "space-between",
                  paddingHorizontal: 20,
                  marginHorizontal: 20,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <View>
                    <FontAwesome name="flash" size={20} color="red" />
                  </View>
                  <View
                    style={{
                      padding: 2,
                      margin: 2,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        // right: 100,
                        // bottom: 10,
                        fontSize: 15,
                        fontFamily: "ProximaNovaA-Bold",
                        color: "#FFFFFF",
                      }}
                    >
                      FLASH SALES !!!
                    </Text>
                  </View>
                </View>
                <TouchableOpacity
                  style={{
                    width: "100%",

                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Text
                    style={{
                      // right: 100,
                      // bottom: 10,
                      fontSize: 12,
                      fontFamily: "ProximaNovaA-Regular",
                      color: "#FFFFFF",
                    }}
                  >
                    see more....
                  </Text>
                </TouchableOpacity>
              </View>

              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                  alignItems: "center",
                  margin: 5,
                  padding: 5,
                }}
              >
                {this.DummyDiscount.slice(0, 4).map((item, id) => {
                  return (
                    <View
                      key={id}
                      style={{
                        backgroundColor: "#F5F5F5",
                        minHeight: 150,
                        width: "40%",
                        borderRadius: 12,
                        margin: 5,
                        marginBottom: 10,
                      }}
                    >
                      <View>
                        <View
                          style={{
                            backgroundColor: "red",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: 5,
                            width: "32%",
                            position: "absolute",
                            padding: 2,

                            zIndex: 1,
                          }}
                        >
                          <Text
                            style={{
                              color: "white",
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Bold",
                            }}
                          >
                            {item.percentageOff}
                          </Text>
                        </View>
                        <Image
                          style={{
                            width: "100%",
                            height: 110,
                            borderRadius: 12,
                          }}
                          source={{
                            uri: item.Image,
                          }}
                          resizeMode="cover"
                        />
                      </View>

                      <View
                        style={{
                          marginHorizontal: 10,
                          paddingTop: 3,
                          marginTop: 2,
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "ProximaNovaA-Bold",
                            fontSize: 10,
                          }}
                        >
                          {item.productName}
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",

                          width: "100%",
                          paddingVertical: 3,
                          marginVertical: 3,
                          justifyContent: "space-around",
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "ProximaNovaA-Bold",
                            fontSize: 12,
                          }}
                        >
                          {item.newPrice}
                        </Text>
                        <Text
                          style={{
                            fontFamily: "ProximaNovaA-Bold",
                            fontSize: 12,

                            textDecorationLine: "line-through",
                          }}
                        >
                          {item.oldPrice}
                        </Text>
                      </View>
                    </View>
                  );
                })}
              </View>
            </View> */}
            {/* <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeResults", {
                  type: "HOT_NEAR_ME"
                });
              }}
              style={{
                backgroundColor: "#42CBA6",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden"
              }}
            >
              <Text
                style={{
                  color: "#FFF",
                  fontSize: 18,
                  left: 30,

                  fontFamily: "ProximaNovaA-Bold"
                }}
              >
                Special offers
              </Text>
              <View>
                <Image
                  style={{
                    maxWidth: 220,
                    maxHeight: 220
                  }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/clip.png")}
                />
              </View>
            </TouchableOpacity> */}
            <View style={{
              flexDirection: "row", marginBottom: 8, marginTop: -12
            }}>

              <NewsTicker navigation={this.props.navigation} />

            </View>

            {/* <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeBlog", { blogID: "00babaOjaGeneralBlog", blogTitle: "Baba Oja" })
              }}
              style={{
                backgroundColor: "#42CBA6",
                height: 55,
                width: "100%",
                borderRadius: 6,
                borderWidth: 1, borderColor: "white",
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                marginBottom: 10,
                overflow: "hidden",
              }}
            >
              <CachedImage
                style={{ width: Dimensions.get("window").width, height: Dimensions.get("window").width / 2, margin: 5, resizeMode: "contain" }}
                source={{ uri: "https://firebasestorage.googleapis.com/v0/b/afbase-7ee60.appspot.com/o/SystemPictures%2FBO-TheShow.jpg?alt=media&token=de631dbf-fc74-47e3-a4bd-b5057bbad1e2" }}
              />
              <View style={{ marginTop: -135, marginBottom: 40, alignItems: "center" }}>
                {Platform.OS == "ios" ? <View
                  style={{
                    backgroundColor: "rgba(198,198,198,0.6)", borderRadius: 25, paddingBottom: 0,
                    height: 40, justifyContent: 'center', alignItems: 'center', width: 40, marginTop: Dimensions.get("window").height > 890 ? -28 : -10, marginBottom: 10,
                  }}>
                  <Text style={{ color: "#000", fontSize: 24, marginLeft: 2 }} >
                    {"▶"}
                  </Text>
                </View>
                  : <View
                    style={{
                      backgroundColor: "rgba(198,198,198,0.6)", borderRadius: 25, paddingBottom: 5, paddingLeft: 2,
                      height: 40, justifyContent: 'center', alignItems: 'center', width: 40, marginTop: -25, marginBottom: 15,
                    }}>
                    <Text style={{ color: "#000", fontSize: 26 }} >
                      {"▶"}
                    </Text>
                  </View>}
              </View>
            </TouchableOpacity> */}





            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {this.state.listOfApps.map((item) => {
                if (!this.appDetails[item]) return;
                return (
                  <TouchableOpacity
                    key={this.appDetails[item].route}
                    onPress={() => {
                      console.log("routepress", this.appDetails[item].route);
                      global.reportStats("pressed_Home_" + item);
                      this.props.navigation.navigate(
                        this.appDetails[item].route,

                        {}
                      );
                    }}
                    style={{
                      backgroundColor: this.appDetails[item].backgroundColor,
                      height: 110,
                      width: "48%",
                      borderRadius: 6,
                      alignItems: "center",
                      justifyContent: "center",
                      marginVertical: 10,
                      // marginHorizontal: 12,
                      // margingRight: 10
                    }}
                  >
                    {this.appDetails[item].icon === null ? (
                      <Image
                        style={{ width: 10, height: 10 }}
                        source={innovation}
                        resizeMode="contain"
                      />
                    ) : (
                      <View>
                        <SvgCss xml={this.appDetails[item].icon} />
                        <Text
                          style={{
                            color: "#FFF",
                            fontSize: 16,

                            fontFamily: "ProximaNovaA-Bold",
                            alignSelf: "center",
                            paddingTop: 7,
                          }}
                        >
                          {this.appDetails[item].title}
                        </Text>
                      </View>
                    )}
                    {/* {this.appDetails[item].title == "Health" && (
                      <View
                        style={{
                          height: 40,
                          width: 160,
                          marginTop: -130,
                          marginBottom: 90,
                          alignItems: "flex-end",
                        }}
                      >
                        <View
                          style={{
                            backgroundColor: "#C9BA49",
                            marginLeft: 8,
                            height: 32,
                            width: 32,
                            borderRadius: 16,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={{
                              color: "#000",
                              fontFamily: "ProximaNovaA-Bold",
                              fontSize: 10,
                            }}
                          >
                            NEW
                          </Text>
                        </View>
                      </View>
                    )} */}
                  </TouchableOpacity>
                );
              })}
            </View>
            {/* <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeCommunities");
              }}
              style={{
                height: 55,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                marginTop: 0,
                overflow: "hidden"
              }}
            >
              <View style={{}}>
                <Text
                  style={{
                    color: "#aaa",
                    fontSize: 18,
                    fontFamily: "ProximaNovaA-Bold"
                  }}
                >
                  Sell on Wakanda
              </Text>
              </View>
            </TouchableOpacity> */}

            <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Home_Communities");
                this.props.navigation.navigate("homeCommunities");
              }}
              style={{
                backgroundColor: "#42CBA6",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <Text
                style={{
                  color: "#FFF",
                  fontSize: 18,
                  right: 10,

                  fontFamily: "ProximaNovaA-Bold",
                }}
              >
                Communities
              </Text>
              <View style={{ top: 15, left: 30 }}>
                <Image
                  style={{
                    maxWidth: 160,
                    maxHeight: 160,
                  }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/community.png")}
                />
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Home_Sellers");
                this.props.navigation.navigate("homeSellers");
              }}
              style={{
                backgroundColor: "#a49",
                borderRadius: 6,
                height: 45,
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                marginTop: 10,
                marginHorizontal: 0,
                overflow: "hidden",
              }}
            >
              <View style={{}}>
                <Text
                  style={{
                    color: "#fff",
                    fontSize: 16,
                    fontFamily: "ProximaNovaA-Bold",
                    paddingLeft: 120,
                  }}
                >
                  Sell on Wakanda
                </Text>
                <View
                  style={{
                    position: "absolute",
                    left: -30,
                    opacity: 0.85,
                    height: 20,
                    marginTop: -10,
                  }}
                >
                  <SvgCss height="500%" xml={global.shopIcon} />
                </View>
              </View>
            </TouchableOpacity>


            <BlogPreview
              blogID={"00babaOjaGeneralBlog"}
              title={'Baba Oja'} />


            {!!this.state.discountData?.length > 0 && (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingHorizontal: 20,
                  marginHorizontal: 20,
                  marginTop: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <View>
                    <FontAwesome name="flash" size={20} color="red" />
                  </View>
                  <View
                    style={{
                      padding: 2,
                      margin: 2,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        // right: 100,
                        // bottom: 10,
                        fontSize: 15,
                        fontFamily: "ProximaNovaA-Bold",
                        color: "#FFFFFF",
                      }}
                    >
                      {this.state.discountLabel || "FLASH SALES !!!"}
                    </Text>
                  </View>
                </View>
                <TouchableOpacity
                  onPress={() => {
                    this.props.navigation.navigate("offerResults", {
                      params: {
                        offerCategories: this.state.discountData,
                        title: this.state.discountLabel || "FLASH SALES !!!",
                        screenColor: [
                          "#AF2ABA",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                        ],
                      },
                      // key: this.appDetails[item].title,
                    });
                  }}
                  style={{
                    width: "100%",

                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Text
                    style={{
                      // right: 100,
                      // bottom: 10,
                      fontSize: 12,
                      fontFamily: "ProximaNovaA-Regular",
                      color: "#FFFFFF",
                      paddingRight: 15,
                    }}
                  >
                    see more
                  </Text>
                </TouchableOpacity>
              </View>
            )}

            <View
              style={{
                flexDirection: "row",

                justifyContent: "space-around",
                alignItems: "center",
                margin: 5,
                padding: 5,
              }}
            >
              {this.state.discountData.slice(0, 3).map((item, id) => {
                let oldPrice = item.postPrice;
                let percentageOff = Math.round(
                  (item.postPriceDiscount / oldPrice) * 100
                ).toString();

                // new  discount price starts
                const result = item;
                let pString = Math.round(
                  result.postPrice - item.postPriceDiscount
                ).toString();
                if (pString.length > 8) {
                  pString = pString.slice(0, pString.length - 6) + "M";
                } else if (pString.length > 6) {
                  pString = Number(pString.slice(0, pString.length - 5)) / 10;
                  pString = pString.toString() + "M";
                } else if (pString.length > 4) {
                  pString = pString.slice(0, pString.length - 3) + "K";
                }
                // new  discount price ends

                // old  discount price starts

                let oldpString = Math.round(oldPrice).toString();
                if (oldpString.length > 8) {
                  oldpString = oldpString.slice(0, oldpString.length - 6) + "M";
                } else if (oldpString.length > 6) {
                  oldpString =
                    Number(oldpString.slice(0, oldpString.length - 5)) / 10;
                  oldpString = oldpString.toString() + "M";
                } else if (oldpString.length > 4) {
                  oldpString = oldpString.slice(0, oldpString.length - 3) + "K";
                }
                // old  discount price ends

                let pCurrency = result.postPriceCurrency || "NGN";
                let pCurrencyString = global.currencySymbols[pCurrency];

                let priceString = pCurrencyString + " " + pString;
                let oldpriceString = pCurrencyString + " " + oldpString;

                //localString is acnString
                let localString = "";
                let oldLocalString = "";

                // xx possibly remove NGN from last section of the following line  to show less
                // xx possibly replace last section of the following line with global.xRates[post.postPriceCurrency||"NGN"] to show ACN for all (also old) NGN posts
                if (
                  global.walletType == "ACN" &&
                  !(result.postPriceCurrency == "ACN") &&
                  result.postPriceType != "Free" &&
                  result.postPrice > 0 &&
                  global.xRates[result.postPriceCurrency || "NGN"]
                ) {
                  const lPrice = Math.round(
                    result.postPrice /
                    global.xRates[result.postPriceCurrency || "NGN"]
                  );
                  const oldlPrice = Math.round(
                    oldPrice / global.xRates[result.postPriceCurrency || "NGN"]
                  );
                  const lCurrency = global.currencySymbols["ACN"];
                  let lString = Math.round(lPrice).toLocaleString(0);
                  let oldlString = Math.round(oldlPrice).toLocaleString(0);
                  localString = "≈ " + lCurrency + " " + lString;
                  oldLocalString = "≈ " + lCurrency + " " + oldlString;
                }
                let beforeString = "";
                let afterString = "";
                if (
                  result.postPriceType &&
                  result.postPriceType != "Fixed Price"
                ) {
                  if (result.postPriceType == "Starting From") {
                    beforeString = "Starting From";
                  } else {
                    afterString = "(" + result.postPriceType + ")";
                  }
                  if (result.postPriceType == "Free") {
                    priceString = "FREE";
                    oldpriceString = "FREE";
                    localString = "";
                    afterString = "";
                  }
                  if (result.postPriceType == "NONE") {
                    priceString = "";
                    oldpriceString = "";
                    localString = "";
                    afterString = "";
                  }
                }

                return (
                  <TouchableOpacity
                    key={item.xID || 0 + id}
                    style={{
                      backgroundColor: "#F5F5F5",
                      minHeight: 180,
                      width: "30%",
                      borderRadius: 12,
                      margin: 5,
                      marginBottom: 10,
                    }}
                    onPress={() => {
                      this.setState({
                        showDetail: true,
                        detailPostResult: item,
                      });
                    }}
                  >
                    <View>
                      <View
                        style={{
                          backgroundColor: "red",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: 5,
                          width: "32%",
                          position: "absolute",
                          padding: 2,

                          zIndex: 1,
                        }}
                      >
                        <Text
                          style={{
                            color: "white",
                            fontSize: 12,
                            fontFamily: "ProximaNovaA-Bold",
                          }}
                        >
                          {percentageOff + "%"}
                        </Text>
                      </View>
                      <Image
                        style={{
                          width: "100%",
                          height: 110,
                          borderRadius: 12,
                        }}
                        source={{
                          uri: item.postPictureURL,
                        }}
                        resizeMode="cover"
                      />
                    </View>

                    <View
                      style={{
                        marginHorizontal: 10,
                        paddingTop: 3,
                        marginTop: 2,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "ProximaNovaA-Bold",
                          fontSize: 10,
                        }}
                      >
                        {item.postTitle}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",

                        width: "100%",
                        paddingVertical: 3,
                        marginVertical: 3,
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "ProximaNovaA-Bold",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {priceString}
                      </Text>
                      <Text
                        style={{
                          fontFamily: "ProximaNovaA-Bold",
                          fontSize: 12,

                          textDecorationLine: "line-through",
                        }}
                      >
                        {oldpriceString}
                      </Text>
                    </View>
                  </TouchableOpacity>
                );
              })}
            </View>


            <View
              style={{
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <View
                style={{
                  padding: 10,
                  margin: 10,
                  marginBottom: 3,
                  marginLeft: 3,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    // right: 100,
                    // bottom: 10,
                    fontSize: 15,
                    fontFamily: "ProximaNovaA-Bold",
                    color: "#FFFFFF",
                  }}
                >
                  Top Picks From Providers
                </Text>
              </View>
            </View>


            {this.state.showIndicator && (
              <ActivityIndicator size="large" color="#333333" />
            )}
            {providers !== [] && (
              <ScrollView
                horizontal={true}
                // contentContainerStyle={{ width: `${100 * intervals}%` }}
                showsHorizontalScrollIndicator={true}
                //ref={ref => (this.myScrollView = ref)}
                scrollEventThrottle={1000}
                onScroll={(e) => {
                  //images of hidden items should only be loaded when scrolling starts
                  if (
                    e.nativeEvent.contentOffset.x >= 700 &&
                    this.state.numberOfProvidersShowing < 999
                  ) {
                    this.setState({ numberOfProvidersShowing: 999 });
                  } else if (
                    e.nativeEvent.contentOffset.x >= 200 &&
                    this.state.numberOfProvidersShowing < 10
                  ) {
                    this.setState({ numberOfProvidersShowing: 10 });
                  }
                }}
              // decelerationRate="fast"
              // pagingEnabled
              >
                {providers.map((item, id) => {
                  // let offers = item["posts"];
                  // console.log("my offers are ", offers);

                  if (id < this.state.numberOfProvidersShowing)
                    return (
                      <TouchableOpacity
                        key={item.xID}
                        style={{
                          backgroundColor: "#D6DBDF",

                          minHeight: 246,
                          maxWidth: "40%",
                          borderRadius: 15,
                          margin: 3,
                        }}
                        onPress={() => {
                          this.props.navigation.navigate("homeProfile", {
                            profileID: item.xID,
                          });
                        }}
                      >
                        <View
                          style={{
                            borderRadius: 15,
                            width: "100%",
                            height: 150,
                            backgroundColor: "#F5F5F5",
                          }}
                        >
                          <Image
                            style={{
                              width: "100%",
                              height: 95,

                              borderRadius: 15,
                            }}
                            source={{
                              uri: item["profilePictureBackgroundURL"],
                            }}
                            resizeMode="cover"
                          />

                          <View
                            style={{
                              width: "100%",

                              borderRadius: 12,
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Image
                              style={{
                                width: 60,
                                height: 60,
                                alignItems: "center",
                                justifyContent: "center",
                                borderWidth: 2,
                                borderColor: "#F5F5F5",
                                borderRadius: 12,
                                bottom: 14,
                                left: 13,
                                padding: 2,
                              }}
                              source={{
                                uri: item["profilePictureURL"],
                              }}
                              resizeMode="cover"
                            />

                            <View style={{ maxWidth: "55%" }}>
                              <Text
                                style={{
                                  color: "#333333",
                                  fontSize: 10,
                                  fontFamily: "ProximaNovaA-Bold",
                                  padding: 5,
                                }}
                              >
                                {item["profileNameBusiness"]}
                              </Text>
                            </View>
                          </View>
                        </View>

                        {/*  <View
                        style={{
                          width: "100%",
                          // flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                    <Text
                          style={{
                            fontSize: 12,
                            fontFamily: "ProximaNovaA-Bold",
                            color: "#333333",
                            padding: 5,
                            margin: 5,
                          }}
                        >
                          offers
                        </Text> 

                        <TouchableOpacity
                          style={{ left: 42 }}
                          onPress={() => {
                            this.props.navigation.navigate("homeProfile", {
                              profileID: item.xID,
                            });
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Regular",
                              color: "#333333",
                              padding: 5,
                              margin: 5,
                            }}
                          >
                            See All
                          </Text>
                        </TouchableOpacity>
                      </View>
                      */}

                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-around",
                            width: "100%",
                            paddingVertical: 6,
                            marginVertical: 6,
                          }}
                        >
                          {item.posts &&
                            item.posts.slice(0, 2).map((post, id) => {
                              //post titiles
                              const titles = post["postTitle"];
                              let productTitle = "";
                              if (titles.length > 12) {
                                productTitle = titles.slice(0, 12) + "....";
                              } else if (titles.length <= 15) {
                                productTitle = titles;
                              }

                              // post prices
                              const result = post;
                              let pString = Math.round(
                                result.postPrice
                              ).toString();
                              if (pString.length > 8) {
                                pString =
                                  pString.slice(0, pString.length - 6) + "M";
                              } else if (pString.length > 6) {
                                pString =
                                  Number(pString.slice(0, pString.length - 5)) /
                                  10;
                                pString = pString.toString() + "M";
                              } else if (pString.length > 4) {
                                pString =
                                  pString.slice(0, pString.length - 3) + "K";
                              }

                              let pCurrency = result.postPriceCurrency || "NGN";
                              let pCurrencyString =
                                global.currencySymbols[pCurrency];

                              let priceString = pCurrencyString + " " + pString;

                              //localString is acnString
                              let localString = "";
                              // xx possibly remove NGN from last section of the following line  to show less
                              // xx possibly replace last section of the following line with global.xRates[post.postPriceCurrency||"NGN"] to show ACN for all (also old) NGN posts
                              if (
                                global.walletType == "ACN" &&
                                !(result.postPriceCurrency == "ACN") &&
                                result.postPriceType != "Free" &&
                                result.postPrice > 0 &&
                                global.xRates[result.postPriceCurrency || "NGN"]
                              ) {
                                const lPrice = Math.round(
                                  result.postPrice /
                                  global.xRates[
                                  result.postPriceCurrency || "NGN"
                                  ]
                                );
                                const lCurrency = global.currencySymbols["ACN"];
                                let lString = Math.round(lPrice).toLocaleString(
                                  0
                                );
                                localString = "≈ " + lCurrency + " " + lString;
                              }
                              let beforeString = "";
                              let afterString = "";
                              if (
                                result.postPriceType &&
                                result.postPriceType != "Fixed Price"
                              ) {
                                if (result.postPriceType == "Starting From") {
                                  beforeString = "Starting From";
                                } else {
                                  afterString =
                                    "(" + result.postPriceType + ")";
                                }
                                if (result.postPriceType == "Free") {
                                  priceString = "FREE";
                                  //oldpriceString = "FREE";
                                  localString = "";
                                  afterString = "";
                                }
                                if (result.postPriceType == "NONE") {
                                  priceString = "";
                                  //oldpriceString = "";
                                  localString = "";
                                  afterString = "";
                                }
                              }

                              return (
                                <View
                                  key={post.xID}
                                  style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                  }}
                                >
                                  <Image
                                    style={{
                                      width: 65,
                                      height: 80,
                                      borderRadius: 10,
                                      borderColor: "black",
                                      borderWidth: 0.02,
                                      shadowColor: "#000",
                                      shadowOpacity: 0.3,
                                    }}
                                    source={{
                                      uri: post["postPictureURL"],
                                    }}
                                    resizeMode="cover"
                                  />

                                  <View
                                    style={{
                                      maxWidth: "50%",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <View
                                      style={{
                                        minHeight: 30,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          fontFamily: "ProximaNovaA-Bold",
                                          color: "#333333",
                                          padding: 2,
                                          margin: 2,
                                        }}
                                      >
                                        {productTitle}
                                      </Text>
                                    </View>
                                    <View
                                      style={{
                                        paddingHorizontal: 4,
                                        marginHorizontal: 4,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          fontFamily: "ProximaNovaA-Bold",
                                          color: "#333333",
                                          marginBottom: 2,
                                          paddingBottom: 2,
                                        }}
                                      >
                                        {/* N {post["postPrice"]} */}
                                        {priceString}
                                      </Text>
                                    </View>
                                  </View>
                                </View>
                              );
                            })}

                          {/* <View
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        > 
                          <Image
                            style={{
                              width: 65,
                              height: 80,
                              borderRadius: 10,
                              borderColor: "black",
                              borderWidth: 0.02,
                              shadowColor: "#000",
                              shadowOpacity: 0.3,
                            }}
                            source={{
                              uri:
                                "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcT1XJgVgwTeZmlDYeyyPaxRhu8ajPzuEi1G5g&usqp=CAU",
                            }}
                            resizeMode="cover"
                          />

                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Bold",
                              color: "#333333",
                              padding: 2,
                              margin: 2,
                            }}
                          >
                            Essential oil
                          </Text>
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Regular",
                              color: "#333333",
                              marginBottom: 2,
                              paddingBottom: 2,
                            }}
                          >
                            N1000
                          </Text>
                        </View> */}
                        </View>
                      </TouchableOpacity>
                    );
                })}
              </ScrollView>
            )}

            {/* <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Home_NewAndTrending");
                this.props.navigation.navigate("homeResults", {
                  type: "NEW_AND_TRENDING",
                });
              }}
              style={{
                backgroundColor: "#F46E56",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <Text
                style={{
                  color: "#FFF",
                  fontSize: 18,
                  left: 35,
                  fontFamily: "ProximaNovaA-Bold",
                }}
              >
                New & Trending
              </Text>
              <View style={{ top: 17, left: 30 }}>
                <Image
                  style={{
                    maxWidth: 220,
                    maxHeight: 220,
                  }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/order-completed-5.png")}
                />
              </View>
            </TouchableOpacity> */}

            {!!this.state.newAndTrendingOffers && (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginTop: 30,
                }}
              >
                <View>
                  <Entypo name="new" size={24} color="red" />
                </View>
                <View
                  style={{
                    padding: 4,
                    margin: 2,
                    paddingVertical: 10,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      // right: 100,
                      // bottom: 10,
                      fontSize: 15,
                      fontFamily: "ProximaNovaA-Bold",
                      color: "#F46E56",
                    }}
                  >
                    New and Trending
                  </Text>
                </View>
                <TouchableOpacity
                  onPress={() => {
                    global.reportStats("pressed_Home_NewAndTrending");
                    this.props.navigation.navigate("homeResults", {
                      type: "NEW_AND_TRENDING",
                    });
                  }}
                  style={{
                    width: "100%",
                    paddingRight: 70,
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Text
                    style={{
                      // right: 100,
                      // bottom: 10,
                      fontSize: 12,
                      fontFamily: "ProximaNovaA-Regular",
                      color: "#FFFFFF",
                      paddingRight: 15,
                    }}
                  >
                    see more
                  </Text>
                </TouchableOpacity>
              </View>
            )}

            <ScrollView
              // contentContainerStyle={{ elevation: 1 }}
              horizontal={true}
              // contentContainerStyle={{ width: `${100 * intervals}%` }}
              showsHorizontalScrollIndicator={true}
              //ref={ref => (this.myScrollView = ref)}
              scrollEventThrottle={1000}
            >
              {this.state.newAndTrendingOffers &&
                this.state.newAndTrendingOffers.map((item, index) => {
                  let milliseconds = 0;
                  let timeCreated = 0;

                  milliseconds = item.timeCreated._seconds
                    ? item.timeCreated._seconds * 1000 +
                    item.timeCreated._nanoseconds / 1000000
                    : item.timeCreated.seconds * 1000 +
                    item.timeCreated.nanoseconds / 1000000;
                  timeCreated = new Date(milliseconds);
                  const result = item;
                  let pString = Math.round(result.postPrice).toString();
                  if (pString.length > 8) {
                    pString = pString.slice(0, pString.length - 6) + "M";
                  } else if (pString.length > 6) {
                    pString = Number(pString.slice(0, pString.length - 5)) / 10;
                    pString = pString.toString() + "M";
                  } else if (pString.length > 4) {
                    pString = pString.slice(0, pString.length - 3) + "K";
                  }

                  let pCurrency = result.postPriceCurrency || "NGN";
                  let pCurrencyString = global.currencySymbols[pCurrency];

                  let priceString = pCurrencyString + " " + pString;

                  //localString is acnString
                  let localString = "";
                  // xx possibly remove NGN from last section of the following line  to show less
                  // xx possibly replace last section of the following line with global.xRates[post.postPriceCurrency||"NGN"] to show ACN for all (also old) NGN posts
                  if (
                    global.walletType == "ACN" &&
                    !(result.postPriceCurrency == "ACN") &&
                    result.postPriceType != "Free" &&
                    result.postPrice > 0 &&
                    global.xRates[result.postPriceCurrency || "NGN"]
                  ) {
                    const lPrice = Math.round(
                      result.postPrice /
                      global.xRates[result.postPriceCurrency || "NGN"]
                    );
                    const lCurrency = global.currencySymbols["ACN"];
                    let lString = Math.round(lPrice).toLocaleString(0);
                    localString = "≈ " + lCurrency + " " + lString;
                  }
                  let beforeString = "";
                  let afterString = "";
                  if (
                    result.postPriceType &&
                    result.postPriceType != "Fixed Price"
                  ) {
                    if (result.postPriceType == "Starting From") {
                      beforeString = "Starting From";
                    } else {
                      afterString = "(" + result.postPriceType + ")";
                    }
                    if (result.postPriceType == "Free") {
                      priceString = "FREE";
                      //oldpriceString = "FREE";
                      localString = "";
                      afterString = "";
                    }
                    if (result.postPriceType == "NONE") {
                      priceString = "";
                      //oldpriceString = "";
                      localString = "";
                      afterString = "";
                    }
                  }

                  return (
                    <TouchableOpacity
                      key={item.xID}
                      onPress={() => {
                        this.setState({
                          showDetail: true,
                          detailPostResult: item,
                        });
                      }}
                      style={{
                        // pading: 5,
                        marginHorizontal: 7,
                        marginBottom: 10,
                        marginTop: 3,
                        borderRadius: 15,
                        maxWidth: "35%",
                        maxWidth:
                          Dimensions.get("window").width < 388 ? "42%" : "35%",
                        maxHeight:
                          Dimensions.get("window").height < 688
                            ? Dimensions.get("window").height * 0.33
                            : Dimensions.get("window").height * 0.25,
                        backgroundColor: "#F5F5F5",
                        marginBottom: 20,
                      }}
                    >
                      <Image
                        style={{
                          width: "100%",
                          height: 120,
                          borderRadius: 12,
                          marginBottom: 10,
                          shadowColor: "#000",
                          shadowOpacity: 0.5,
                        }}
                        source={{
                          uri: item.postPictureURL,
                        }}
                        resizeMode="cover"
                      />

                      <View
                        style={{
                          alignItems: "flex-end",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 10,
                            color: "#707070",
                            fontFamily: "ProximaNovaA-Regular",
                          }}
                        >
                          <Moment fromNow element={Text}>
                            {timeCreated.getTime()}
                          </Moment>
                        </Text>
                      </View>

                      <View
                        style={{
                          minWidth: "100%",
                          minHeight: "35%",
                          borderBottomRightRadius: 12,
                          borderBottomLeftRadius: 12,
                          backgroundColor: "#F46E56",
                          paddingHorizontal: 10,
                          paddingBottom: 10,
                          zIndex: 1,
                        }}
                      >
                        <View style={{ paddingTop: 5, maxHeight: "50%" }}>
                          <Text
                            style={{
                              color: "#FFFFFF",
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Bold",
                            }}
                          >
                            {item.postTitle}
                          </Text>
                        </View>
                        <View
                          style={{
                            maxHeight: "50%",
                          }}
                        >
                          <View
                            style={{
                              backgroundColor: priceString === "" ? "" : "red",
                              padding: 7,
                              maxHeight: 25,
                              borderRadius: 12,
                              maxWidth: "50%",
                              marginTop: 5,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: "ProximaNovaA-Bold",
                                color: "#FFFFFF",
                              }}
                            >
                              {priceString}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </TouchableOpacity>
                  );
                })}
            </ScrollView>

            {/* <View style={{ flexDirection: "row" }}>
              <TouchableOpacity
                onPress={() => {
                  this.props.navigation.navigate("homeElectronics", {});
                }}
                style={{
                  backgroundColor: "#4DC5E2",
                  height: 150,
                  width: "40%",
                  borderRadius: 6,
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 15
                }}
              >
                <SvgCss xml={electronics} />

                <Text
                  style={{
                    color: "#FFF",
                    fontSize: 12,
                    top: 23,

                    fontFamily: "ProximaNovaA-Bold"
                  }}
                >
                  Electronics
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  this.props.navigation.navigate("homeFashion", {});
                }}
                style={{
                  backgroundColor: "#4160E0",
                  height: 150,
                  width: "40%",
                  borderRadius: 6,
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 15
                }}
              >
                <SvgCss xml={services} />

                <Text
                  style={{
                    color: "#FFF",
                    fontSize: 12,
                    top: 23,
                    fontFamily: "ProximaNovaA-Bold"
                  }}
                >
                  Services
                </Text>
              </TouchableOpacity>
            </View> */}
            {/* <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeResults", {
                  type: "HOT_NEAR_ME"
                });
              }}
              style={{
                backgroundColor: "#935FF0",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden"
              }}
            >
              <Text
                style={{
                  color: "#FFF",
                  fontSize: 18,
                  left: 30,

                  fontFamily: "ProximaNovaA-Bold"
                }}
              >
                Special offers
              </Text>
              <View style={{ bottom: 15, left: 70 }}>
                <Image
                  style={{
                    maxWidth: 230,
                    maxHeight: 230
                  }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/alloffers.png")}
                />
              </View>
            </TouchableOpacity> */}
            {/* <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeResults", {
                  type: "HOT_NEAR_ME"
                });
              }}
              style={{
                backgroundColor: "#4DC5E2",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden"
              }}
              >
              <Text
              style={{
                color: "#FFF",
                fontSize: 18,
                left: 30,
                
                fontFamily: "ProximaNovaA-Bold"
              }}
              >
              Websites
              </Text>
              <View>
              <Image
              style={{
                maxWidth: 220,
                maxHeight: 220
              }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/cliplistisempty.png")}
                />
              </View>
            </TouchableOpacity> */}
            {this.state.recommendedPostIDs.length < 2 ? null : (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingHorizontal: 5,
                  marginHorizontal: 5,
                  marginTop: 30,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <View>
                    <Entypo name="new" size={24} color="#6Ec456" />
                  </View>
                  <View
                    style={{
                      padding: 2,
                      margin: 2,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        // right: 100,
                        // bottom: 10,
                        fontSize: 15,
                        fontFamily: "ProximaNovaA-Bold",
                        color: "#FFFFFF",
                      }}
                    >
                      Recommended
                    </Text>
                  </View>
                </View>
                <TouchableOpacity
                  onPress={() => {
                    this.props.navigation.navigate("offerResults", {
                      params: {
                        offerCategories: this.state.recommendedPostIDs,
                        title: "RECOMMENDED OFFERS!!",
                        screenColor: [
                          "#6Ec456",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                          "#F5F5F5",
                        ],
                      },
                      // key: this.appDetails[item].title,
                    });
                  }}
                  style={{
                    width: "100%",
                    paddingRight: 70,
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Text
                    style={{
                      // right: 100,
                      // bottom: 10,
                      fontSize: 12,
                      fontFamily: "ProximaNovaA-Regular",
                      color: "#FFFFFF",
                      paddingRight: 15,
                    }}
                  >
                    see more
                  </Text>
                </TouchableOpacity>
              </View>
            )}
            {this.state.recommendedPostIDs.length < 2 ? null : (
              <ScrollView
                horizontal={true}
                contentContainerStyle={{
                  width:
                    this.state.recommendedPostIDs.length < 3 ? "100%" : null,
                }}
                showsHorizontalScrollIndicator={true}
                //ref={ref => (this.myScrollView = ref)}
                scrollEventThrottle={1000}
              >
                {this.state.recommendedPostIDs.map((item, i) => {
                  return (
                    <RecommendedOffer
                      key={item}
                      postID={item}
                      colors={["#F5F5F5", "#F5F5F5", "#6Ec456"]}
                      navigation={this.props.navigation}
                    />
                  );
                })}
                <View style={{ width: 100 }} />
              </ScrollView>
            )}

            {this.state.LastViewedPostIDs?.length > 1 && (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  paddingHorizontal: 5,
                  marginHorizontal: 5,
                  marginTop: 15,
                }}
              >
                <View>
                  <Entypo name="new" size={24} color="red" />
                </View>
                <View
                  style={{
                    padding: 4,
                    margin: 2,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      // right: 100,
                      // bottom: 10,
                      fontSize: 15,
                      fontFamily: "ProximaNovaA-Bold",
                      color: "#C9BA49",
                    }}
                  >
                    Last Viewed
                  </Text>
                </View>
              </View>
            )}

            {this.state.LastViewedPostIDs?.length > 1 && (
              <ScrollView
                horizontal={true}
                contentContainerStyle={{
                  width:
                    this.state.LastViewedPostIDs.length < 3 ? "100%" : null,
                }}
                showsHorizontalScrollIndicator={true}
                //ref={ref => (this.myScrollView = ref)}
                scrollEventThrottle={1000}
              >
                {this.state.LastViewedPostIDs.map((item, index) => {
                  return (
                    <RecommendedOffer
                      key={item}
                      postID={item}
                      colors={["#F5F5F5", "#F5F5F5", "#F46E56"]}
                      navigation={this.props.navigation}
                    />
                  );
                })}
                <View style={{ width: 100 }} />
              </ScrollView>
            )}

            <BlogPreview
              blogID={"x1NX4bZOBP3XgvkfhFAD"}
              title={'Wakanda Spark'} />

            <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Home_HotRightNow");
                this.props.navigation.navigate("homeResults", {
                  type: "HOT_NEAR_ME",
                });
              }}
              style={{
                backgroundColor: "#935FF0",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                marginTop: 30,
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <Text
                style={{
                  color: "#FFF",
                  fontSize: 18,
                  left: 30,
                  fontFamily: "ProximaNovaA-Bold",
                }}
              >
                Hot right now
              </Text>
              <View style={{ top: 15, left: 51 }}>
                <Image
                  style={{
                    maxWidth: 220,
                    maxHeight: 220,
                  }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/clip-1.png")}
                />
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Home_HottestEver");
                this.props.navigation.navigate("homeResults", {
                  type: "HOTTEST_EVER",
                });
              }}
              style={{
                backgroundColor: "#F05F93",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <Text
                style={{
                  color: "#FFF",
                  fontSize: 18,
                  left: 30,
                  fontFamily: "ProximaNovaA-Bold",
                }}
              >
                Hottest ever
              </Text>
              <View style={{ top: 15, left: 51 }}>
                <Image
                  style={{
                    maxWidth: 220,
                    maxHeight: 220,
                  }}
                  source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/clip-1.png")}
                />
              </View>
            </TouchableOpacity>
            {global.myFollowingIDs?.length > 2 && (
              <TouchableOpacity
                onPress={() => {
                  global.reportStats("pressed_Home_FromMyContacts");
                  this.props.navigation.navigate("homeResults", {
                    type: "MY_CONTACTS",
                  });
                }}
                style={{
                  backgroundColor: "#6Ec456",
                  height: 110,
                  width: "100%",
                  borderRadius: 6,
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 15,
                  flexDirection: "row",
                  overflow: "hidden",
                }}
              >
                <Text
                  style={{
                    color: "#FFF",
                    fontSize: 18,
                    left: 35,
                    fontFamily: "ProximaNovaA-Bold",
                  }}
                >
                  From My Contacts
                </Text>
                <View style={{ top: 17, left: 30 }}>
                  <Image
                    style={{
                      maxWidth: 220,
                      maxHeight: 220,
                    }}
                    source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/order-completed-5.png")}
                  />
                </View>
              </TouchableOpacity>
            )}
            <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Home_HotNot");
                this.props.navigation.navigate("homeHotNot");
                // this.props.navigation.navigate("homeResults", {
                //   type: "HOTTEST_EVER",
                // });
              }}
              style={{
                backgroundColor: "#a94",
                borderRadius: 6,
                height: 110,
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                marginHorizontal: 0,
                overflow: "hidden",
              }}
            >
              <View style={{}}>
                <Text
                  style={{
                    color: "#fff",
                    fontSize: 18,
                    fontFamily: "ProximaNovaA-Bold",
                    paddingLeft: 120,
                  }}
                >
                  Hot or Not
                </Text>
                <View
                  style={{
                    position: "absolute",
                    left: 200,
                    opacity: 0.85,
                    height: 130,
                    marginTop: 0,
                  }}
                >
                  <Image
                    style={{
                      maxWidth: 180,
                      maxHeight: 140,
                    }}
                    source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/clip-1.png")}
                  />
                  {/* <View
                  style={{
                    position: "absolute",
                    left: -50,
                    opacity: 0.85,
                    height: 20,
                    marginTop: -10,
                  }}
                >
                  <Image
                    style={{
                      maxWidth: 120,
                      maxHeight: 50,
                    }}
                    source={require("../images/homePageIcons/imagesforwakandamarketrevamphometiles/clip-1.png")}
                  /> */}
                </View>
                <View
                  style={{
                    position: "absolute",
                    left: -50,
                    opacity: 0.85,
                    height: 50,
                    marginTop: -5,
                  }}
                >
                  <Text style={{ fontSize: 32 }}>👍 👎</Text>
                </View>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                global.reportStats("pressed_Around_Me");
                this.props.navigation.navigate("homeAround");
              }}
              style={{
                backgroundColor: "#fff",
                height: 110,
                width: "100%",
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                margin: 15,
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <Image
                style={{
                  height: 110,
                  width: "100%",
                  borderRadius: 6,
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "row",
                  overflow: "hidden",
                  marginLeft: -20,
                }}
                source={require("../images/homePageIcons/AroundMe.png")}
              />
              <Text
                style={{
                  color: "#000",
                  fontSize: 18,
                  right: 10,
                  marginTop: 0,
                  marginLeft: -160,
                  fontFamily: "ProximaNovaA-Bold",
                }}
              >
                Around Me <Text style={{ color: "#ccc" }}> .</Text>
              </Text>
              <View style={{ top: 17, left: 30 }}></View>
            </TouchableOpacity>

            {this.state.showDetail && (
              <Post
                postID={this.state.detailPostResult.xID}
                data={this.state.detailPostResult}
                //data={this.props.data}
                key={this.state.detailPostResult.xID + this.state.showDetail}
                navigation={this.props.navigation}
                showDetail={this.state.showDetail}
                onHideDetail={() => {
                  this.setState({ showDetail: false });
                }}
                relevantStatus={"LIVE"}
                blackBackground={true}
                onIsNotRelevant={() => {
                  alert("Offer not available at the moment");
                }}
              />
            )}
          </View>
        </View>
      );
    } else {
      return (
        <View
          style={{
            height: "100%",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ActivityIndicator />
        </View>
      );
    }
  };

  renderYoutube = () => {
    const sHeight = Dimensions.get("window").height;
    const sWidth = Dimensions.get("window").width;
    const fHeight = Math.max(sHeight - 125, sWidth - 20 + 250);
    return (<View
      style={{
        alignItems: "center",
        justifyContent: "flex-end",
        height: "100%",
        backgroundColor: "#000"
      }}
    >
      <WebView
        originWhitelist={['*']}
        style={{ width: sWidth, height: sHeight, marginVertical: ((sHeight - sWidth * 0.7) / 2) }}
        source={{ uri: 'https://www.youtube.com/embed/gpfRm2SnWzU' }}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        useWebKit={true}
      />
      <TouchableOpacity
        style={{
          position: "absolute",
          borderWidth: 0,
          backgroundColor: "#000",
          borderColor: "rgba(0,0,0,0.2)",
          alignItems: "center",
          justifyContent: "center",
          width: 35,
          top: sHeight - fHeight - 15,
          left: 5,
          height: 25,
          borderRadius: 35
        }}
        onPress={() => {
          this.setState({ watchingYoutube: false });
        }}
      >
        <Image
          style={{ width: 35, height: 35, opacity: 1 }}
          source={require("../images/icons/CancelWhite.png")}
        />
      </TouchableOpacity>
    </View>)
  }

  render() {
    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: "#000" }}>
        <StatusBar barStyle="light-content" translucent={true} />
        <View style={{ backgroundColor: "#000", marginTop: 28 }}>
          {!this.state.watchingYoutube ? <ScrollView>
            {!!this.state.versionMessage && this.renderVersionMessage()}
            {this.renderSearch()}

            {!this.state.showSearchResults && this.renderMain()}
          </ScrollView>
            : this.renderYoutube()}

          <LocationPopup
            msDelay={2500}
            //showAlwaysOnce={true}
            onNewLocation={async () => {
              this.loadHome()
              this.loadNewAndTrending();
            }} />

          <NavigationEvents
            onDidFocus={async (payload) => {
              const justSignedIn = this.props.navigation.getParam("justSignedIn", null);
              if (justSignedIn && !this.reloadedAfterSignin) {
                this.loadHome();
                this.loadNewAndTrending();
                console.log("RELOADING AFTER SIGNIN")
                this.reloadedAfterSignin = true
              }

              // console.log("Home Screen focused")
              const nowDate = new Date();
              const oneHourAgoDate = new Date(nowDate.getTime() - 60000 * 60);
              if (
                !this.timeLastRefreshedNewAndTrending ||
                this.timeLastRefreshedNewAndTrending < oneHourAgoDate
              ) {
                // console.log("Refreshing New and Trending")
                this.timeLastRefreshedNewAndTrending = nowDate;
                this.loadNewAndTrending();
                this.loadHome(); //added
                this.loadNotifications(); //added
              }
              if (global.lastViewedPostIDs?.length > 0) {
                //console.log("Analyzing lastViewedPostIDs", global.lastViewedPostIDs)
                const lastViewedPostIDs = global.duplicate(
                  global.lastViewedPostIDs
                );
                if (lastViewedPostIDs.length > 15)
                  lastViewedPostIDs.length = 15;
                this.setState({ LastViewedPostIDs: lastViewedPostIDs });
              }
              try {
                const recommendationPostIDs = await global.getRecommendationsAsync(
                  12,
                  { rotateFast: true }
                );
                // console.log("Analyzing recommendationPostIDs", recommendationPostIDs)
                if (
                  Array.isArray(recommendationPostIDs) &&
                  recommendationPostIDs.length > 0
                )
                  this.setState({ recommendedPostIDs: recommendationPostIDs });
              } catch (err) {
                global.warn?.(err, "NavEventsHome");
              }
            }}
          />
        </View>
      </SafeAreaView>
    );
  }
}
